/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain (auto-generated; do not edit)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ADMIN_API_BASE_URL = new InjectionToken<string>('ADMIN_API_BASE_URL');

@Injectable()
export class AdminGeneratedService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activationPartnersAll(body: FilterRequest | undefined): Observable<ActivationPartnerInfoDTO[]> {
        let url_ = this.baseUrl + "/v1/Activation/ActivationPartners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivationPartnersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivationPartnersAll(<any>response_);
                } catch (e) {
                    return <Observable<ActivationPartnerInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationPartnerInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processActivationPartnersAll(response: HttpResponseBase): Observable<ActivationPartnerInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivationPartnerInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationPartnerInfoDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    activationPartners(api_version: string | undefined, body: FilterRequest | undefined): Observable<ActivationPartnerInfoDTO[]> {
        let url_ = this.baseUrl + "/Activation/ActivationPartners?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivationPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivationPartners(<any>response_);
                } catch (e) {
                    return <Observable<ActivationPartnerInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationPartnerInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processActivationPartners(response: HttpResponseBase): Observable<ActivationPartnerInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivationPartnerInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationPartnerInfoDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activationCustomersAll(body: ActivationCustomersReq | undefined): Observable<ActivationCustomerInfoDTO[]> {
        let url_ = this.baseUrl + "/v1/Activation/ActivationCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivationCustomersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivationCustomersAll(<any>response_);
                } catch (e) {
                    return <Observable<ActivationCustomerInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationCustomerInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processActivationCustomersAll(response: HttpResponseBase): Observable<ActivationCustomerInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivationCustomerInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationCustomerInfoDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    activationCustomers(api_version: string | undefined, body: ActivationCustomersReq | undefined): Observable<ActivationCustomerInfoDTO[]> {
        let url_ = this.baseUrl + "/Activation/ActivationCustomers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivationCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivationCustomers(<any>response_);
                } catch (e) {
                    return <Observable<ActivationCustomerInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationCustomerInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processActivationCustomers(response: HttpResponseBase): Observable<ActivationCustomerInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivationCustomerInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationCustomerInfoDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    servicesAll(body: ServicesReq | undefined): Observable<ServiceDTO[]> {
        let url_ = this.baseUrl + "/v1/Activation/Services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServicesAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServicesAll(<any>response_);
                } catch (e) {
                    return <Observable<ServiceDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processServicesAll(response: HttpResponseBase): Observable<ServiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    services(api_version: string | undefined, body: ServicesReq | undefined): Observable<ServiceDTO[]> {
        let url_ = this.baseUrl + "/Activation/Services?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServices(<any>response_);
                } catch (e) {
                    return <Observable<ServiceDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processServices(response: HttpResponseBase): Observable<ServiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    avaiableRouteTenantsAll(body: AvaiableRouteTenantsReq | undefined): Observable<RouteTenantDTO[]> {
        let url_ = this.baseUrl + "/v1/Activation/AvaiableRouteTenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvaiableRouteTenantsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvaiableRouteTenantsAll(<any>response_);
                } catch (e) {
                    return <Observable<RouteTenantDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RouteTenantDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvaiableRouteTenantsAll(response: HttpResponseBase): Observable<RouteTenantDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RouteTenantDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RouteTenantDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    avaiableRouteTenants(api_version: string | undefined, body: AvaiableRouteTenantsReq | undefined): Observable<RouteTenantDTO[]> {
        let url_ = this.baseUrl + "/Activation/AvaiableRouteTenants?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvaiableRouteTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvaiableRouteTenants(<any>response_);
                } catch (e) {
                    return <Observable<RouteTenantDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RouteTenantDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvaiableRouteTenants(response: HttpResponseBase): Observable<RouteTenantDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RouteTenantDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RouteTenantDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activations(body: ActivationsReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/v1/Activation/Activations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivations(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processActivations(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    activations2(api_version: string | undefined, body: ActivationsReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/Activation/Activations?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivations2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivations2(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processActivations2(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createActivation(body: CreateActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/v1/Activation/CreateActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivation(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCreateActivation(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createActivation2(api_version: string | undefined, body: CreateActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/Activation/CreateActivation?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivation2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivation2(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCreateActivation2(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startOverCreateActivation(body: StartOverCreateActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/v1/Activation/StartOverCreateActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOverCreateActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOverCreateActivation(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processStartOverCreateActivation(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    startOverCreateActivation2(api_version: string | undefined, body: StartOverCreateActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/Activation/StartOverCreateActivation?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOverCreateActivation2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOverCreateActivation2(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processStartOverCreateActivation2(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLiveNow(body: StartOverCreateActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/v1/Activation/GetLiveNow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiveNow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiveNow(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetLiveNow(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    getLiveNow2(api_version: string | undefined, body: StartOverCreateActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/Activation/GetLiveNow?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLiveNow2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLiveNow2(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetLiveNow2(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setSignedNow(body: SetSignedNowRequest | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/v1/Activation/SetSignedNow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSignedNow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSignedNow(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processSetSignedNow(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    setSignedNow2(api_version: string | undefined, body: SetSignedNowRequest | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/Activation/SetSignedNow?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSignedNow2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSignedNow2(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processSetSignedNow2(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTestAccount(body: CreateTestAccountReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/v1/Activation/CreateTestAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTestAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTestAccount(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTestAccount(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    createTestAccount2(api_version: string | undefined, body: CreateTestAccountReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/Activation/CreateTestAccount?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTestAccount2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTestAccount2(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTestAccount2(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelActivation(body: CancelActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/v1/Activation/CancelActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelActivation(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCancelActivation(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    cancelActivation2(api_version: string | undefined, body: CancelActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/Activation/CancelActivation?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelActivation2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelActivation2(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCancelActivation2(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    envelopeQuery(body: EnvelopeQueryReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Activation/EnvelopeQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnvelopeQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnvelopeQuery(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processEnvelopeQuery(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    envelopeQuery2(api_version: string | undefined, body: EnvelopeQueryReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Activation/EnvelopeQuery?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnvelopeQuery2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnvelopeQuery2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processEnvelopeQuery2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    startOverCancelActivation(body: StartOverCancelActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/v1/Activation/StartOverCancelActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOverCancelActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOverCancelActivation(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processStartOverCancelActivation(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    startOverCancelActivation2(api_version: string | undefined, body: StartOverCancelActivationReq | undefined): Observable<ActivationsRes> {
        let url_ = this.baseUrl + "/Activation/StartOverCancelActivation?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOverCancelActivation2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOverCancelActivation2(<any>response_);
                } catch (e) {
                    return <Observable<ActivationsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ActivationsRes>><any>_observableThrow(response_);
        }));
    }

    protected processStartOverCancelActivation2(response: HttpResponseBase): Observable<ActivationsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivationsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ActivationsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivationsRes>(<any>null);
    }

    /**
     * @return Success
     */
    about(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Activation/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about2(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Activation/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout2(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    avaiablePartnerAgreementsAll(body: AvaiablePartnerAgreementsReq | undefined): Observable<AvailablePartnerAgreementsDetailDTO[]> {
        let url_ = this.baseUrl + "/v1/Agreements/AvaiablePartnerAgreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvaiablePartnerAgreementsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvaiablePartnerAgreementsAll(<any>response_);
                } catch (e) {
                    return <Observable<AvailablePartnerAgreementsDetailDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailablePartnerAgreementsDetailDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvaiablePartnerAgreementsAll(response: HttpResponseBase): Observable<AvailablePartnerAgreementsDetailDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailablePartnerAgreementsDetailDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailablePartnerAgreementsDetailDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    avaiablePartnerAgreements(api_version: string | undefined, body: AvaiablePartnerAgreementsReq | undefined): Observable<AvailablePartnerAgreementsDetailDTO[]> {
        let url_ = this.baseUrl + "/Agreements/AvaiablePartnerAgreements?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvaiablePartnerAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvaiablePartnerAgreements(<any>response_);
                } catch (e) {
                    return <Observable<AvailablePartnerAgreementsDetailDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailablePartnerAgreementsDetailDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvaiablePartnerAgreements(response: HttpResponseBase): Observable<AvailablePartnerAgreementsDetailDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailablePartnerAgreementsDetailDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AvailablePartnerAgreementsDetailDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerAndCustomersAll(body: PartnerAndCustomersReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/v1/Agreements/PartnerAndCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAndCustomersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAndCustomersAll(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAndCustomersAll(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerAndCustomers(api_version: string | undefined, body: PartnerAndCustomersReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/Agreements/PartnerAndCustomers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAndCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAndCustomers(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAndCustomers(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    services2(body: ServicesReq | undefined): Observable<ServiceDTO[]> {
        let url_ = this.baseUrl + "/v1/Agreements/Services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServices2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServices2(<any>response_);
                } catch (e) {
                    return <Observable<ServiceDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processServices2(response: HttpResponseBase): Observable<ServiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    services3(api_version: string | undefined, body: ServicesReq | undefined): Observable<ServiceDTO[]> {
        let url_ = this.baseUrl + "/Agreements/Services?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServices3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServices3(<any>response_);
                } catch (e) {
                    return <Observable<ServiceDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processServices3(response: HttpResponseBase): Observable<ServiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerAgreements(body: PartnerAgreementsReq | undefined): Observable<PartnerAgreementsRes> {
        let url_ = this.baseUrl + "/v1/Agreements/PartnerAgreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAgreements(<any>response_);
                } catch (e) {
                    return <Observable<PartnerAgreementsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerAgreementsRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAgreements(response: HttpResponseBase): Observable<PartnerAgreementsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerAgreementsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerAgreements2(api_version: string | undefined, body: PartnerAgreementsReq | undefined): Observable<PartnerAgreementsRes> {
        let url_ = this.baseUrl + "/Agreements/PartnerAgreements?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAgreements2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAgreements2(<any>response_);
                } catch (e) {
                    return <Observable<PartnerAgreementsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerAgreementsRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAgreements2(response: HttpResponseBase): Observable<PartnerAgreementsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerAgreementsRes>(<any>null);
    }

    /**
     * @return Success
     */
    partnerAgreements3(id: number): Observable<PartnerAgreementsDetailDTO> {
        let url_ = this.baseUrl + "/v1/Agreements/PartnerAgreements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAgreements3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAgreements3(<any>response_);
                } catch (e) {
                    return <Observable<PartnerAgreementsDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerAgreementsDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAgreements3(response: HttpResponseBase): Observable<PartnerAgreementsDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementsDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerAgreementsDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    partnerAgreements4(id: number, api_version: string | undefined): Observable<PartnerAgreementsDetailDTO> {
        let url_ = this.baseUrl + "/Agreements/PartnerAgreements/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAgreements4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAgreements4(<any>response_);
                } catch (e) {
                    return <Observable<PartnerAgreementsDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerAgreementsDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAgreements4(response: HttpResponseBase): Observable<PartnerAgreementsDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerAgreementsDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerAgreementsDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPartnerAgreement(body: AddPartnerAgreementReq | undefined): Observable<AddPartnerAgreementRes> {
        let url_ = this.baseUrl + "/v1/Agreements/AddPartnerAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPartnerAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPartnerAgreement(<any>response_);
                } catch (e) {
                    return <Observable<AddPartnerAgreementRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPartnerAgreementRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddPartnerAgreement(response: HttpResponseBase): Observable<AddPartnerAgreementRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPartnerAgreementRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddPartnerAgreementRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPartnerAgreementRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addPartnerAgreement2(api_version: string | undefined, body: AddPartnerAgreementReq | undefined): Observable<AddPartnerAgreementRes> {
        let url_ = this.baseUrl + "/Agreements/AddPartnerAgreement?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPartnerAgreement2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPartnerAgreement2(<any>response_);
                } catch (e) {
                    return <Observable<AddPartnerAgreementRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPartnerAgreementRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddPartnerAgreement2(response: HttpResponseBase): Observable<AddPartnerAgreementRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPartnerAgreementRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddPartnerAgreementRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPartnerAgreementRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePartnerAgreement(body: UpdatePartnerAgreementReq | undefined): Observable<UpdatePartnerAgreementRes> {
        let url_ = this.baseUrl + "/v1/Agreements/UpdatePartnerAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartnerAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartnerAgreement(<any>response_);
                } catch (e) {
                    return <Observable<UpdatePartnerAgreementRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdatePartnerAgreementRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePartnerAgreement(response: HttpResponseBase): Observable<UpdatePartnerAgreementRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerAgreementRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdatePartnerAgreementRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePartnerAgreementRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePartnerAgreement2(api_version: string | undefined, body: UpdatePartnerAgreementReq | undefined): Observable<UpdatePartnerAgreementRes> {
        let url_ = this.baseUrl + "/Agreements/UpdatePartnerAgreement?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartnerAgreement2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartnerAgreement2(<any>response_);
                } catch (e) {
                    return <Observable<UpdatePartnerAgreementRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdatePartnerAgreementRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePartnerAgreement2(response: HttpResponseBase): Observable<UpdatePartnerAgreementRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerAgreementRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdatePartnerAgreementRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePartnerAgreementRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    expirePartnerAgreement(body: ExpirePartnerAgreementRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Agreements/ExpirePartnerAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpirePartnerAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpirePartnerAgreement(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExpirePartnerAgreement(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    expirePartnerAgreement2(api_version: string | undefined, body: ExpirePartnerAgreementRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Agreements/ExpirePartnerAgreement?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpirePartnerAgreement2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpirePartnerAgreement2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processExpirePartnerAgreement2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerAgreements(body: CustomerAgreementsReq | undefined): Observable<CustomerAgreementsRes> {
        let url_ = this.baseUrl + "/v1/Agreements/CustomerAgreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerAgreements(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAgreementsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAgreementsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerAgreements(response: HttpResponseBase): Observable<CustomerAgreementsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAgreementsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAgreementsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerAgreements2(api_version: string | undefined, body: CustomerAgreementsReq | undefined): Observable<CustomerAgreementsRes> {
        let url_ = this.baseUrl + "/Agreements/CustomerAgreements?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerAgreements2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerAgreements2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAgreementsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAgreementsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerAgreements2(response: HttpResponseBase): Observable<CustomerAgreementsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAgreementsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAgreementsRes>(<any>null);
    }

    /**
     * @return Success
     */
    customerAgreements3(id: number): Observable<CustomerAgreementsDetailDTO> {
        let url_ = this.baseUrl + "/v1/Agreements/CustomerAgreements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerAgreements3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerAgreements3(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAgreementsDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAgreementsDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerAgreements3(response: HttpResponseBase): Observable<CustomerAgreementsDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAgreementsDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAgreementsDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    customerAgreements4(id: number, api_version: string | undefined): Observable<CustomerAgreementsDetailDTO> {
        let url_ = this.baseUrl + "/Agreements/CustomerAgreements/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerAgreements4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerAgreements4(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAgreementsDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAgreementsDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerAgreements4(response: HttpResponseBase): Observable<CustomerAgreementsDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAgreementsDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAgreementsDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerAgreements(body: AddCustomerAgreementsReq | undefined): Observable<AddCustomerAgreementsRes> {
        let url_ = this.baseUrl + "/v1/Agreements/AddCustomerAgreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerAgreements(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerAgreementsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerAgreementsRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerAgreements(response: HttpResponseBase): Observable<AddCustomerAgreementsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerAgreementsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddCustomerAgreementsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerAgreementsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerAgreements2(api_version: string | undefined, body: AddCustomerAgreementsReq | undefined): Observable<AddCustomerAgreementsRes> {
        let url_ = this.baseUrl + "/Agreements/AddCustomerAgreements?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerAgreements2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerAgreements2(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerAgreementsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerAgreementsRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerAgreements2(response: HttpResponseBase): Observable<AddCustomerAgreementsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerAgreementsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddCustomerAgreementsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerAgreementsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerAgreements(body: UpdateCustomerAgreementsReq | undefined): Observable<UpdateCustomerAgreementsRes> {
        let url_ = this.baseUrl + "/v1/Agreements/UpdateCustomerAgreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerAgreements(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerAgreementsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerAgreementsRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerAgreements(response: HttpResponseBase): Observable<UpdateCustomerAgreementsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerAgreementsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateCustomerAgreementsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerAgreementsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCustomerAgreements2(api_version: string | undefined, body: UpdateCustomerAgreementsReq | undefined): Observable<UpdateCustomerAgreementsRes> {
        let url_ = this.baseUrl + "/Agreements/UpdateCustomerAgreements?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerAgreements2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerAgreements2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerAgreementsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerAgreementsRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerAgreements2(response: HttpResponseBase): Observable<UpdateCustomerAgreementsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerAgreementsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateCustomerAgreementsRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerAgreementsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    agreementServiceCoef(body: AgreementServiceCoefReq | undefined): Observable<AgreementServiceCoefRes> {
        let url_ = this.baseUrl + "/v1/Agreements/AgreementServiceCoef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgreementServiceCoef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgreementServiceCoef(<any>response_);
                } catch (e) {
                    return <Observable<AgreementServiceCoefRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgreementServiceCoefRes>><any>_observableThrow(response_);
        }));
    }

    protected processAgreementServiceCoef(response: HttpResponseBase): Observable<AgreementServiceCoefRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementServiceCoefRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgreementServiceCoefRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    agreementServiceCoef2(api_version: string | undefined, body: AgreementServiceCoefReq | undefined): Observable<AgreementServiceCoefRes> {
        let url_ = this.baseUrl + "/Agreements/AgreementServiceCoef?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgreementServiceCoef2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgreementServiceCoef2(<any>response_);
                } catch (e) {
                    return <Observable<AgreementServiceCoefRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgreementServiceCoefRes>><any>_observableThrow(response_);
        }));
    }

    protected processAgreementServiceCoef2(response: HttpResponseBase): Observable<AgreementServiceCoefRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementServiceCoefRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgreementServiceCoefRes>(<any>null);
    }

    /**
     * @return Success
     */
    agreementServiceCoef3(id: number): Observable<AgreementServiceCoefDTO> {
        let url_ = this.baseUrl + "/v1/Agreements/AgreementServiceCoef/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgreementServiceCoef3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgreementServiceCoef3(<any>response_);
                } catch (e) {
                    return <Observable<AgreementServiceCoefDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgreementServiceCoefDTO>><any>_observableThrow(response_);
        }));
    }

    protected processAgreementServiceCoef3(response: HttpResponseBase): Observable<AgreementServiceCoefDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementServiceCoefDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgreementServiceCoefDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    agreementServiceCoef4(id: number, api_version: string | undefined): Observable<AgreementServiceCoefDTO> {
        let url_ = this.baseUrl + "/Agreements/AgreementServiceCoef/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAgreementServiceCoef4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAgreementServiceCoef4(<any>response_);
                } catch (e) {
                    return <Observable<AgreementServiceCoefDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgreementServiceCoefDTO>><any>_observableThrow(response_);
        }));
    }

    protected processAgreementServiceCoef4(response: HttpResponseBase): Observable<AgreementServiceCoefDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementServiceCoefDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgreementServiceCoefDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addAgreementServiceCoef(body: AddAgreementServiceCoefReq | undefined): Observable<AddAgreementServiceCoefRes> {
        let url_ = this.baseUrl + "/v1/Agreements/AddAgreementServiceCoef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgreementServiceCoef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgreementServiceCoef(<any>response_);
                } catch (e) {
                    return <Observable<AddAgreementServiceCoefRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddAgreementServiceCoefRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddAgreementServiceCoef(response: HttpResponseBase): Observable<AddAgreementServiceCoefRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAgreementServiceCoefRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddAgreementServiceCoefRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddAgreementServiceCoefRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addAgreementServiceCoef2(api_version: string | undefined, body: AddAgreementServiceCoefReq | undefined): Observable<AddAgreementServiceCoefRes> {
        let url_ = this.baseUrl + "/Agreements/AddAgreementServiceCoef?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAgreementServiceCoef2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAgreementServiceCoef2(<any>response_);
                } catch (e) {
                    return <Observable<AddAgreementServiceCoefRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddAgreementServiceCoefRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddAgreementServiceCoef2(response: HttpResponseBase): Observable<AddAgreementServiceCoefRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddAgreementServiceCoefRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddAgreementServiceCoefRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddAgreementServiceCoefRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAgreementServiceCoef(body: UpdateAgreementServiceCoefReq | undefined): Observable<UpdateAgreementServiceCoefRes> {
        let url_ = this.baseUrl + "/v1/Agreements/UpdateAgreementServiceCoef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAgreementServiceCoef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAgreementServiceCoef(<any>response_);
                } catch (e) {
                    return <Observable<UpdateAgreementServiceCoefRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateAgreementServiceCoefRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAgreementServiceCoef(response: HttpResponseBase): Observable<UpdateAgreementServiceCoefRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAgreementServiceCoefRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateAgreementServiceCoefRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateAgreementServiceCoefRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateAgreementServiceCoef2(api_version: string | undefined, body: UpdateAgreementServiceCoefReq | undefined): Observable<UpdateAgreementServiceCoefRes> {
        let url_ = this.baseUrl + "/Agreements/UpdateAgreementServiceCoef?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAgreementServiceCoef2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAgreementServiceCoef2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateAgreementServiceCoefRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateAgreementServiceCoefRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateAgreementServiceCoef2(response: HttpResponseBase): Observable<UpdateAgreementServiceCoefRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAgreementServiceCoefRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateAgreementServiceCoefRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateAgreementServiceCoefRes>(<any>null);
    }

    /**
     * @return Success
     */
    about3(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Agreements/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout3(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout3(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about4(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Agreements/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout4(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout4(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pathList(body: PathListReq | undefined): Observable<PathListRes> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/PathList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPathList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPathList(<any>response_);
                } catch (e) {
                    return <Observable<PathListRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PathListRes>><any>_observableThrow(response_);
        }));
    }

    protected processPathList(response: HttpResponseBase): Observable<PathListRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PathListRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PathListRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    pathList2(api_version: string | undefined, body: PathListReq | undefined): Observable<PathListRes> {
        let url_ = this.baseUrl + "/ApiLocalization/PathList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPathList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPathList2(<any>response_);
                } catch (e) {
                    return <Observable<PathListRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PathListRes>><any>_observableThrow(response_);
        }));
    }

    protected processPathList2(response: HttpResponseBase): Observable<PathListRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PathListRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PathListRes>(<any>null);
    }

    /**
     * @return Success
     */
    pathList3(id: number): Observable<ApiLocalizationPathDTO> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/PathList/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPathList3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPathList3(<any>response_);
                } catch (e) {
                    return <Observable<ApiLocalizationPathDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiLocalizationPathDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPathList3(response: HttpResponseBase): Observable<ApiLocalizationPathDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiLocalizationPathDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiLocalizationPathDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    pathList4(id: number, api_version: string | undefined): Observable<ApiLocalizationPathDTO> {
        let url_ = this.baseUrl + "/ApiLocalization/PathList/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPathList4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPathList4(<any>response_);
                } catch (e) {
                    return <Observable<ApiLocalizationPathDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiLocalizationPathDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPathList4(response: HttpResponseBase): Observable<ApiLocalizationPathDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiLocalizationPathDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiLocalizationPathDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPath(body: AddPathReq | undefined): Observable<AddPathRes> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/AddPath";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPath(<any>response_);
                } catch (e) {
                    return <Observable<AddPathRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPathRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddPath(response: HttpResponseBase): Observable<AddPathRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPathRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddPathRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPathRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addPath2(api_version: string | undefined, body: AddPathReq | undefined): Observable<AddPathRes> {
        let url_ = this.baseUrl + "/ApiLocalization/AddPath?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPath2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPath2(<any>response_);
                } catch (e) {
                    return <Observable<AddPathRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPathRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddPath2(response: HttpResponseBase): Observable<AddPathRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPathRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddPathRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPathRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePath(body: UpdatePathReq | undefined): Observable<UpdatePathRes> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/UpdatePath";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePath(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePath(<any>response_);
                } catch (e) {
                    return <Observable<UpdatePathRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdatePathRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePath(response: HttpResponseBase): Observable<UpdatePathRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePathRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdatePathRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePathRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePath2(api_version: string | undefined, body: UpdatePathReq | undefined): Observable<UpdatePathRes> {
        let url_ = this.baseUrl + "/ApiLocalization/UpdatePath?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePath2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePath2(<any>response_);
                } catch (e) {
                    return <Observable<UpdatePathRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdatePathRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePath2(response: HttpResponseBase): Observable<UpdatePathRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePathRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdatePathRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePathRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerApiLanguagesList(body: CustomerApiLanguagesListReq | undefined): Observable<CustomerApiLanguagesListRes> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/CustomerApiLanguagesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerApiLanguagesList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerApiLanguagesList(<any>response_);
                } catch (e) {
                    return <Observable<CustomerApiLanguagesListRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerApiLanguagesListRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerApiLanguagesList(response: HttpResponseBase): Observable<CustomerApiLanguagesListRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerApiLanguagesListRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerApiLanguagesListRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerApiLanguagesList2(api_version: string | undefined, body: CustomerApiLanguagesListReq | undefined): Observable<CustomerApiLanguagesListRes> {
        let url_ = this.baseUrl + "/ApiLocalization/CustomerApiLanguagesList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerApiLanguagesList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerApiLanguagesList2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerApiLanguagesListRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerApiLanguagesListRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerApiLanguagesList2(response: HttpResponseBase): Observable<CustomerApiLanguagesListRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerApiLanguagesListRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerApiLanguagesListRes>(<any>null);
    }

    /**
     * @return Success
     */
    customerApiLanguagesList3(id: number): Observable<CustomerApiLanguagesDTO> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/CustomerApiLanguagesList/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerApiLanguagesList3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerApiLanguagesList3(<any>response_);
                } catch (e) {
                    return <Observable<CustomerApiLanguagesDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerApiLanguagesDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerApiLanguagesList3(response: HttpResponseBase): Observable<CustomerApiLanguagesDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerApiLanguagesDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerApiLanguagesDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    customerApiLanguagesList4(id: number, api_version: string | undefined): Observable<CustomerApiLanguagesDTO> {
        let url_ = this.baseUrl + "/ApiLocalization/CustomerApiLanguagesList/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerApiLanguagesList4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerApiLanguagesList4(<any>response_);
                } catch (e) {
                    return <Observable<CustomerApiLanguagesDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerApiLanguagesDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerApiLanguagesList4(response: HttpResponseBase): Observable<CustomerApiLanguagesDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerApiLanguagesDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerApiLanguagesDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerApiLanguages(body: AddCustomerApiLanguagesReq | undefined): Observable<AddCustomerApiLanguagesRes> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/AddCustomerApiLanguages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerApiLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerApiLanguages(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerApiLanguagesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerApiLanguagesRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerApiLanguages(response: HttpResponseBase): Observable<AddCustomerApiLanguagesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerApiLanguagesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddCustomerApiLanguagesRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerApiLanguagesRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerApiLanguages2(api_version: string | undefined, body: AddCustomerApiLanguagesReq | undefined): Observable<AddCustomerApiLanguagesRes> {
        let url_ = this.baseUrl + "/ApiLocalization/AddCustomerApiLanguages?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerApiLanguages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerApiLanguages2(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerApiLanguagesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerApiLanguagesRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerApiLanguages2(response: HttpResponseBase): Observable<AddCustomerApiLanguagesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerApiLanguagesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddCustomerApiLanguagesRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerApiLanguagesRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerApiLanguages(body: UpdateCustomerApiLanguagesReq | undefined): Observable<UpdateCustomerApiLanguagesRes> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/UpdateCustomerApiLanguages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerApiLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerApiLanguages(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerApiLanguagesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerApiLanguagesRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerApiLanguages(response: HttpResponseBase): Observable<UpdateCustomerApiLanguagesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerApiLanguagesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateCustomerApiLanguagesRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerApiLanguagesRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCustomerApiLanguages2(api_version: string | undefined, body: UpdateCustomerApiLanguagesReq | undefined): Observable<UpdateCustomerApiLanguagesRes> {
        let url_ = this.baseUrl + "/ApiLocalization/UpdateCustomerApiLanguages?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerApiLanguages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerApiLanguages2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerApiLanguagesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerApiLanguagesRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerApiLanguages2(response: HttpResponseBase): Observable<UpdateCustomerApiLanguagesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerApiLanguagesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateCustomerApiLanguagesRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerApiLanguagesRes>(<any>null);
    }

    /**
     * @return Success
     */
    deleteCustomerApiLanguages(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/DeleteCustomerApiLanguages/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerApiLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerApiLanguages(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustomerApiLanguages(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteCustomerApiLanguages2(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/ApiLocalization/DeleteCustomerApiLanguages/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerApiLanguages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerApiLanguages2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustomerApiLanguages2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    apiTextValues(body: ApiTextValuesReq | undefined): Observable<ApiTextValuesRes> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/ApiTextValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTextValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTextValues(<any>response_);
                } catch (e) {
                    return <Observable<ApiTextValuesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiTextValuesRes>><any>_observableThrow(response_);
        }));
    }

    protected processApiTextValues(response: HttpResponseBase): Observable<ApiTextValuesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTextValuesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiTextValuesRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    apiTextValues2(api_version: string | undefined, body: ApiTextValuesReq | undefined): Observable<ApiTextValuesRes> {
        let url_ = this.baseUrl + "/ApiLocalization/ApiTextValues?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApiTextValues2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApiTextValues2(<any>response_);
                } catch (e) {
                    return <Observable<ApiTextValuesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApiTextValuesRes>><any>_observableThrow(response_);
        }));
    }

    protected processApiTextValues2(response: HttpResponseBase): Observable<ApiTextValuesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTextValuesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiTextValuesRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateApiTextValue(body: UpdateApiTextValueReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/UpdateApiTextValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApiTextValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApiTextValue(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateApiTextValue(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateApiTextValue2(api_version: string | undefined, body: UpdateApiTextValueReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/ApiLocalization/UpdateApiTextValue?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApiTextValue2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApiTextValue2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateApiTextValue2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about5(): Observable<string> {
        let url_ = this.baseUrl + "/v1/ApiLocalization/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout5(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout5(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about6(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/ApiLocalization/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout6(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout6(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    parameters(body: AppPrmDefinitionsReq | undefined): Observable<AppPrmDefinitionsRes> {
        let url_ = this.baseUrl + "/v1/AppParameterDefinitions/Parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParameters(<any>response_);
                } catch (e) {
                    return <Observable<AppPrmDefinitionsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppPrmDefinitionsRes>><any>_observableThrow(response_);
        }));
    }

    protected processParameters(response: HttpResponseBase): Observable<AppPrmDefinitionsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppPrmDefinitionsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppPrmDefinitionsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    parameters2(api_version: string | undefined, body: AppPrmDefinitionsReq | undefined): Observable<AppPrmDefinitionsRes> {
        let url_ = this.baseUrl + "/AppParameterDefinitions/Parameters?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParameters2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParameters2(<any>response_);
                } catch (e) {
                    return <Observable<AppPrmDefinitionsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppPrmDefinitionsRes>><any>_observableThrow(response_);
        }));
    }

    protected processParameters2(response: HttpResponseBase): Observable<AppPrmDefinitionsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppPrmDefinitionsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppPrmDefinitionsRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerParametersAll(body: PartnerParametersReq | undefined): Observable<AppParameterInfoDTO[]> {
        let url_ = this.baseUrl + "/v1/AppParameterDefinitions/PartnerParameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerParametersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerParametersAll(<any>response_);
                } catch (e) {
                    return <Observable<AppParameterInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppParameterInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerParametersAll(response: HttpResponseBase): Observable<AppParameterInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppParameterInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppParameterInfoDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerParameters(api_version: string | undefined, body: PartnerParametersReq | undefined): Observable<AppParameterInfoDTO[]> {
        let url_ = this.baseUrl + "/AppParameterDefinitions/PartnerParameters?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerParameters(<any>response_);
                } catch (e) {
                    return <Observable<AppParameterInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppParameterInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerParameters(response: HttpResponseBase): Observable<AppParameterInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppParameterInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppParameterInfoDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerParametersAll(body: CustomerParametersReq | undefined): Observable<AppParameterInfoDTO[]> {
        let url_ = this.baseUrl + "/v1/AppParameterDefinitions/CustomerParameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerParametersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerParametersAll(<any>response_);
                } catch (e) {
                    return <Observable<AppParameterInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppParameterInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerParametersAll(response: HttpResponseBase): Observable<AppParameterInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppParameterInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppParameterInfoDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerParameters(api_version: string | undefined, body: CustomerParametersReq | undefined): Observable<AppParameterInfoDTO[]> {
        let url_ = this.baseUrl + "/AppParameterDefinitions/CustomerParameters?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerParameters(<any>response_);
                } catch (e) {
                    return <Observable<AppParameterInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppParameterInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerParameters(response: HttpResponseBase): Observable<AppParameterInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppParameterInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppParameterInfoDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    parameterDetail(body: ParameterDetailReq | undefined): Observable<ParameterDetailRes> {
        let url_ = this.baseUrl + "/v1/AppParameterDefinitions/ParameterDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParameterDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParameterDetail(<any>response_);
                } catch (e) {
                    return <Observable<ParameterDetailRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ParameterDetailRes>><any>_observableThrow(response_);
        }));
    }

    protected processParameterDetail(response: HttpResponseBase): Observable<ParameterDetailRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterDetailRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ParameterDetailRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ParameterDetailRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    parameterDetail2(api_version: string | undefined, body: ParameterDetailReq | undefined): Observable<ParameterDetailRes> {
        let url_ = this.baseUrl + "/AppParameterDefinitions/ParameterDetail?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParameterDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParameterDetail2(<any>response_);
                } catch (e) {
                    return <Observable<ParameterDetailRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ParameterDetailRes>><any>_observableThrow(response_);
        }));
    }

    protected processParameterDetail2(response: HttpResponseBase): Observable<ParameterDetailRes> {
        
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterDetailRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ParameterDetailRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ParameterDetailRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateParameter(body: UpdateParameterReq | undefined): Observable<UpdateParameterRes> {
        let url_ = this.baseUrl + "/v1/AppParameterDefinitions/UpdateParameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParameter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParameter(<any>response_);
                } catch (e) {
                    return <Observable<UpdateParameterRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateParameterRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateParameter(response: HttpResponseBase): Observable<UpdateParameterRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateParameterRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateParameterRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateParameterRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateParameter2(api_version: string | undefined, body: UpdateParameterReq | undefined): Observable<UpdateParameterRes> {
        let url_ = this.baseUrl + "/AppParameterDefinitions/UpdateParameter?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateParameter2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateParameter2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateParameterRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateParameterRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateParameter2(response: HttpResponseBase): Observable<UpdateParameterRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateParameterRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateParameterRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateParameterRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerAndCustomers2(body: PartnerAndCustomersReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/v1/AppParameterDefinitions/PartnerAndCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAndCustomers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAndCustomers2(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAndCustomers2(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerAndCustomers3(api_version: string | undefined, body: PartnerAndCustomersReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/AppParameterDefinitions/PartnerAndCustomers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAndCustomers3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAndCustomers3(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAndCustomers3(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @return Success
     */
    about7(): Observable<string> {
        let url_ = this.baseUrl + "/v1/AppParameterDefinitions/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout7(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout7(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about8(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/AppParameterDefinitions/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout8(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout8(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    customerDetail(id: string | null): Observable<CustomerDetailDTO> {
        let url_ = this.baseUrl + "/v1/Customer/CustomerDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDetail(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerDetail(response: HttpResponseBase): Observable<CustomerDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    customerDetail2(id: string | null, api_version: string | undefined): Observable<CustomerDetailDTO> {
        let url_ = this.baseUrl + "/Customer/CustomerDetail/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerDetail2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerDetail2(response: HttpResponseBase): Observable<CustomerDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customers(body: CustomersReq | undefined): Observable<CustomersRes> {
        let url_ = this.baseUrl + "/v1/Customer/Customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers(<any>response_);
                } catch (e) {
                    return <Observable<CustomersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomersRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomers(response: HttpResponseBase): Observable<CustomersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customers2(api_version: string | undefined, body: CustomersReq | undefined): Observable<CustomersRes> {
        let url_ = this.baseUrl + "/Customer/Customers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers2(<any>response_);
                } catch (e) {
                    return <Observable<CustomersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomersRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomers2(response: HttpResponseBase): Observable<CustomersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    lockedAndUnlocked(body: LockedAndUnLockedCustomersReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/LockedAndUnlocked";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockedAndUnlocked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockedAndUnlocked(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLockedAndUnlocked(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    lockedAndUnlocked2(api_version: string | undefined, body: LockedAndUnLockedCustomersReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/LockedAndUnlocked?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLockedAndUnlocked2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLockedAndUnlocked2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processLockedAndUnlocked2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dealerApiOrAdminPanelAddActivation(body: DealerApiOrAdminPanelActivationAddInputs | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/DealerApiOrAdminPanelAddActivation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDealerApiOrAdminPanelAddActivation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDealerApiOrAdminPanelAddActivation(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDealerApiOrAdminPanelAddActivation(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    dealerApiOrAdminPanelAddActivation2(api_version: string | undefined, body: DealerApiOrAdminPanelActivationAddInputs | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/DealerApiOrAdminPanelAddActivation?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDealerApiOrAdminPanelAddActivation2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDealerApiOrAdminPanelAddActivation2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDealerApiOrAdminPanelAddActivation2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 !== undefined ? resultData400 : <any>null;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dealerApiOrAdminPanelAddCustomer(body: DealerApiOrAdminPanelCustomerAddInputs | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/DealerApiOrAdminPanelAddCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDealerApiOrAdminPanelAddCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDealerApiOrAdminPanelAddCustomer(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDealerApiOrAdminPanelAddCustomer(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    dealerApiOrAdminPanelAddCustomer2(api_version: string | undefined, body: DealerApiOrAdminPanelCustomerAddInputs | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/DealerApiOrAdminPanelAddCustomer?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDealerApiOrAdminPanelAddCustomer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDealerApiOrAdminPanelAddCustomer2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDealerApiOrAdminPanelAddCustomer2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fastTransaction(body: CustomerFileUploadReq | undefined): Observable<CustomerFileUploadRes> {
        let url_ = this.baseUrl + "/v1/Customer/FastTransaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFastTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFastTransaction(<any>response_);
                } catch (e) {
                    return <Observable<CustomerFileUploadRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerFileUploadRes>><any>_observableThrow(response_);
        }));
    }

    protected processFastTransaction(response: HttpResponseBase): Observable<CustomerFileUploadRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFileUploadRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerFileUploadRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    fastTransaction2(api_version: string | undefined, body: CustomerFileUploadReq | undefined): Observable<CustomerFileUploadRes> {
        let url_ = this.baseUrl + "/Customer/FastTransaction?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFastTransaction2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFastTransaction2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerFileUploadRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerFileUploadRes>><any>_observableThrow(response_);
        }));
    }

    protected processFastTransaction2(response: HttpResponseBase): Observable<CustomerFileUploadRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFileUploadRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerFileUploadRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerFileUpload(body: CustomerFileUploadReq | undefined): Observable<CustomerFileUploadRes> {
        let url_ = this.baseUrl + "/v1/Customer/CustomerFileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerFileUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerFileUpload(<any>response_);
                } catch (e) {
                    return <Observable<CustomerFileUploadRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerFileUploadRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerFileUpload(response: HttpResponseBase): Observable<CustomerFileUploadRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFileUploadRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerFileUploadRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerFileUpload2(api_version: string | undefined, body: CustomerFileUploadReq | undefined): Observable<CustomerFileUploadRes> {
        let url_ = this.baseUrl + "/Customer/CustomerFileUpload?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerFileUpload2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerFileUpload2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerFileUploadRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerFileUploadRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerFileUpload2(response: HttpResponseBase): Observable<CustomerFileUploadRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFileUploadRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerFileUploadRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomer(body: AddCustomerReq | undefined): Observable<AddCustomerRes> {
        let url_ = this.baseUrl + "/v1/Customer/AddCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomer(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomer(response: HttpResponseBase): Observable<AddCustomerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomer2(api_version: string | undefined, body: AddCustomerReq | undefined): Observable<AddCustomerRes> {
        let url_ = this.baseUrl + "/Customer/AddCustomer?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomer2(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomer2(response: HttpResponseBase): Observable<AddCustomerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomer(body: UpdateCustomerReq | undefined): Observable<UpdateCustomerRes> {
        let url_ = this.baseUrl + "/v1/Customer/UpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomer(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomer(response: HttpResponseBase): Observable<UpdateCustomerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCustomer2(api_version: string | undefined, body: UpdateCustomerReq | undefined): Observable<UpdateCustomerRes> {
        let url_ = this.baseUrl + "/Customer/UpdateCustomer?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomer2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomer2(response: HttpResponseBase): Observable<UpdateCustomerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerLogoAndSignInfo(body: AddCustomerLogoAndSignInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/AddCustomerLogoAndSignInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerLogoAndSignInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerLogoAndSignInfo(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerLogoAndSignInfo(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerLogoAndSignInfo2(api_version: string | undefined, body: AddCustomerLogoAndSignInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/AddCustomerLogoAndSignInfo?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerLogoAndSignInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerLogoAndSignInfo2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerLogoAndSignInfo2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerSummaryInfo(body: AddCustomerSummaryInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/AddCustomerSummaryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerSummaryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerSummaryInfo(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerSummaryInfo(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerSummaryInfo2(api_version: string | undefined, body: AddCustomerSummaryInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/AddCustomerSummaryInfo?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerSummaryInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerSummaryInfo2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerSummaryInfo2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerSummaryInfo(body: UpdateCustomerSummaryInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/UpdateCustomerSummaryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerSummaryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerSummaryInfo(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerSummaryInfo(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCustomerSummaryInfo2(api_version: string | undefined, body: UpdateCustomerSummaryInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/UpdateCustomerSummaryInfo?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerSummaryInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerSummaryInfo2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerSummaryInfo2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    customerSummaryInfoDetail(id: string | null): Observable<CustomerSummaryInfoDTO> {
        let url_ = this.baseUrl + "/v1/Customer/CustomerSummaryInfoDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerSummaryInfoDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerSummaryInfoDetail(<any>response_);
                } catch (e) {
                    return <Observable<CustomerSummaryInfoDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerSummaryInfoDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerSummaryInfoDetail(response: HttpResponseBase): Observable<CustomerSummaryInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerSummaryInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerSummaryInfoDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    customerSummaryInfoDetail2(id: string | null, api_version: string | undefined): Observable<CustomerSummaryInfoDTO> {
        let url_ = this.baseUrl + "/Customer/CustomerSummaryInfoDetail/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerSummaryInfoDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerSummaryInfoDetail2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerSummaryInfoDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerSummaryInfoDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerSummaryInfoDetail2(response: HttpResponseBase): Observable<CustomerSummaryInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerSummaryInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerSummaryInfoDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeCustomerPartner(body: ChangeCustomerPartnerRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/ChangeCustomerPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCustomerPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCustomerPartner(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processChangeCustomerPartner(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    changeCustomerPartner2(api_version: string | undefined, body: ChangeCustomerPartnerRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/ChangeCustomerPartner?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCustomerPartner2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCustomerPartner2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processChangeCustomerPartner2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeCustomer(body: ChangeCustomerIdRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/ChangeCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCustomer(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processChangeCustomer(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    changeCustomer2(api_version: string | undefined, body: ChangeCustomerIdRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/ChangeCustomer?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeCustomer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeCustomer2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processChangeCustomer2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    stopContourMaster(customerId: string | null | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Customer/StopContourMaster?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopContourMaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopContourMaster(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processStopContourMaster(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param customerId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    stopContourMaster2(customerId: string | null | undefined, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Customer/StopContourMaster?";
        if (customerId !== undefined && customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStopContourMaster2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStopContourMaster2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processStopContourMaster2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about9(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Customer/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout9(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout9(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout9(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about10(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Customer/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout10(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout10(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout10(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    filters(body: CustomerAllowedIPFiltersReq | undefined): Observable<CustomerAllowedIPFiltersRes> {
        let url_ = this.baseUrl + "/v1/CustomerAllowedIP/Filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilters(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAllowedIPFiltersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAllowedIPFiltersRes>><any>_observableThrow(response_);
        }));
    }

    protected processFilters(response: HttpResponseBase): Observable<CustomerAllowedIPFiltersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAllowedIPFiltersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAllowedIPFiltersRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    filters2(api_version: string | undefined, body: CustomerAllowedIPFiltersReq | undefined): Observable<CustomerAllowedIPFiltersRes> {
        let url_ = this.baseUrl + "/CustomerAllowedIP/Filters?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilters2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilters2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAllowedIPFiltersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAllowedIPFiltersRes>><any>_observableThrow(response_);
        }));
    }

    protected processFilters2(response: HttpResponseBase): Observable<CustomerAllowedIPFiltersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAllowedIPFiltersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAllowedIPFiltersRes>(<any>null);
    }

    /**
     * @return Success
     */
    filters3(id: number): Observable<CustomerAllowedIPDTO> {
        let url_ = this.baseUrl + "/v1/CustomerAllowedIP/Filters/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilters3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilters3(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAllowedIPDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAllowedIPDTO>><any>_observableThrow(response_);
        }));
    }

    protected processFilters3(response: HttpResponseBase): Observable<CustomerAllowedIPDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAllowedIPDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAllowedIPDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    filters4(id: number, api_version: string | undefined): Observable<CustomerAllowedIPDTO> {
        let url_ = this.baseUrl + "/CustomerAllowedIP/Filters/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilters4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilters4(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAllowedIPDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAllowedIPDTO>><any>_observableThrow(response_);
        }));
    }

    protected processFilters4(response: HttpResponseBase): Observable<CustomerAllowedIPDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAllowedIPDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAllowedIPDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addFilter(body: CustomerAllowedIPAddFilterReq | undefined): Observable<CustomerAllowedIPAddFilterRes> {
        let url_ = this.baseUrl + "/v1/CustomerAllowedIP/AddFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFilter(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAllowedIPAddFilterRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAllowedIPAddFilterRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddFilter(response: HttpResponseBase): Observable<CustomerAllowedIPAddFilterRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAllowedIPAddFilterRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAllowedIPAddFilterRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addFilter2(api_version: string | undefined, body: CustomerAllowedIPAddFilterReq | undefined): Observable<CustomerAllowedIPAddFilterRes> {
        let url_ = this.baseUrl + "/CustomerAllowedIP/AddFilter?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFilter2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFilter2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAllowedIPAddFilterRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAllowedIPAddFilterRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddFilter2(response: HttpResponseBase): Observable<CustomerAllowedIPAddFilterRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAllowedIPAddFilterRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAllowedIPAddFilterRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFilter(body: CustomerAllowedIPUpdateFilterReq | undefined): Observable<CustomerAllowedIPUpdateFilterRes> {
        let url_ = this.baseUrl + "/v1/CustomerAllowedIP/UpdateFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFilter(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAllowedIPUpdateFilterRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAllowedIPUpdateFilterRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateFilter(response: HttpResponseBase): Observable<CustomerAllowedIPUpdateFilterRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAllowedIPUpdateFilterRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAllowedIPUpdateFilterRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateFilter2(api_version: string | undefined, body: CustomerAllowedIPUpdateFilterReq | undefined): Observable<CustomerAllowedIPUpdateFilterRes> {
        let url_ = this.baseUrl + "/CustomerAllowedIP/UpdateFilter?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFilter2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFilter2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAllowedIPUpdateFilterRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAllowedIPUpdateFilterRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateFilter2(response: HttpResponseBase): Observable<CustomerAllowedIPUpdateFilterRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAllowedIPUpdateFilterRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAllowedIPUpdateFilterRes>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    id(id: number | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerAllowedIP/DeleteFilter/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processId(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processId(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    id2(id: number | undefined, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerAllowedIP/DeleteFilter/id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processId2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processId2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processId2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about11(): Observable<string> {
        let url_ = this.baseUrl + "/v1/CustomerAllowedIP/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout11(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout11(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout11(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about12(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/CustomerAllowedIP/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout12(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout12(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout12(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilterQueryUserAll(body: FilterQueryUserReq | undefined): Observable<UserInfo[]> {
        let url_ = this.baseUrl + "/v1/CustomerBranch/GetFilterQueryUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilterQueryUserAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilterQueryUserAll(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilterQueryUserAll(response: HttpResponseBase): Observable<UserInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    getFilterQueryUser(api_version: string | undefined, body: FilterQueryUserReq | undefined): Observable<UserInfo[]> {
        let url_ = this.baseUrl + "/CustomerBranch/GetFilterQueryUser?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilterQueryUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilterQueryUser(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFilterQueryUser(response: HttpResponseBase): Observable<UserInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customersBranchs(body: CustomersBranchsRequest | undefined): Observable<CustomersBranchsResponse> {
        let url_ = this.baseUrl + "/v1/CustomerBranch/CustomersBranchs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersBranchs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersBranchs(<any>response_);
                } catch (e) {
                    return <Observable<CustomersBranchsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomersBranchsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersBranchs(response: HttpResponseBase): Observable<CustomersBranchsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersBranchsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersBranchsResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customersBranchs2(api_version: string | undefined, body: CustomersBranchsRequest | undefined): Observable<CustomersBranchsResponse> {
        let url_ = this.baseUrl + "/CustomerBranch/CustomersBranchs?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersBranchs2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersBranchs2(<any>response_);
                } catch (e) {
                    return <Observable<CustomersBranchsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomersBranchsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersBranchs2(response: HttpResponseBase): Observable<CustomersBranchsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersBranchsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersBranchsResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerBranchsDropDownListAll(body: CustomersBranchsRequest | undefined): Observable<CustomerBranchDTO[]> {
        let url_ = this.baseUrl + "/v1/CustomerBranch/CustomerBranchsDropDownList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerBranchsDropDownListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerBranchsDropDownListAll(<any>response_);
                } catch (e) {
                    return <Observable<CustomerBranchDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerBranchDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerBranchsDropDownListAll(response: HttpResponseBase): Observable<CustomerBranchDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerBranchDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerBranchDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerBranchsDropDownList(api_version: string | undefined, body: CustomersBranchsRequest | undefined): Observable<CustomerBranchDTO[]> {
        let url_ = this.baseUrl + "/CustomerBranch/CustomerBranchsDropDownList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerBranchsDropDownList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerBranchsDropDownList(<any>response_);
                } catch (e) {
                    return <Observable<CustomerBranchDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerBranchDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerBranchsDropDownList(response: HttpResponseBase): Observable<CustomerBranchDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerBranchDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerBranchDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    customerBranchDetail(id: number): Observable<CustomerBranchDTO> {
        let url_ = this.baseUrl + "/v1/CustomerBranch/CustomerBranchDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerBranchDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerBranchDetail(<any>response_);
                } catch (e) {
                    return <Observable<CustomerBranchDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerBranchDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerBranchDetail(response: HttpResponseBase): Observable<CustomerBranchDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBranchDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerBranchDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    customerBranchDetail2(id: number, api_version: string | undefined): Observable<CustomerBranchDTO> {
        let url_ = this.baseUrl + "/CustomerBranch/CustomerBranchDetail/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerBranchDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerBranchDetail2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerBranchDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerBranchDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerBranchDetail2(response: HttpResponseBase): Observable<CustomerBranchDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBranchDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerBranchDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerBranch(body: CustomerBranchRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerBranch/AddCustomerBranch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerBranch(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerBranch(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerBranch2(api_version: string | undefined, body: CustomerBranchRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerBranch/AddCustomerBranch?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerBranch2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerBranch2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerBranch2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerBranch(body: CustomerBranchRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerBranch/UpdateCustomerBranch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerBranch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerBranch(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerBranch(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCustomerBranch2(api_version: string | undefined, body: CustomerBranchRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerBranch/UpdateCustomerBranch?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerBranch2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerBranch2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerBranch2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about13(): Observable<string> {
        let url_ = this.baseUrl + "/v1/CustomerBranch/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout13(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout13(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout13(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about14(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/CustomerBranch/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout14(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout14(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout14(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customersBranchUsers(body: CustomersBranchsUsersReq | undefined): Observable<CustomersBranchUsersRes> {
        let url_ = this.baseUrl + "/v1/CustomerBranchUsers/CustomersBranchUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersBranchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersBranchUsers(<any>response_);
                } catch (e) {
                    return <Observable<CustomersBranchUsersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomersBranchUsersRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersBranchUsers(response: HttpResponseBase): Observable<CustomersBranchUsersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersBranchUsersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersBranchUsersRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customersBranchUsers2(api_version: string | undefined, body: CustomersBranchsUsersReq | undefined): Observable<CustomersBranchUsersRes> {
        let url_ = this.baseUrl + "/CustomerBranchUsers/CustomersBranchUsers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersBranchUsers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersBranchUsers2(<any>response_);
                } catch (e) {
                    return <Observable<CustomersBranchUsersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomersBranchUsersRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersBranchUsers2(response: HttpResponseBase): Observable<CustomersBranchUsersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersBranchUsersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersBranchUsersRes>(<any>null);
    }

    /**
     * @return Success
     */
    customerBranchUserDetail(id: number): Observable<CustomerBranchUsersDetailDTO> {
        let url_ = this.baseUrl + "/v1/CustomerBranchUsers/CustomerBranchUserDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerBranchUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerBranchUserDetail(<any>response_);
                } catch (e) {
                    return <Observable<CustomerBranchUsersDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerBranchUsersDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerBranchUserDetail(response: HttpResponseBase): Observable<CustomerBranchUsersDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBranchUsersDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerBranchUsersDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    customerBranchUserDetail2(id: number, api_version: string | undefined): Observable<CustomerBranchUsersDetailDTO> {
        let url_ = this.baseUrl + "/CustomerBranchUsers/CustomerBranchUserDetail/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerBranchUserDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerBranchUserDetail2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerBranchUsersDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerBranchUsersDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerBranchUserDetail2(response: HttpResponseBase): Observable<CustomerBranchUsersDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBranchUsersDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerBranchUsersDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerBranchUsers(body: AddCustomerBranchUsersReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerBranchUsers/AddCustomerBranchUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerBranchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerBranchUsers(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerBranchUsers(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerBranchUsers2(api_version: string | undefined, body: AddCustomerBranchUsersReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerBranchUsers/AddCustomerBranchUsers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerBranchUsers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerBranchUsers2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerBranchUsers2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerBranchUsers(body: UpdateCustomerBranchUsersReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerBranchUsers/UpdateCustomerBranchUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerBranchUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerBranchUsers(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerBranchUsers(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCustomerBranchUsers2(api_version: string | undefined, body: UpdateCustomerBranchUsersReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerBranchUsers/UpdateCustomerBranchUsers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerBranchUsers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerBranchUsers2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerBranchUsers2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about15(): Observable<string> {
        let url_ = this.baseUrl + "/v1/CustomerBranchUsers/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout15(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout15(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout15(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about16(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/CustomerBranchUsers/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout16(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout16(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout16(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    avaiableCustomerAgreementsAll(body: AvaiableCustomerAgreementsReq | undefined): Observable<CustomerAgreementsInfoDTO[]> {
        let url_ = this.baseUrl + "/v1/CustomerContours/AvaiableCustomerAgreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvaiableCustomerAgreementsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvaiableCustomerAgreementsAll(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAgreementsInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAgreementsInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvaiableCustomerAgreementsAll(response: HttpResponseBase): Observable<CustomerAgreementsInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAgreementsInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAgreementsInfoDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    avaiableCustomerAgreements(api_version: string | undefined, body: AvaiableCustomerAgreementsReq | undefined): Observable<CustomerAgreementsInfoDTO[]> {
        let url_ = this.baseUrl + "/CustomerContours/AvaiableCustomerAgreements?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvaiableCustomerAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvaiableCustomerAgreements(<any>response_);
                } catch (e) {
                    return <Observable<CustomerAgreementsInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerAgreementsInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvaiableCustomerAgreements(response: HttpResponseBase): Observable<CustomerAgreementsInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAgreementsInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerAgreementsInfoDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerContoursCustomersAll(body: CustomersForContourReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/v1/CustomerContours/CustomerContoursCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerContoursCustomersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerContoursCustomersAll(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerContoursCustomersAll(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerContoursCustomers(api_version: string | undefined, body: CustomersForContourReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/CustomerContours/CustomerContoursCustomers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerContoursCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerContoursCustomers(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerContoursCustomers(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documents(body: CustomerContoursDocumentsReq | undefined): Observable<CustomerContoursDocumentsRes> {
        let url_ = this.baseUrl + "/v1/CustomerContours/Documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocuments(<any>response_);
                } catch (e) {
                    return <Observable<CustomerContoursDocumentsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerContoursDocumentsRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocuments(response: HttpResponseBase): Observable<CustomerContoursDocumentsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerContoursDocumentsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerContoursDocumentsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    documents2(api_version: string | undefined, body: CustomerContoursDocumentsReq | undefined): Observable<CustomerContoursDocumentsRes> {
        let url_ = this.baseUrl + "/CustomerContours/Documents?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocuments2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocuments2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerContoursDocumentsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerContoursDocumentsRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocuments2(response: HttpResponseBase): Observable<CustomerContoursDocumentsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerContoursDocumentsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerContoursDocumentsRes>(<any>null);
    }

    /**
     * @return Success
     */
    documents3(id: number): Observable<CustomerContourDocumentDTO> {
        let url_ = this.baseUrl + "/v1/CustomerContours/Documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocuments3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocuments3(<any>response_);
                } catch (e) {
                    return <Observable<CustomerContourDocumentDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerContourDocumentDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocuments3(response: HttpResponseBase): Observable<CustomerContourDocumentDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerContourDocumentDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerContourDocumentDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    documents4(id: number, api_version: string | undefined): Observable<CustomerContourDocumentDTO> {
        let url_ = this.baseUrl + "/CustomerContours/Documents/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocuments4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocuments4(<any>response_);
                } catch (e) {
                    return <Observable<CustomerContourDocumentDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerContourDocumentDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocuments4(response: HttpResponseBase): Observable<CustomerContourDocumentDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerContourDocumentDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerContourDocumentDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dealaerApiAddContourDocument(body: DealerApiContourAddInputs | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerContours/DealaerApiAddContourDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDealaerApiAddContourDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDealaerApiAddContourDocument(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDealaerApiAddContourDocument(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    dealaerApiAddContourDocument2(api_version: string | undefined, body: DealerApiContourAddInputs | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerContours/DealaerApiAddContourDocument?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDealaerApiAddContourDocument2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDealaerApiAddContourDocument2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDealaerApiAddContourDocument2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDocument(body: AddCustomerContourDocumentReq | undefined): Observable<AddCustomerContourDocumentRes> {
        let url_ = this.baseUrl + "/v1/CustomerContours/AddDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerContourDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerContourDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocument(response: HttpResponseBase): Observable<AddCustomerContourDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerContourDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerContourDocumentRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addDocument2(api_version: string | undefined, body: AddCustomerContourDocumentReq | undefined): Observable<AddCustomerContourDocumentRes> {
        let url_ = this.baseUrl + "/CustomerContours/AddDocument?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument2(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerContourDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerContourDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocument2(response: HttpResponseBase): Observable<AddCustomerContourDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerContourDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerContourDocumentRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocument(body: UpdateCustomerContourDocumentReq | undefined): Observable<UpdateCustomerContourDocumentRes> {
        let url_ = this.baseUrl + "/v1/CustomerContours/UpdateDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocument(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerContourDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerContourDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDocument(response: HttpResponseBase): Observable<UpdateCustomerContourDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerContourDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerContourDocumentRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateDocument2(api_version: string | undefined, body: UpdateCustomerContourDocumentReq | undefined): Observable<UpdateCustomerContourDocumentRes> {
        let url_ = this.baseUrl + "/CustomerContours/UpdateDocument?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocument2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocument2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerContourDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerContourDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDocument2(response: HttpResponseBase): Observable<UpdateCustomerContourDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerContourDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerContourDocumentRes>(<any>null);
    }

    /**
     * @return Success
     */
    deleteDocument(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerContours/DeleteDocument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteDocument2(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerContours/DeleteDocument/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocument2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetCustomerContour(body: ResetCustomerContourRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerContours/ResetCustomerContour";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetCustomerContour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetCustomerContour(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processResetCustomerContour(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    resetCustomerContour2(api_version: string | undefined, body: ResetCustomerContourRequest | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerContours/ResetCustomerContour?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetCustomerContour2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetCustomerContour2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processResetCustomerContour2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about17(): Observable<string> {
        let url_ = this.baseUrl + "/v1/CustomerContours/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout17(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout17(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout17(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about18(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/CustomerContours/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout18(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout18(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout18(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerInfo(body: AddCustomerInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerInfo/AddCustomerInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerInfo(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerInfo(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerInfo2(api_version: string | undefined, body: AddCustomerInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerInfo/AddCustomerInfo?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerInfo2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerInfo2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about19(): Observable<string> {
        let url_ = this.baseUrl + "/v1/CustomerInfo/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout19(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout19(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout19(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about20(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/CustomerInfo/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout20(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout20(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout20(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customersSftpInfoDefinition(body: CustomersFtpReq | undefined): Observable<CustomersFtpRes> {
        let url_ = this.baseUrl + "/v1/CustomerSftpInfoDefinition/CustomersSftpInfoDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersSftpInfoDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersSftpInfoDefinition(<any>response_);
                } catch (e) {
                    return <Observable<CustomersFtpRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomersFtpRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersSftpInfoDefinition(response: HttpResponseBase): Observable<CustomersFtpRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersFtpRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersFtpRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customersSftpInfoDefinition2(api_version: string | undefined, body: CustomersFtpReq | undefined): Observable<CustomersFtpRes> {
        let url_ = this.baseUrl + "/CustomerSftpInfoDefinition/CustomersSftpInfoDefinition?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersSftpInfoDefinition2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersSftpInfoDefinition2(<any>response_);
                } catch (e) {
                    return <Observable<CustomersFtpRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomersFtpRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersSftpInfoDefinition2(response: HttpResponseBase): Observable<CustomersFtpRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomersFtpRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomersFtpRes>(<any>null);
    }

    /**
     * @return Success
     */
    customersSftpInfoDefinition3(id: number): Observable<CustomerFtpInfoDTO> {
        let url_ = this.baseUrl + "/v1/CustomerSftpInfoDefinition/CustomersSftpInfoDefinition/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersSftpInfoDefinition3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersSftpInfoDefinition3(<any>response_);
                } catch (e) {
                    return <Observable<CustomerFtpInfoDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerFtpInfoDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersSftpInfoDefinition3(response: HttpResponseBase): Observable<CustomerFtpInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFtpInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerFtpInfoDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    customersSftpInfoDefinition4(id: number, api_version: string | undefined): Observable<CustomerFtpInfoDTO> {
        let url_ = this.baseUrl + "/CustomerSftpInfoDefinition/CustomersSftpInfoDefinition/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersSftpInfoDefinition4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersSftpInfoDefinition4(<any>response_);
                } catch (e) {
                    return <Observable<CustomerFtpInfoDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerFtpInfoDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersSftpInfoDefinition4(response: HttpResponseBase): Observable<CustomerFtpInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerFtpInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerFtpInfoDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerFtp(body: AddCustomerFtpReq | undefined): Observable<AddCustomerFtpRes> {
        let url_ = this.baseUrl + "/v1/CustomerSftpInfoDefinition/AddCustomerFtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerFtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerFtp(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerFtpRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerFtpRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerFtp(response: HttpResponseBase): Observable<AddCustomerFtpRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerFtpRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddCustomerFtpRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerFtpRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerFtp2(api_version: string | undefined, body: AddCustomerFtpReq | undefined): Observable<AddCustomerFtpRes> {
        let url_ = this.baseUrl + "/CustomerSftpInfoDefinition/AddCustomerFtp?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerFtp2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerFtp2(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerFtpRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerFtpRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerFtp2(response: HttpResponseBase): Observable<AddCustomerFtpRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerFtpRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddCustomerFtpRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerFtpRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerFtp(body: UpdateCustomerFtpReq | undefined): Observable<UpdateCustomerFtpRes> {
        let url_ = this.baseUrl + "/v1/CustomerSftpInfoDefinition/UpdateCustomerFtp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerFtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerFtp(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerFtpRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerFtpRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerFtp(response: HttpResponseBase): Observable<UpdateCustomerFtpRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerFtpRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateCustomerFtpRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerFtpRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCustomerFtp2(api_version: string | undefined, body: UpdateCustomerFtpReq | undefined): Observable<UpdateCustomerFtpRes> {
        let url_ = this.baseUrl + "/CustomerSftpInfoDefinition/UpdateCustomerFtp?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerFtp2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerFtp2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerFtpRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerFtpRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerFtp2(response: HttpResponseBase): Observable<UpdateCustomerFtpRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerFtpRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateCustomerFtpRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerFtpRes>(<any>null);
    }

    /**
     * @return Success
     */
    deleteCustomerFtp(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/CustomerSftpInfoDefinition/DeleteCustomerFtp/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerFtp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerFtp(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustomerFtp(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteCustomerFtp2(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/CustomerSftpInfoDefinition/DeleteCustomerFtp/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerFtp2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerFtp2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustomerFtp2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about21(): Observable<string> {
        let url_ = this.baseUrl + "/v1/CustomerSftpInfoDefinition/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout21(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout21(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout21(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about22(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/CustomerSftpInfoDefinition/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout22(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout22(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout22(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    dashboardPartnersAndSubPartnersAll(): Observable<PartnerAndSubPartnerDTO[]> {
        let url_ = this.baseUrl + "/v1/Dashboard/DashboardPartnersAndSubPartners";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboardPartnersAndSubPartnersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboardPartnersAndSubPartnersAll(<any>response_);
                } catch (e) {
                    return <Observable<PartnerAndSubPartnerDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerAndSubPartnerDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processDashboardPartnersAndSubPartnersAll(response: HttpResponseBase): Observable<PartnerAndSubPartnerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerAndSubPartnerDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerAndSubPartnerDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    dashboardPartnersAndSubPartners(api_version: string | undefined): Observable<PartnerAndSubPartnerDTO[]> {
        let url_ = this.baseUrl + "/Dashboard/DashboardPartnersAndSubPartners?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboardPartnersAndSubPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboardPartnersAndSubPartners(<any>response_);
                } catch (e) {
                    return <Observable<PartnerAndSubPartnerDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerAndSubPartnerDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processDashboardPartnersAndSubPartners(response: HttpResponseBase): Observable<PartnerAndSubPartnerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerAndSubPartnerDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerAndSubPartnerDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerCustomers(body: PartnerCustomersReq | undefined): Observable<PartnerCustomersRes> {
        let url_ = this.baseUrl + "/v1/Dashboard/PartnerCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerCustomers(<any>response_);
                } catch (e) {
                    return <Observable<PartnerCustomersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerCustomersRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerCustomers(response: HttpResponseBase): Observable<PartnerCustomersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerCustomersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerCustomersRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerCustomers2(api_version: string | undefined, body: PartnerCustomersReq | undefined): Observable<PartnerCustomersRes> {
        let url_ = this.baseUrl + "/Dashboard/PartnerCustomers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerCustomers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerCustomers2(<any>response_);
                } catch (e) {
                    return <Observable<PartnerCustomersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerCustomersRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerCustomers2(response: HttpResponseBase): Observable<PartnerCustomersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerCustomersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerCustomersRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customersSearchAll(body: PartnerAndCustomersReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/v1/Dashboard/CustomersSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersSearchAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersSearchAll(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersSearchAll(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customersSearch(api_version: string | undefined, body: PartnerAndCustomersReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/Dashboard/CustomersSearch?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomersSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomersSearch(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processCustomersSearch(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    monthlyDocumentCount(body: MonthlyDocumentCountReq | undefined): Observable<MonthlyDocumentCountRes> {
        let url_ = this.baseUrl + "/v1/Dashboard/MonthlyDocumentCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyDocumentCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyDocumentCount(<any>response_);
                } catch (e) {
                    return <Observable<MonthlyDocumentCountRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<MonthlyDocumentCountRes>><any>_observableThrow(response_);
        }));
    }

    protected processMonthlyDocumentCount(response: HttpResponseBase): Observable<MonthlyDocumentCountRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyDocumentCountRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyDocumentCountRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    monthlyDocumentCount2(api_version: string | undefined, body: MonthlyDocumentCountReq | undefined): Observable<MonthlyDocumentCountRes> {
        let url_ = this.baseUrl + "/Dashboard/MonthlyDocumentCount?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyDocumentCount2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyDocumentCount2(<any>response_);
                } catch (e) {
                    return <Observable<MonthlyDocumentCountRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<MonthlyDocumentCountRes>><any>_observableThrow(response_);
        }));
    }

    protected processMonthlyDocumentCount2(response: HttpResponseBase): Observable<MonthlyDocumentCountRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyDocumentCountRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyDocumentCountRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contourHistory(body: ContourHistoryReq | undefined): Observable<ContourHistoryRes> {
        let url_ = this.baseUrl + "/v1/Dashboard/ContourHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContourHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContourHistory(<any>response_);
                } catch (e) {
                    return <Observable<ContourHistoryRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContourHistoryRes>><any>_observableThrow(response_);
        }));
    }

    protected processContourHistory(response: HttpResponseBase): Observable<ContourHistoryRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContourHistoryRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContourHistoryRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    contourHistory2(api_version: string | undefined, body: ContourHistoryReq | undefined): Observable<ContourHistoryRes> {
        let url_ = this.baseUrl + "/Dashboard/ContourHistory?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContourHistory2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContourHistory2(<any>response_);
                } catch (e) {
                    return <Observable<ContourHistoryRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContourHistoryRes>><any>_observableThrow(response_);
        }));
    }

    protected processContourHistory2(response: HttpResponseBase): Observable<ContourHistoryRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContourHistoryRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContourHistoryRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    monthlyAllServiceDocumentCount(body: MonthlyAllServicesDocumentCountReq | undefined): Observable<MonthlyDocumentCountRes> {
        let url_ = this.baseUrl + "/v1/Dashboard/MonthlyAllServiceDocumentCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyAllServiceDocumentCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyAllServiceDocumentCount(<any>response_);
                } catch (e) {
                    return <Observable<MonthlyDocumentCountRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<MonthlyDocumentCountRes>><any>_observableThrow(response_);
        }));
    }

    protected processMonthlyAllServiceDocumentCount(response: HttpResponseBase): Observable<MonthlyDocumentCountRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyDocumentCountRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyDocumentCountRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    monthlyAllServiceDocumentCount2(api_version: string | undefined, body: MonthlyAllServicesDocumentCountReq | undefined): Observable<MonthlyDocumentCountRes> {
        let url_ = this.baseUrl + "/Dashboard/MonthlyAllServiceDocumentCount?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMonthlyAllServiceDocumentCount2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyAllServiceDocumentCount2(<any>response_);
                } catch (e) {
                    return <Observable<MonthlyDocumentCountRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<MonthlyDocumentCountRes>><any>_observableThrow(response_);
        }));
    }

    protected processMonthlyAllServiceDocumentCount2(response: HttpResponseBase): Observable<MonthlyDocumentCountRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyDocumentCountRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MonthlyDocumentCountRes>(<any>null);
    }

    /**
     * @return Success
     */
    runLowContourMailToPartnerService(): Observable<RunLowContourMailToPartnerServiceResponse> {
        let url_ = this.baseUrl + "/v1/Dashboard/RunLowContourMailToPartnerService";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunLowContourMailToPartnerService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunLowContourMailToPartnerService(<any>response_);
                } catch (e) {
                    return <Observable<RunLowContourMailToPartnerServiceResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RunLowContourMailToPartnerServiceResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRunLowContourMailToPartnerService(response: HttpResponseBase): Observable<RunLowContourMailToPartnerServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunLowContourMailToPartnerServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RunLowContourMailToPartnerServiceResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    runLowContourMailToPartnerService2(api_version: string | undefined): Observable<RunLowContourMailToPartnerServiceResponse> {
        let url_ = this.baseUrl + "/Dashboard/RunLowContourMailToPartnerService?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunLowContourMailToPartnerService2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunLowContourMailToPartnerService2(<any>response_);
                } catch (e) {
                    return <Observable<RunLowContourMailToPartnerServiceResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<RunLowContourMailToPartnerServiceResponse>><any>_observableThrow(response_);
        }));
    }

    protected processRunLowContourMailToPartnerService2(response: HttpResponseBase): Observable<RunLowContourMailToPartnerServiceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RunLowContourMailToPartnerServiceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RunLowContourMailToPartnerServiceResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about23(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Dashboard/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout23(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout23(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout23(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about24(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Dashboard/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout24(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout24(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout24(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    countries(): Observable<CountriesRes> {
        let url_ = this.baseUrl + "/v1/Definition/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries(<any>response_);
                } catch (e) {
                    return <Observable<CountriesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountriesRes>><any>_observableThrow(response_);
        }));
    }

    protected processCountries(response: HttpResponseBase): Observable<CountriesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountriesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountriesRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    countries2(api_version: string | undefined): Observable<CountriesRes> {
        let url_ = this.baseUrl + "/Definition/Countries?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCountries2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCountries2(<any>response_);
                } catch (e) {
                    return <Observable<CountriesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountriesRes>><any>_observableThrow(response_);
        }));
    }

    protected processCountries2(response: HttpResponseBase): Observable<CountriesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountriesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountriesRes>(<any>null);
    }

    /**
     * @return Success
     */
    cities(countryId: number): Observable<CitiesRes> {
        let url_ = this.baseUrl + "/v1/Definition/Cities/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCities(<any>response_);
                } catch (e) {
                    return <Observable<CitiesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CitiesRes>><any>_observableThrow(response_);
        }));
    }

    protected processCities(response: HttpResponseBase): Observable<CitiesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CitiesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CitiesRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    cities2(countryId: number, api_version: string | undefined): Observable<CitiesRes> {
        let url_ = this.baseUrl + "/Definition/Cities/{countryId}?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCities2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCities2(<any>response_);
                } catch (e) {
                    return <Observable<CitiesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CitiesRes>><any>_observableThrow(response_);
        }));
    }

    protected processCities2(response: HttpResponseBase): Observable<CitiesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CitiesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CitiesRes>(<any>null);
    }

    /**
     * @return Success
     */
    citySubdivisions(cityId: number): Observable<CitySubdivisionsRes> {
        let url_ = this.baseUrl + "/v1/Definition/CitySubdivisions/{cityId}";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCitySubdivisions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCitySubdivisions(<any>response_);
                } catch (e) {
                    return <Observable<CitySubdivisionsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CitySubdivisionsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCitySubdivisions(response: HttpResponseBase): Observable<CitySubdivisionsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CitySubdivisionsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CitySubdivisionsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    citySubdivisions2(cityId: number, api_version: string | undefined): Observable<CitySubdivisionsRes> {
        let url_ = this.baseUrl + "/Definition/CitySubdivisions/{cityId}?";
        if (cityId === undefined || cityId === null)
            throw new Error("The parameter 'cityId' must be defined.");
        url_ = url_.replace("{cityId}", encodeURIComponent("" + cityId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCitySubdivisions2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCitySubdivisions2(<any>response_);
                } catch (e) {
                    return <Observable<CitySubdivisionsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CitySubdivisionsRes>><any>_observableThrow(response_);
        }));
    }

    protected processCitySubdivisions2(response: HttpResponseBase): Observable<CitySubdivisionsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CitySubdivisionsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CitySubdivisionsRes>(<any>null);
    }

    /**
     * @return Success
     */
    maxRecordCountListAll(): Observable<number[]> {
        let url_ = this.baseUrl + "/v1/Definition/MaxRecordCountList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaxRecordCountListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaxRecordCountListAll(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processMaxRecordCountListAll(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    maxRecordCountList(api_version: string | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/Definition/MaxRecordCountList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaxRecordCountList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaxRecordCountList(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processMaxRecordCountList(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    services4(body: ServicesReq | undefined): Observable<ServiceDTO[]> {
        let url_ = this.baseUrl + "/v1/Definition/Services";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServices4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServices4(<any>response_);
                } catch (e) {
                    return <Observable<ServiceDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processServices4(response: HttpResponseBase): Observable<ServiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    services5(api_version: string | undefined, body: ServicesReq | undefined): Observable<ServiceDTO[]> {
        let url_ = this.baseUrl + "/Definition/Services?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServices5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServices5(<any>response_);
                } catch (e) {
                    return <Observable<ServiceDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processServices5(response: HttpResponseBase): Observable<ServiceDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    routeTenantsAll(body: RouteTenantReq | undefined): Observable<RouteTenantDTO[]> {
        let url_ = this.baseUrl + "/v1/Definition/RouteTenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRouteTenantsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRouteTenantsAll(<any>response_);
                } catch (e) {
                    return <Observable<RouteTenantDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RouteTenantDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processRouteTenantsAll(response: HttpResponseBase): Observable<RouteTenantDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RouteTenantDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RouteTenantDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    routeTenants(api_version: string | undefined, body: RouteTenantReq | undefined): Observable<RouteTenantDTO[]> {
        let url_ = this.baseUrl + "/Definition/RouteTenants?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRouteTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRouteTenants(<any>response_);
                } catch (e) {
                    return <Observable<RouteTenantDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RouteTenantDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processRouteTenants(response: HttpResponseBase): Observable<RouteTenantDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RouteTenantDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RouteTenantDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerServices(body: CustomerServicesInfoReq | undefined): Observable<CustomerServicesInfoRes> {
        let url_ = this.baseUrl + "/v1/Definition/CustomerServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerServices(<any>response_);
                } catch (e) {
                    return <Observable<CustomerServicesInfoRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerServicesInfoRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerServices(response: HttpResponseBase): Observable<CustomerServicesInfoRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerServicesInfoRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerServicesInfoRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerServices2(api_version: string | undefined, body: CustomerServicesInfoReq | undefined): Observable<CustomerServicesInfoRes> {
        let url_ = this.baseUrl + "/Definition/CustomerServices?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerServices2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerServices2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerServicesInfoRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerServicesInfoRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerServices2(response: HttpResponseBase): Observable<CustomerServicesInfoRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerServicesInfoRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerServicesInfoRes>(<any>null);
    }

    /**
     * @return Success
     */
    about25(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Definition/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout25(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout25(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout25(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about26(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Definition/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout26(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout26(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout26(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentMapping(body: DocumentMappingReq | undefined): Observable<DocumentMappingRes> {
        let url_ = this.baseUrl + "/v1/DocumentMapping/DocumentMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentMapping(<any>response_);
                } catch (e) {
                    return <Observable<DocumentMappingRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentMappingRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentMapping(response: HttpResponseBase): Observable<DocumentMappingRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentMappingRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentMappingRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    documentMapping2(api_version: string | undefined, body: DocumentMappingReq | undefined): Observable<DocumentMappingRes> {
        let url_ = this.baseUrl + "/DocumentMapping/DocumentMapping?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentMapping2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentMapping2(<any>response_);
                } catch (e) {
                    return <Observable<DocumentMappingRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentMappingRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentMapping2(response: HttpResponseBase): Observable<DocumentMappingRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentMappingRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentMappingRes>(<any>null);
    }

    /**
     * @return Success
     */
    documentMappingDetail(id: number, customerId: string | null): Observable<DocumentMappingDetailDTO> {
        let url_ = this.baseUrl + "/v1/DocumentMapping/DocumentMappingDetail/{id}/{customerId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentMappingDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentMappingDetail(<any>response_);
                } catch (e) {
                    return <Observable<DocumentMappingDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentMappingDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentMappingDetail(response: HttpResponseBase): Observable<DocumentMappingDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentMappingDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentMappingDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    documentMappingDetail2(id: number, customerId: string | null, api_version: string | undefined): Observable<DocumentMappingDetailDTO> {
        let url_ = this.baseUrl + "/DocumentMapping/DocumentMappingDetail/{id}/{customerId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentMappingDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentMappingDetail2(<any>response_);
                } catch (e) {
                    return <Observable<DocumentMappingDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentMappingDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentMappingDetail2(response: HttpResponseBase): Observable<DocumentMappingDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentMappingDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentMappingDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDocumentMapping(body: AddDocumentMappingReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentMapping/AddDocumentMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentMapping(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocumentMapping(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addDocumentMapping2(api_version: string | undefined, body: AddDocumentMappingReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentMapping/AddDocumentMapping?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentMapping2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentMapping2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocumentMapping2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocumentMapping(body: UpdateDocumentMappingReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentMapping/UpdateDocumentMapping";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentMapping(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDocumentMapping(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateDocumentMapping2(api_version: string | undefined, body: UpdateDocumentMappingReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentMapping/UpdateDocumentMapping?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentMapping2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentMapping2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDocumentMapping2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    deleteDocumentMapping(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentMapping/DeleteDocumentMapping/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentMapping(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocumentMapping(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteDocumentMapping2(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentMapping/DeleteDocumentMapping/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentMapping2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentMapping2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocumentMapping2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about27(): Observable<string> {
        let url_ = this.baseUrl + "/v1/DocumentMapping/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout27(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout27(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout27(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about28(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/DocumentMapping/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout28(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout28(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout28(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentsPrefixes(body: DocumentPrefixReq | undefined): Observable<DocumentPrefixRes> {
        let url_ = this.baseUrl + "/v1/DocumentPrefix/DocumentsPrefixes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsPrefixes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsPrefixes(<any>response_);
                } catch (e) {
                    return <Observable<DocumentPrefixRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentPrefixRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentsPrefixes(response: HttpResponseBase): Observable<DocumentPrefixRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPrefixRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentPrefixRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    documentsPrefixes2(api_version: string | undefined, body: DocumentPrefixReq | undefined): Observable<DocumentPrefixRes> {
        let url_ = this.baseUrl + "/DocumentPrefix/DocumentsPrefixes?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentsPrefixes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentsPrefixes2(<any>response_);
                } catch (e) {
                    return <Observable<DocumentPrefixRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentPrefixRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentsPrefixes2(response: HttpResponseBase): Observable<DocumentPrefixRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPrefixRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentPrefixRes>(<any>null);
    }

    /**
     * @return Success
     */
    documentPrefixDetail(id: number, customerId: string | null): Observable<DocumentPrefixDetailDTO> {
        let url_ = this.baseUrl + "/v1/DocumentPrefix/DocumentPrefixDetail/{id}/{customerId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentPrefixDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentPrefixDetail(<any>response_);
                } catch (e) {
                    return <Observable<DocumentPrefixDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentPrefixDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentPrefixDetail(response: HttpResponseBase): Observable<DocumentPrefixDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPrefixDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentPrefixDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    documentPrefixDetail2(id: number, customerId: string | null, api_version: string | undefined): Observable<DocumentPrefixDetailDTO> {
        let url_ = this.baseUrl + "/DocumentPrefix/DocumentPrefixDetail/{id}/{customerId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentPrefixDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentPrefixDetail2(<any>response_);
                } catch (e) {
                    return <Observable<DocumentPrefixDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentPrefixDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentPrefixDetail2(response: HttpResponseBase): Observable<DocumentPrefixDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentPrefixDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentPrefixDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDocumentPrefix(body: AddDocumentPrefixReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentPrefix/AddDocumentPrefix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentPrefix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentPrefix(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocumentPrefix(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addDocumentPrefix2(api_version: string | undefined, body: AddDocumentPrefixReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentPrefix/AddDocumentPrefix?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentPrefix2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentPrefix2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocumentPrefix2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerCustomersInfoAll(body: DocumentPrefixPagePartnerCustomersReq | undefined): Observable<PartnerCustomersInfo[]> {
        let url_ = this.baseUrl + "/v1/DocumentPrefix/PartnerCustomersInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerCustomersInfoAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerCustomersInfoAll(<any>response_);
                } catch (e) {
                    return <Observable<PartnerCustomersInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerCustomersInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerCustomersInfoAll(response: HttpResponseBase): Observable<PartnerCustomersInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerCustomersInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerCustomersInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerCustomersInfo(api_version: string | undefined, body: DocumentPrefixPagePartnerCustomersReq | undefined): Observable<PartnerCustomersInfo[]> {
        let url_ = this.baseUrl + "/DocumentPrefix/PartnerCustomersInfo?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerCustomersInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerCustomersInfo(<any>response_);
                } catch (e) {
                    return <Observable<PartnerCustomersInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerCustomersInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerCustomersInfo(response: HttpResponseBase): Observable<PartnerCustomersInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerCustomersInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerCustomersInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocumentPrefix(body: UpdateDocumentPrefixReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentPrefix/UpdateDocumentPrefix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentPrefix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentPrefix(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDocumentPrefix(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateDocumentPrefix2(api_version: string | undefined, body: UpdateDocumentPrefixReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentPrefix/UpdateDocumentPrefix?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocumentPrefix2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocumentPrefix2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDocumentPrefix2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    deleteDocumentPrefix(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentPrefix/DeleteDocumentPrefix/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentPrefix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentPrefix(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocumentPrefix(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteDocumentPrefix2(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentPrefix/DeleteDocumentPrefix/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocumentPrefix2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocumentPrefix2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocumentPrefix2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    controlDocumentPrefixNumber(body: ControlDocumentPrefixNumberReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentPrefix/ControlDocumentPrefixNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processControlDocumentPrefixNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processControlDocumentPrefixNumber(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processControlDocumentPrefixNumber(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    controlDocumentPrefixNumber2(api_version: string | undefined, body: ControlDocumentPrefixNumberReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentPrefix/ControlDocumentPrefixNumber?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processControlDocumentPrefixNumber2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processControlDocumentPrefixNumber2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processControlDocumentPrefixNumber2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about29(): Observable<string> {
        let url_ = this.baseUrl + "/v1/DocumentPrefix/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout29(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout29(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout29(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about30(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/DocumentPrefix/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout30(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout30(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout30(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentXslt(body: XsltDocumentsReq | undefined): Observable<XsltDocumentsRes> {
        let url_ = this.baseUrl + "/v1/DocumentXslt/DocumentXslt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentXslt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentXslt(<any>response_);
                } catch (e) {
                    return <Observable<XsltDocumentsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<XsltDocumentsRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentXslt(response: HttpResponseBase): Observable<XsltDocumentsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = XsltDocumentsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<XsltDocumentsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    documentXslt2(api_version: string | undefined, body: XsltDocumentsReq | undefined): Observable<XsltDocumentsRes> {
        let url_ = this.baseUrl + "/DocumentXslt/DocumentXslt?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentXslt2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentXslt2(<any>response_);
                } catch (e) {
                    return <Observable<XsltDocumentsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<XsltDocumentsRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentXslt2(response: HttpResponseBase): Observable<XsltDocumentsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = XsltDocumentsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<XsltDocumentsRes>(<any>null);
    }

    /**
     * @return Success
     */
    documentXsltDetail(id: number, customerId: string | null): Observable<XsltDocumentsDetailDTO> {
        let url_ = this.baseUrl + "/v1/DocumentXslt/DocumentXsltDetail/{id}/{customerId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentXsltDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentXsltDetail(<any>response_);
                } catch (e) {
                    return <Observable<XsltDocumentsDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<XsltDocumentsDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentXsltDetail(response: HttpResponseBase): Observable<XsltDocumentsDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = XsltDocumentsDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<XsltDocumentsDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    documentXsltDetail2(id: number, customerId: string | null, api_version: string | undefined): Observable<XsltDocumentsDetailDTO> {
        let url_ = this.baseUrl + "/DocumentXslt/DocumentXsltDetail/{id}/{customerId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocumentXsltDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocumentXsltDetail2(<any>response_);
                } catch (e) {
                    return <Observable<XsltDocumentsDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<XsltDocumentsDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocumentXsltDetail2(response: HttpResponseBase): Observable<XsltDocumentsDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = XsltDocumentsDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<XsltDocumentsDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDocumentXslt(body: AddXsltDocumentsReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentXslt/AddDocumentXslt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentXslt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentXslt(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocumentXslt(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addDocumentXslt2(api_version: string | undefined, body: AddXsltDocumentsReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentXslt/AddDocumentXslt?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocumentXslt2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocumentXslt2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocumentXslt2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateXsltDocument(body: UpdateXsltDocumentsReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentXslt/UpdateXsltDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateXsltDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateXsltDocument(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateXsltDocument(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateXsltDocument2(api_version: string | undefined, body: UpdateXsltDocumentsReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentXslt/UpdateXsltDocument?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateXsltDocument2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateXsltDocument2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateXsltDocument2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPaymentInfoToXsltDocument(body: AddPaymentInfoToXsltDocumentReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/DocumentXslt/AddPaymentInfoToXsltDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPaymentInfoToXsltDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPaymentInfoToXsltDocument(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddPaymentInfoToXsltDocument(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addPaymentInfoToXsltDocument2(api_version: string | undefined, body: AddPaymentInfoToXsltDocumentReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/DocumentXslt/AddPaymentInfoToXsltDocument?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPaymentInfoToXsltDocument2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPaymentInfoToXsltDocument2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddPaymentInfoToXsltDocument2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getPaymentInfoFromXsltDocument(xsltId: number, customerId: string | null): Observable<GetPaymentInfoFromXsltDocumentRes> {
        let url_ = this.baseUrl + "/v1/DocumentXslt/GetPaymentInfoFromXsltDocument/{xsltId}/{customerId}";
        if (xsltId === undefined || xsltId === null)
            throw new Error("The parameter 'xsltId' must be defined.");
        url_ = url_.replace("{xsltId}", encodeURIComponent("" + xsltId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfoFromXsltDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfoFromXsltDocument(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentInfoFromXsltDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentInfoFromXsltDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentInfoFromXsltDocument(response: HttpResponseBase): Observable<GetPaymentInfoFromXsltDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentInfoFromXsltDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentInfoFromXsltDocumentRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getPaymentInfoFromXsltDocument2(xsltId: number, customerId: string | null, api_version: string | undefined): Observable<GetPaymentInfoFromXsltDocumentRes> {
        let url_ = this.baseUrl + "/DocumentXslt/GetPaymentInfoFromXsltDocument/{xsltId}/{customerId}?";
        if (xsltId === undefined || xsltId === null)
            throw new Error("The parameter 'xsltId' must be defined.");
        url_ = url_.replace("{xsltId}", encodeURIComponent("" + xsltId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfoFromXsltDocument2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfoFromXsltDocument2(<any>response_);
                } catch (e) {
                    return <Observable<GetPaymentInfoFromXsltDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetPaymentInfoFromXsltDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentInfoFromXsltDocument2(response: HttpResponseBase): Observable<GetPaymentInfoFromXsltDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentInfoFromXsltDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentInfoFromXsltDocumentRes>(<any>null);
    }

    /**
     * @return Success
     */
    about31(): Observable<string> {
        let url_ = this.baseUrl + "/v1/DocumentXslt/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout31(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout31(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout31(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about32(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/DocumentXslt/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout32(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout32(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout32(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @return Success
     */
    gibAppServerServerListAll(): Observable<ELedgerGibAppServerDTO[]> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/GibAppServerServerList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerServerListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerServerListAll(<any>response_);
                } catch (e) {
                    return <Observable<ELedgerGibAppServerDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ELedgerGibAppServerDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerServerListAll(response: HttpResponseBase): Observable<ELedgerGibAppServerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ELedgerGibAppServerDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ELedgerGibAppServerDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    gibAppServerServerList(api_version: string | undefined): Observable<ELedgerGibAppServerDTO[]> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/GibAppServerServerList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerServerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerServerList(<any>response_);
                } catch (e) {
                    return <Observable<ELedgerGibAppServerDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ELedgerGibAppServerDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerServerList(response: HttpResponseBase): Observable<ELedgerGibAppServerDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ELedgerGibAppServerDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ELedgerGibAppServerDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    gibAppServerServerList2(id: number): Observable<ELedgerGibAppServerDTO> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/GibAppServerServerList/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerServerList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerServerList2(<any>response_);
                } catch (e) {
                    return <Observable<ELedgerGibAppServerDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ELedgerGibAppServerDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerServerList2(response: HttpResponseBase): Observable<ELedgerGibAppServerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ELedgerGibAppServerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ELedgerGibAppServerDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    gibAppServerServerList3(id: number, api_version: string | undefined): Observable<ELedgerGibAppServerDTO> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/GibAppServerServerList/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerServerList3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerServerList3(<any>response_);
                } catch (e) {
                    return <Observable<ELedgerGibAppServerDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<ELedgerGibAppServerDTO>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerServerList3(response: HttpResponseBase): Observable<ELedgerGibAppServerDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ELedgerGibAppServerDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ELedgerGibAppServerDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    gibAppServerAddServer(body: GibAppServerAddServerReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/GibAppServerAddServer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerAddServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerAddServer(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerAddServer(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    gibAppServerAddServer2(api_version: string | undefined, body: GibAppServerAddServerReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/GibAppServerAddServer?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerAddServer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerAddServer2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerAddServer2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    gibAppServerUpdateServer(body: GibAppServerUpdateServerReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/GibAppServerUpdateServer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerUpdateServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerUpdateServer(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerUpdateServer(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    gibAppServerUpdateServer2(api_version: string | undefined, body: GibAppServerUpdateServerReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/GibAppServerUpdateServer?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerUpdateServer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerUpdateServer2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerUpdateServer2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    gibAppServerDeleteServer(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/GibAppServerDeleteServer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerDeleteServer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerDeleteServer(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerDeleteServer(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    gibAppServerDeleteServer2(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/GibAppServerDeleteServer/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGibAppServerDeleteServer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGibAppServerDeleteServer2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGibAppServerDeleteServer2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    eLedgerArchiveCustomersListAll(body: ELedgerArchiveCustomersListReq | undefined): Observable<ELedgerArchiveCustomerInfoDTO[]> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/ELedgerArchiveCustomersList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processELedgerArchiveCustomersListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processELedgerArchiveCustomersListAll(<any>response_);
                } catch (e) {
                    return <Observable<ELedgerArchiveCustomerInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ELedgerArchiveCustomerInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processELedgerArchiveCustomersListAll(response: HttpResponseBase): Observable<ELedgerArchiveCustomerInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ELedgerArchiveCustomerInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ELedgerArchiveCustomerInfoDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    eLedgerArchiveCustomersList(api_version: string | undefined, body: ELedgerArchiveCustomersListReq | undefined): Observable<ELedgerArchiveCustomerInfoDTO[]> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/ELedgerArchiveCustomersList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processELedgerArchiveCustomersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processELedgerArchiveCustomersList(<any>response_);
                } catch (e) {
                    return <Observable<ELedgerArchiveCustomerInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ELedgerArchiveCustomerInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processELedgerArchiveCustomersList(response: HttpResponseBase): Observable<ELedgerArchiveCustomerInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ELedgerArchiveCustomerInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ELedgerArchiveCustomerInfoDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerGibAppServersList(body: CustomerGibAppServersListReq | undefined): Observable<CustomerGibAppServersListRes> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/CustomerGibAppServersList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGibAppServersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGibAppServersList(<any>response_);
                } catch (e) {
                    return <Observable<CustomerGibAppServersListRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerGibAppServersListRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerGibAppServersList(response: HttpResponseBase): Observable<CustomerGibAppServersListRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerGibAppServersListRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerGibAppServersListRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerGibAppServersList2(api_version: string | undefined, body: CustomerGibAppServersListReq | undefined): Observable<CustomerGibAppServersListRes> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/CustomerGibAppServersList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGibAppServersList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGibAppServersList2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerGibAppServersListRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerGibAppServersListRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerGibAppServersList2(response: HttpResponseBase): Observable<CustomerGibAppServersListRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerGibAppServersListRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerGibAppServersListRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerGibAppServersAddOrUpdateCustomer(body: CustomerGibAppServersAddOrUpdateCustomerReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/CustomerGibAppServersAddOrUpdateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGibAppServersAddOrUpdateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGibAppServersAddOrUpdateCustomer(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerGibAppServersAddOrUpdateCustomer(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerGibAppServersAddOrUpdateCustomer2(api_version: string | undefined, body: CustomerGibAppServersAddOrUpdateCustomerReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/CustomerGibAppServersAddOrUpdateCustomer?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerGibAppServersAddOrUpdateCustomer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerGibAppServersAddOrUpdateCustomer2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerGibAppServersAddOrUpdateCustomer2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about33(): Observable<string> {
        let url_ = this.baseUrl + "/v1/ELedgerGibAppServer/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout33(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout33(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout33(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about34(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/ELedgerGibAppServer/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout34(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout34(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout34(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    outgoingFields(body: OutgoingFieldsReq | undefined): Observable<OutgoingFieldsRes> {
        let url_ = this.baseUrl + "/v1/OutgoingAdditionalFields/OutgoingFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOutgoingFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOutgoingFields(<any>response_);
                } catch (e) {
                    return <Observable<OutgoingFieldsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutgoingFieldsRes>><any>_observableThrow(response_);
        }));
    }

    protected processOutgoingFields(response: HttpResponseBase): Observable<OutgoingFieldsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutgoingFieldsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutgoingFieldsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    outgoingFields2(api_version: string | undefined, body: OutgoingFieldsReq | undefined): Observable<OutgoingFieldsRes> {
        let url_ = this.baseUrl + "/OutgoingAdditionalFields/OutgoingFields?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOutgoingFields2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOutgoingFields2(<any>response_);
                } catch (e) {
                    return <Observable<OutgoingFieldsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<OutgoingFieldsRes>><any>_observableThrow(response_);
        }));
    }

    protected processOutgoingFields2(response: HttpResponseBase): Observable<OutgoingFieldsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OutgoingFieldsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutgoingFieldsRes>(<any>null);
    }

    /**
     * @return Success
     */
    outgoingFields3(id: number): Observable<AdditionalFieldsDTO> {
        let url_ = this.baseUrl + "/v1/OutgoingAdditionalFields/OutgoingFields/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOutgoingFields3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOutgoingFields3(<any>response_);
                } catch (e) {
                    return <Observable<AdditionalFieldsDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdditionalFieldsDTO>><any>_observableThrow(response_);
        }));
    }

    protected processOutgoingFields3(response: HttpResponseBase): Observable<AdditionalFieldsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdditionalFieldsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdditionalFieldsDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    outgoingFields4(id: number, api_version: string | undefined): Observable<AdditionalFieldsDTO> {
        let url_ = this.baseUrl + "/OutgoingAdditionalFields/OutgoingFields/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOutgoingFields4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOutgoingFields4(<any>response_);
                } catch (e) {
                    return <Observable<AdditionalFieldsDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<AdditionalFieldsDTO>><any>_observableThrow(response_);
        }));
    }

    protected processOutgoingFields4(response: HttpResponseBase): Observable<AdditionalFieldsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdditionalFieldsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AdditionalFieldsDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOutgoingFields(body: AddOutgoingFieldReq | undefined): Observable<AddOutgoingFieldRes> {
        let url_ = this.baseUrl + "/v1/OutgoingAdditionalFields/AddOutgoingFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOutgoingFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOutgoingFields(<any>response_);
                } catch (e) {
                    return <Observable<AddOutgoingFieldRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddOutgoingFieldRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddOutgoingFields(response: HttpResponseBase): Observable<AddOutgoingFieldRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddOutgoingFieldRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddOutgoingFieldRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addOutgoingFields2(api_version: string | undefined, body: AddOutgoingFieldReq | undefined): Observable<AddOutgoingFieldRes> {
        let url_ = this.baseUrl + "/OutgoingAdditionalFields/AddOutgoingFields?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOutgoingFields2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOutgoingFields2(<any>response_);
                } catch (e) {
                    return <Observable<AddOutgoingFieldRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddOutgoingFieldRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddOutgoingFields2(response: HttpResponseBase): Observable<AddOutgoingFieldRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddOutgoingFieldRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddOutgoingFieldRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOutgoingFields(body: UpdateOutgoingFieldReq | undefined): Observable<UpdateOutgoingFieldRes> {
        let url_ = this.baseUrl + "/v1/OutgoingAdditionalFields/UpdateOutgoingFields";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOutgoingFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOutgoingFields(<any>response_);
                } catch (e) {
                    return <Observable<UpdateOutgoingFieldRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateOutgoingFieldRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOutgoingFields(response: HttpResponseBase): Observable<UpdateOutgoingFieldRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateOutgoingFieldRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateOutgoingFieldRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateOutgoingFields2(api_version: string | undefined, body: UpdateOutgoingFieldReq | undefined): Observable<UpdateOutgoingFieldRes> {
        let url_ = this.baseUrl + "/OutgoingAdditionalFields/UpdateOutgoingFields?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOutgoingFields2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOutgoingFields2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateOutgoingFieldRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateOutgoingFieldRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateOutgoingFields2(response: HttpResponseBase): Observable<UpdateOutgoingFieldRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateOutgoingFieldRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateOutgoingFieldRes>(<any>null);
    }

    /**
     * @return Success
     */
    deleteOutgoingFields(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/OutgoingAdditionalFields/DeleteOutgoingFields/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOutgoingFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOutgoingFields(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOutgoingFields(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteOutgoingFields2(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/OutgoingAdditionalFields/DeleteOutgoingFields/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOutgoingFields2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOutgoingFields2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteOutgoingFields2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about35(): Observable<string> {
        let url_ = this.baseUrl + "/v1/OutgoingAdditionalFields/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout35(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout35(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout35(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about36(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/OutgoingAdditionalFields/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout36(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout36(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout36(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partners(body: PartnersReq | undefined): Observable<PartnersRes> {
        let url_ = this.baseUrl + "/v1/Partner/Partners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners(<any>response_);
                } catch (e) {
                    return <Observable<PartnersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnersRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartners(response: HttpResponseBase): Observable<PartnersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnersRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partners2(api_version: string | undefined, body: PartnersReq | undefined): Observable<PartnersRes> {
        let url_ = this.baseUrl + "/Partner/Partners?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartners2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartners2(<any>response_);
                } catch (e) {
                    return <Observable<PartnersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnersRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartners2(response: HttpResponseBase): Observable<PartnersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnersRes>(<any>null);
    }

    /**
     * @return Success
     */
    partnerDetail(id: string | null): Observable<PartnerDetailDTO> {
        let url_ = this.baseUrl + "/v1/Partner/PartnerDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerDetail(<any>response_);
                } catch (e) {
                    return <Observable<PartnerDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerDetail(response: HttpResponseBase): Observable<PartnerDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    partnerDetail2(id: string | null, api_version: string | undefined): Observable<PartnerDetailDTO> {
        let url_ = this.baseUrl + "/Partner/PartnerDetail/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerDetail2(<any>response_);
                } catch (e) {
                    return <Observable<PartnerDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerDetail2(response: HttpResponseBase): Observable<PartnerDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPartner(body: AddPartnerReq | undefined): Observable<AddPartnerRes> {
        let url_ = this.baseUrl + "/v1/Partner/AddPartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPartner(<any>response_);
                } catch (e) {
                    return <Observable<AddPartnerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPartnerRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddPartner(response: HttpResponseBase): Observable<AddPartnerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPartnerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPartnerRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addPartner2(api_version: string | undefined, body: AddPartnerReq | undefined): Observable<AddPartnerRes> {
        let url_ = this.baseUrl + "/Partner/AddPartner?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPartner2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPartner2(<any>response_);
                } catch (e) {
                    return <Observable<AddPartnerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPartnerRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddPartner2(response: HttpResponseBase): Observable<AddPartnerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPartnerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPartnerRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePartner(body: UpdatePartnerReq | undefined): Observable<UpdatePartnerRes> {
        let url_ = this.baseUrl + "/v1/Partner/UpdatePartner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartner(<any>response_);
                } catch (e) {
                    return <Observable<UpdatePartnerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdatePartnerRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePartner(response: HttpResponseBase): Observable<UpdatePartnerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePartnerRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePartner2(api_version: string | undefined, body: UpdatePartnerReq | undefined): Observable<UpdatePartnerRes> {
        let url_ = this.baseUrl + "/Partner/UpdatePartner?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartner2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartner2(<any>response_);
                } catch (e) {
                    return <Observable<UpdatePartnerRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdatePartnerRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePartner2(response: HttpResponseBase): Observable<UpdatePartnerRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePartnerRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPartnerSummaryInfo(body: AddPartnerSummaryInfoReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/Partner/AddPartnerSummaryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPartnerSummaryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPartnerSummaryInfo(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddPartnerSummaryInfo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addPartnerSummaryInfo2(api_version: string | undefined, body: AddPartnerSummaryInfoReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/Partner/AddPartnerSummaryInfo?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPartnerSummaryInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPartnerSummaryInfo2(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddPartnerSummaryInfo2(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePartnerSummaryInfo(body: UpdatePartnerSummaryInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Partner/UpdatePartnerSummaryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartnerSummaryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartnerSummaryInfo(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePartnerSummaryInfo(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePartnerSummaryInfo2(api_version: string | undefined, body: UpdatePartnerSummaryInfoReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Partner/UpdatePartnerSummaryInfo?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartnerSummaryInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartnerSummaryInfo2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePartnerSummaryInfo2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    partnerSummaryInfoDetail(id: string | null): Observable<PartnerSummaryInfoDTO> {
        let url_ = this.baseUrl + "/v1/Partner/PartnerSummaryInfoDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerSummaryInfoDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerSummaryInfoDetail(<any>response_);
                } catch (e) {
                    return <Observable<PartnerSummaryInfoDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerSummaryInfoDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerSummaryInfoDetail(response: HttpResponseBase): Observable<PartnerSummaryInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerSummaryInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerSummaryInfoDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    partnerSummaryInfoDetail2(id: string | null, api_version: string | undefined): Observable<PartnerSummaryInfoDTO> {
        let url_ = this.baseUrl + "/Partner/PartnerSummaryInfoDetail/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerSummaryInfoDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerSummaryInfoDetail2(<any>response_);
                } catch (e) {
                    return <Observable<PartnerSummaryInfoDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerSummaryInfoDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerSummaryInfoDetail2(response: HttpResponseBase): Observable<PartnerSummaryInfoDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerSummaryInfoDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerSummaryInfoDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getArchiveReport(body: GetArchiveReportRequest | undefined): Observable<GetArchiveReportResults> {
        let url_ = this.baseUrl + "/v1/Partner/GetArchiveReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchiveReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchiveReport(<any>response_);
                } catch (e) {
                    return <Observable<GetArchiveReportResults>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArchiveReportResults>><any>_observableThrow(response_);
        }));
    }

    protected processGetArchiveReport(response: HttpResponseBase): Observable<GetArchiveReportResults> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArchiveReportResults.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArchiveReportResults>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    getArchiveReport2(api_version: string | undefined, body: GetArchiveReportRequest | undefined): Observable<GetArchiveReportResults> {
        let url_ = this.baseUrl + "/Partner/GetArchiveReport?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchiveReport2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchiveReport2(<any>response_);
                } catch (e) {
                    return <Observable<GetArchiveReportResults>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetArchiveReportResults>><any>_observableThrow(response_);
        }));
    }

    protected processGetArchiveReport2(response: HttpResponseBase): Observable<GetArchiveReportResults> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetArchiveReportResults.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetArchiveReportResults>(<any>null);
    }

    /**
     * @return Success
     */
    about37(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Partner/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout37(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout37(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout37(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about38(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Partner/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout38(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout38(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout38(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    avaiablePartnerAgreements2(body: AvaiablePartnerContourAgreementsReq | undefined): Observable<AgreementsInfoDTO[]> {
        let url_ = this.baseUrl + "/v1/PartnerContours/AvaiablePartnerAgreements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvaiablePartnerAgreements2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvaiablePartnerAgreements2(<any>response_);
                } catch (e) {
                    return <Observable<AgreementsInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgreementsInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvaiablePartnerAgreements2(response: HttpResponseBase): Observable<AgreementsInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementsInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgreementsInfoDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    avaiablePartnerAgreements3(api_version: string | undefined, body: AvaiablePartnerContourAgreementsReq | undefined): Observable<AgreementsInfoDTO[]> {
        let url_ = this.baseUrl + "/PartnerContours/AvaiablePartnerAgreements?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAvaiablePartnerAgreements3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAvaiablePartnerAgreements3(<any>response_);
                } catch (e) {
                    return <Observable<AgreementsInfoDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AgreementsInfoDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processAvaiablePartnerAgreements3(response: HttpResponseBase): Observable<AgreementsInfoDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementsInfoDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AgreementsInfoDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerContoursPartnersAll(body: PartnersForContourReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/v1/PartnerContours/PartnerContoursPartners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerContoursPartnersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerContoursPartnersAll(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerContoursPartnersAll(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerContoursPartners(api_version: string | undefined, body: PartnersForContourReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/PartnerContours/PartnerContoursPartners?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerContoursPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerContoursPartners(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerContoursPartners(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documents5(body: PartnerContoursDocumentsReq | undefined): Observable<PartnerContoursDocumentsRes> {
        let url_ = this.baseUrl + "/v1/PartnerContours/Documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocuments5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocuments5(<any>response_);
                } catch (e) {
                    return <Observable<PartnerContoursDocumentsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerContoursDocumentsRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocuments5(response: HttpResponseBase): Observable<PartnerContoursDocumentsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerContoursDocumentsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerContoursDocumentsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    documents6(api_version: string | undefined, body: PartnerContoursDocumentsReq | undefined): Observable<PartnerContoursDocumentsRes> {
        let url_ = this.baseUrl + "/PartnerContours/Documents?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocuments6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocuments6(<any>response_);
                } catch (e) {
                    return <Observable<PartnerContoursDocumentsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerContoursDocumentsRes>><any>_observableThrow(response_);
        }));
    }

    protected processDocuments6(response: HttpResponseBase): Observable<PartnerContoursDocumentsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerContoursDocumentsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerContoursDocumentsRes>(<any>null);
    }

    /**
     * @return Success
     */
    documents7(id: number): Observable<PartnerContourDocumentDTO> {
        let url_ = this.baseUrl + "/v1/PartnerContours/Documents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocuments7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocuments7(<any>response_);
                } catch (e) {
                    return <Observable<PartnerContourDocumentDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerContourDocumentDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocuments7(response: HttpResponseBase): Observable<PartnerContourDocumentDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerContourDocumentDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerContourDocumentDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    documents8(id: number, api_version: string | undefined): Observable<PartnerContourDocumentDTO> {
        let url_ = this.baseUrl + "/PartnerContours/Documents/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocuments8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocuments8(<any>response_);
                } catch (e) {
                    return <Observable<PartnerContourDocumentDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerContourDocumentDTO>><any>_observableThrow(response_);
        }));
    }

    protected processDocuments8(response: HttpResponseBase): Observable<PartnerContourDocumentDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerContourDocumentDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerContourDocumentDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addDocument3(body: AddPartnerContourDocumentReq | undefined): Observable<AddPartnerContourDocumentRes> {
        let url_ = this.baseUrl + "/v1/PartnerContours/AddDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument3(<any>response_);
                } catch (e) {
                    return <Observable<AddPartnerContourDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPartnerContourDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocument3(response: HttpResponseBase): Observable<AddPartnerContourDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPartnerContourDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPartnerContourDocumentRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addDocument4(api_version: string | undefined, body: AddPartnerContourDocumentReq | undefined): Observable<AddPartnerContourDocumentRes> {
        let url_ = this.baseUrl + "/PartnerContours/AddDocument?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument4(<any>response_);
                } catch (e) {
                    return <Observable<AddPartnerContourDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddPartnerContourDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddDocument4(response: HttpResponseBase): Observable<AddPartnerContourDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPartnerContourDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPartnerContourDocumentRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDocument3(body: UpdatePartnerContourDocumentReq | undefined): Observable<UpdatePartnerContourDocumentRes> {
        let url_ = this.baseUrl + "/v1/PartnerContours/UpdateDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocument3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocument3(<any>response_);
                } catch (e) {
                    return <Observable<UpdatePartnerContourDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdatePartnerContourDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDocument3(response: HttpResponseBase): Observable<UpdatePartnerContourDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerContourDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePartnerContourDocumentRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateDocument4(api_version: string | undefined, body: UpdatePartnerContourDocumentReq | undefined): Observable<UpdatePartnerContourDocumentRes> {
        let url_ = this.baseUrl + "/PartnerContours/UpdateDocument?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocument4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocument4(<any>response_);
                } catch (e) {
                    return <Observable<UpdatePartnerContourDocumentRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdatePartnerContourDocumentRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateDocument4(response: HttpResponseBase): Observable<UpdatePartnerContourDocumentRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePartnerContourDocumentRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePartnerContourDocumentRes>(<any>null);
    }

    /**
     * @return Success
     */
    deleteDocument3(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/PartnerContours/DeleteDocument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument3(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocument3(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteDocument4(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/PartnerContours/DeleteDocument/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument4(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteDocument4(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about39(): Observable<string> {
        let url_ = this.baseUrl + "/v1/PartnerContours/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout39(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout39(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about40(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/PartnerContours/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout40(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout40(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout40(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerRouteTenantsPartners(body: FilterRequest | undefined): Observable<PartnerRouteTenantsPartnersRes> {
        let url_ = this.baseUrl + "/v1/PartnerRouteTenants/PartnerRouteTenantsPartners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerRouteTenantsPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerRouteTenantsPartners(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantsPartnersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantsPartnersRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerRouteTenantsPartners(response: HttpResponseBase): Observable<PartnerRouteTenantsPartnersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantsPartnersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantsPartnersRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerRouteTenantsPartners2(api_version: string | undefined, body: FilterRequest | undefined): Observable<PartnerRouteTenantsPartnersRes> {
        let url_ = this.baseUrl + "/PartnerRouteTenants/PartnerRouteTenantsPartners?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerRouteTenantsPartners2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerRouteTenantsPartners2(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantsPartnersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantsPartnersRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerRouteTenantsPartners2(response: HttpResponseBase): Observable<PartnerRouteTenantsPartnersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantsPartnersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantsPartnersRes>(<any>null);
    }

    /**
     * @return Success
     */
    partnerRouteTenants(): Observable<PartnerRouteTenantsRes> {
        let url_ = this.baseUrl + "/v1/PartnerRouteTenants/PartnerRouteTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerRouteTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerRouteTenants(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantsRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerRouteTenants(response: HttpResponseBase): Observable<PartnerRouteTenantsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    partnerRouteTenants2(api_version: string | undefined): Observable<PartnerRouteTenantsRes> {
        let url_ = this.baseUrl + "/PartnerRouteTenants/PartnerRouteTenants?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerRouteTenants2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerRouteTenants2(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantsRes>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerRouteTenants2(response: HttpResponseBase): Observable<PartnerRouteTenantsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantsRes>(<any>null);
    }

    /**
     * @return Success
     */
    partnerRouteTenants3(id: number): Observable<PartnerRouteTenantsDTO> {
        let url_ = this.baseUrl + "/v1/PartnerRouteTenants/PartnerRouteTenants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerRouteTenants3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerRouteTenants3(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantsDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantsDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerRouteTenants3(response: HttpResponseBase): Observable<PartnerRouteTenantsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantsDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    partnerRouteTenants4(id: number, api_version: string | undefined): Observable<PartnerRouteTenantsDTO> {
        let url_ = this.baseUrl + "/PartnerRouteTenants/PartnerRouteTenants/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerRouteTenants4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerRouteTenants4(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantsDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantsDTO>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerRouteTenants4(response: HttpResponseBase): Observable<PartnerRouteTenantsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantsDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPartnerRouteTenant(body: PartnerRouteTenantReq | undefined): Observable<PartnerRouteTenantRes> {
        let url_ = this.baseUrl + "/v1/PartnerRouteTenants/AddPartnerRouteTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPartnerRouteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPartnerRouteTenant(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddPartnerRouteTenant(response: HttpResponseBase): Observable<PartnerRouteTenantRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = PartnerRouteTenantRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addPartnerRouteTenant2(api_version: string | undefined, body: PartnerRouteTenantReq | undefined): Observable<PartnerRouteTenantRes> {
        let url_ = this.baseUrl + "/PartnerRouteTenants/AddPartnerRouteTenant?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPartnerRouteTenant2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPartnerRouteTenant2(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddPartnerRouteTenant2(response: HttpResponseBase): Observable<PartnerRouteTenantRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = PartnerRouteTenantRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePartnerRouteTenant(body: PartnerRouteTenantReq | undefined): Observable<PartnerRouteTenantRes> {
        let url_ = this.baseUrl + "/v1/PartnerRouteTenants/UpdatePartnerRouteTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartnerRouteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartnerRouteTenant(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePartnerRouteTenant(response: HttpResponseBase): Observable<PartnerRouteTenantRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = PartnerRouteTenantRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updatePartnerRouteTenant2(api_version: string | undefined, body: PartnerRouteTenantReq | undefined): Observable<PartnerRouteTenantRes> {
        let url_ = this.baseUrl + "/PartnerRouteTenants/UpdatePartnerRouteTenant?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePartnerRouteTenant2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePartnerRouteTenant2(<any>response_);
                } catch (e) {
                    return <Observable<PartnerRouteTenantRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<PartnerRouteTenantRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePartnerRouteTenant2(response: HttpResponseBase): Observable<PartnerRouteTenantRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerRouteTenantRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = PartnerRouteTenantRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PartnerRouteTenantRes>(<any>null);
    }

    /**
     * @return Success
     */
    about41(): Observable<string> {
        let url_ = this.baseUrl + "/v1/PartnerRouteTenants/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout41(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout41(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout41(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about42(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/PartnerRouteTenants/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout42(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout42(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout42(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    users(body: UsersReq | undefined): Observable<UsersRes> {
        let url_ = this.baseUrl + "/v1/PartnerUser/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers(<any>response_);
                } catch (e) {
                    return <Observable<UsersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UsersRes>><any>_observableThrow(response_);
        }));
    }

    protected processUsers(response: HttpResponseBase): Observable<UsersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UsersRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    users2(api_version: string | undefined, body: UsersReq | undefined): Observable<UsersRes> {
        let url_ = this.baseUrl + "/PartnerUser/Users?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers2(<any>response_);
                } catch (e) {
                    return <Observable<UsersRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UsersRes>><any>_observableThrow(response_);
        }));
    }

    protected processUsers2(response: HttpResponseBase): Observable<UsersRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsersRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UsersRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerUserList(body: CustomerUserListReq | undefined): Observable<CustomerUserListRes> {
        let url_ = this.baseUrl + "/v1/PartnerUser/CustomerUserList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerUserList(<any>response_);
                } catch (e) {
                    return <Observable<CustomerUserListRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerUserListRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerUserList(response: HttpResponseBase): Observable<CustomerUserListRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerUserListRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerUserListRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerUserList2(api_version: string | undefined, body: CustomerUserListReq | undefined): Observable<CustomerUserListRes> {
        let url_ = this.baseUrl + "/PartnerUser/CustomerUserList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerUserList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerUserList2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerUserListRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerUserListRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerUserList2(response: HttpResponseBase): Observable<CustomerUserListRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerUserListRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerUserListRes>(<any>null);
    }

    /**
     * @return Success
     */
    users3(id: number): Observable<UserDetailDTO> {
        let url_ = this.baseUrl + "/v1/PartnerUser/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers3(<any>response_);
                } catch (e) {
                    return <Observable<UserDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processUsers3(response: HttpResponseBase): Observable<UserDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    users4(id: number, api_version: string | undefined): Observable<UserDetailDTO> {
        let url_ = this.baseUrl + "/PartnerUser/Users/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUsers4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers4(<any>response_);
                } catch (e) {
                    return <Observable<UserDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processUsers4(response: HttpResponseBase): Observable<UserDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUser(body: AddUserReq | undefined): Observable<AddUserRes> {
        let url_ = this.baseUrl + "/v1/PartnerUser/AddUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser(<any>response_);
                } catch (e) {
                    return <Observable<AddUserRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddUserRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddUser(response: HttpResponseBase): Observable<AddUserRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddUserRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddUserRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddUserRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addUser2(api_version: string | undefined, body: AddUserReq | undefined): Observable<AddUserRes> {
        let url_ = this.baseUrl + "/PartnerUser/AddUser?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUser2(<any>response_);
                } catch (e) {
                    return <Observable<AddUserRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddUserRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddUser2(response: HttpResponseBase): Observable<AddUserRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddUserRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddUserRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddUserRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body: UpdateUserReq | undefined): Observable<UpdateUserRes> {
        let url_ = this.baseUrl + "/v1/PartnerUser/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UpdateUserRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateUserRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateUser2(api_version: string | undefined, body: UpdateUserReq | undefined): Observable<UpdateUserRes> {
        let url_ = this.baseUrl + "/PartnerUser/UpdateUser?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateUserRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateUserRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateUser2(response: HttpResponseBase): Observable<UpdateUserRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateUserRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partnerAndCustomers4(body: PartnerAndCustomersReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/v1/PartnerUser/PartnerAndCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAndCustomers4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAndCustomers4(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAndCustomers4(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    partnerAndCustomers5(api_version: string | undefined, body: PartnerAndCustomersReq | undefined): Observable<UserPartnerOrCustomerInfo[]> {
        let url_ = this.baseUrl + "/PartnerUser/PartnerAndCustomers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPartnerAndCustomers5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPartnerAndCustomers5(<any>response_);
                } catch (e) {
                    return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserPartnerOrCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processPartnerAndCustomers5(response: HttpResponseBase): Observable<UserPartnerOrCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserPartnerOrCustomerInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rolesAll(body: PartnerUserRolesReq | undefined): Observable<UserRoleInfo[]> {
        let url_ = this.baseUrl + "/v1/PartnerUser/Roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolesAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolesAll(<any>response_);
                } catch (e) {
                    return <Observable<UserRoleInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRoleInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processRolesAll(response: HttpResponseBase): Observable<UserRoleInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    roles(api_version: string | undefined, body: PartnerUserRolesReq | undefined): Observable<UserRoleInfo[]> {
        let url_ = this.baseUrl + "/PartnerUser/Roles?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles(<any>response_);
                } catch (e) {
                    return <Observable<UserRoleInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRoleInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processRoles(response: HttpResponseBase): Observable<UserRoleInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserRoleInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRoleInfo[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addOperatorPermission(body: AddOperatorPermissionReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/PartnerUser/AddOperatorPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOperatorPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOperatorPermission(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddOperatorPermission(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addOperatorPermission2(api_version: string | undefined, body: AddOperatorPermissionReq | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/PartnerUser/AddOperatorPermission?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOperatorPermission2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOperatorPermission2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processAddOperatorPermission2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = BaseResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about43(): Observable<string> {
        let url_ = this.baseUrl + "/v1/PartnerUser/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout43(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout43(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout43(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about44(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/PartnerUser/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout44(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout44(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout44(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    roles2(body: RolesReq | undefined): Observable<RolesRes> {
        let url_ = this.baseUrl + "/v1/Role/Roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles2(<any>response_);
                } catch (e) {
                    return <Observable<RolesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<RolesRes>><any>_observableThrow(response_);
        }));
    }

    protected processRoles2(response: HttpResponseBase): Observable<RolesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolesRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    roles3(api_version: string | undefined, body: RolesReq | undefined): Observable<RolesRes> {
        let url_ = this.baseUrl + "/Role/Roles?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles3(<any>response_);
                } catch (e) {
                    return <Observable<RolesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<RolesRes>><any>_observableThrow(response_);
        }));
    }

    protected processRoles3(response: HttpResponseBase): Observable<RolesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RolesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolesRes>(<any>null);
    }

    /**
     * @return Success
     */
    roles4(id: number): Observable<RoleDetailDTO> {
        let url_ = this.baseUrl + "/v1/Role/Roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles4(<any>response_);
                } catch (e) {
                    return <Observable<RoleDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processRoles4(response: HttpResponseBase): Observable<RoleDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDetailDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    roles5(id: number, api_version: string | undefined): Observable<RoleDetailDTO> {
        let url_ = this.baseUrl + "/Role/Roles/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoles5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoles5(<any>response_);
                } catch (e) {
                    return <Observable<RoleDetailDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDetailDTO>><any>_observableThrow(response_);
        }));
    }

    protected processRoles5(response: HttpResponseBase): Observable<RoleDetailDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDetailDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDetailDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRole(body: AddRoleReq | undefined): Observable<AddRoleRes> {
        let url_ = this.baseUrl + "/v1/Role/AddRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRole(<any>response_);
                } catch (e) {
                    return <Observable<AddRoleRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddRoleRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddRole(response: HttpResponseBase): Observable<AddRoleRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddRoleRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddRoleRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddRoleRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addRole2(api_version: string | undefined, body: AddRoleReq | undefined): Observable<AddRoleRes> {
        let url_ = this.baseUrl + "/Role/AddRole?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRole2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRole2(<any>response_);
                } catch (e) {
                    return <Observable<AddRoleRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddRoleRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddRole2(response: HttpResponseBase): Observable<AddRoleRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddRoleRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = AddRoleRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddRoleRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRole(body: UpdateRoleReq | undefined): Observable<UpdateRoleRes> {
        let url_ = this.baseUrl + "/v1/Role/UpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole(<any>response_);
                } catch (e) {
                    return <Observable<UpdateRoleRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateRoleRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRole(response: HttpResponseBase): Observable<UpdateRoleRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRoleRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateRoleRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateRoleRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateRole2(api_version: string | undefined, body: UpdateRoleReq | undefined): Observable<UpdateRoleRes> {
        let url_ = this.baseUrl + "/Role/UpdateRole?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRole2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRole2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateRoleRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateRoleRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRole2(response: HttpResponseBase): Observable<UpdateRoleRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRoleRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = UpdateRoleRes.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateRoleRes>(<any>null);
    }

    /**
     * @return Success
     */
    newRoleRightsListAll(): Observable<RoleRightDTO[]> {
        let url_ = this.baseUrl + "/v1/Role/NewRoleRightsList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRoleRightsListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRoleRightsListAll(<any>response_);
                } catch (e) {
                    return <Observable<RoleRightDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleRightDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processNewRoleRightsListAll(response: HttpResponseBase): Observable<RoleRightDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleRightDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleRightDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    newRoleRightsList(api_version: string | undefined): Observable<RoleRightDTO[]> {
        let url_ = this.baseUrl + "/Role/NewRoleRightsList?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRoleRightsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRoleRightsList(<any>response_);
                } catch (e) {
                    return <Observable<RoleRightDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleRightDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processNewRoleRightsList(response: HttpResponseBase): Observable<RoleRightDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleRightDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleRightDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    about45(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Role/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout45(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout45(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout45(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about46(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Role/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout46(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout46(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout46(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ruleCustomersAll(body: RuleCustomersReq | undefined): Observable<RuleCustomerInfo[]> {
        let url_ = this.baseUrl + "/v1/Rules/RuleCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleCustomersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleCustomersAll(<any>response_);
                } catch (e) {
                    return <Observable<RuleCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processRuleCustomersAll(response: HttpResponseBase): Observable<RuleCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleCustomerInfo[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    ruleCustomers(api_version: string | undefined, body: RuleCustomersReq | undefined): Observable<RuleCustomerInfo[]> {
        let url_ = this.baseUrl + "/Rules/RuleCustomers?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleCustomers(<any>response_);
                } catch (e) {
                    return <Observable<RuleCustomerInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleCustomerInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processRuleCustomers(response: HttpResponseBase): Observable<RuleCustomerInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleCustomerInfo.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleCustomerInfo[]>(<any>null);
    }

    /**
     * @return Success
     */
    ruleDefinitionConditionsAll(id: number): Observable<RuleDefinitionConditionDTO[]> {
        let url_ = this.baseUrl + "/v1/Rules/RuleDefinitionConditions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleDefinitionConditionsAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleDefinitionConditionsAll(<any>response_);
                } catch (e) {
                    return <Observable<RuleDefinitionConditionDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleDefinitionConditionDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processRuleDefinitionConditionsAll(response: HttpResponseBase): Observable<RuleDefinitionConditionDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleDefinitionConditionDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleDefinitionConditionDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    ruleDefinitionConditions(id: number, api_version: string | undefined): Observable<RuleDefinitionConditionDTO[]> {
        let url_ = this.baseUrl + "/Rules/RuleDefinitionConditions/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleDefinitionConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleDefinitionConditions(<any>response_);
                } catch (e) {
                    return <Observable<RuleDefinitionConditionDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleDefinitionConditionDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processRuleDefinitionConditions(response: HttpResponseBase): Observable<RuleDefinitionConditionDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleDefinitionConditionDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleDefinitionConditionDTO[]>(<any>null);
    }

    /**
     * @return Success
     */
    ruleDefinitionParametersAll(id: number): Observable<RuleDefinitionParameterDTO[]> {
        let url_ = this.baseUrl + "/v1/Rules/RuleDefinitionParameters/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleDefinitionParametersAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleDefinitionParametersAll(<any>response_);
                } catch (e) {
                    return <Observable<RuleDefinitionParameterDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleDefinitionParameterDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processRuleDefinitionParametersAll(response: HttpResponseBase): Observable<RuleDefinitionParameterDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleDefinitionParameterDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleDefinitionParameterDTO[]>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    ruleDefinitionParameters(id: number, api_version: string | undefined): Observable<RuleDefinitionParameterDTO[]> {
        let url_ = this.baseUrl + "/Rules/RuleDefinitionParameters/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleDefinitionParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleDefinitionParameters(<any>response_);
                } catch (e) {
                    return <Observable<RuleDefinitionParameterDTO[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleDefinitionParameterDTO[]>><any>_observableThrow(response_);
        }));
    }

    protected processRuleDefinitionParameters(response: HttpResponseBase): Observable<RuleDefinitionParameterDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleDefinitionParameterDTO.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleDefinitionParameterDTO[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ruleDefinitions(body: RuleDefinitionsReq | undefined): Observable<RuleDefinitionsRes> {
        let url_ = this.baseUrl + "/v1/Rules/RuleDefinitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleDefinitions(<any>response_);
                } catch (e) {
                    return <Observable<RuleDefinitionsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleDefinitionsRes>><any>_observableThrow(response_);
        }));
    }

    protected processRuleDefinitions(response: HttpResponseBase): Observable<RuleDefinitionsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RuleDefinitionsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleDefinitionsRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    ruleDefinitions2(api_version: string | undefined, body: RuleDefinitionsReq | undefined): Observable<RuleDefinitionsRes> {
        let url_ = this.baseUrl + "/Rules/RuleDefinitions?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleDefinitions2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleDefinitions2(<any>response_);
                } catch (e) {
                    return <Observable<RuleDefinitionsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleDefinitionsRes>><any>_observableThrow(response_);
        }));
    }

    protected processRuleDefinitions2(response: HttpResponseBase): Observable<RuleDefinitionsRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RuleDefinitionsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleDefinitionsRes>(<any>null);
    }

    /**
     * @return Success
     */
    ruleDefinitions3(id: number): Observable<RuleDefinitionDetailsDTO> {
        let url_ = this.baseUrl + "/v1/Rules/RuleDefinitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleDefinitions3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleDefinitions3(<any>response_);
                } catch (e) {
                    return <Observable<RuleDefinitionDetailsDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleDefinitionDetailsDTO>><any>_observableThrow(response_);
        }));
    }

    protected processRuleDefinitions3(response: HttpResponseBase): Observable<RuleDefinitionDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RuleDefinitionDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleDefinitionDetailsDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    ruleDefinitions4(id: number, api_version: string | undefined): Observable<RuleDefinitionDetailsDTO> {
        let url_ = this.baseUrl + "/Rules/RuleDefinitions/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRuleDefinitions4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRuleDefinitions4(<any>response_);
                } catch (e) {
                    return <Observable<RuleDefinitionDetailsDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<RuleDefinitionDetailsDTO>><any>_observableThrow(response_);
        }));
    }

    protected processRuleDefinitions4(response: HttpResponseBase): Observable<RuleDefinitionDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RuleDefinitionDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RuleDefinitionDetailsDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRuleDefinition(body: UpdateRuleDefinitionReq | undefined): Observable<UpdateRuleDefinitionRes> {
        let url_ = this.baseUrl + "/v1/Rules/UpdateRuleDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRuleDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRuleDefinition(<any>response_);
                } catch (e) {
                    return <Observable<UpdateRuleDefinitionRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateRuleDefinitionRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRuleDefinition(response: HttpResponseBase): Observable<UpdateRuleDefinitionRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRuleDefinitionRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateRuleDefinitionRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateRuleDefinition2(api_version: string | undefined, body: UpdateRuleDefinitionReq | undefined): Observable<UpdateRuleDefinitionRes> {
        let url_ = this.baseUrl + "/Rules/UpdateRuleDefinition?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRuleDefinition2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRuleDefinition2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateRuleDefinitionRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateRuleDefinitionRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRuleDefinition2(response: HttpResponseBase): Observable<UpdateRuleDefinitionRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRuleDefinitionRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateRuleDefinitionRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerRules(body: CustomerRulesReq | undefined): Observable<CustomerRulesRes> {
        let url_ = this.baseUrl + "/v1/Rules/CustomerRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerRules(<any>response_);
                } catch (e) {
                    return <Observable<CustomerRulesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerRulesRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerRules(response: HttpResponseBase): Observable<CustomerRulesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerRulesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerRulesRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    customerRules2(api_version: string | undefined, body: CustomerRulesReq | undefined): Observable<CustomerRulesRes> {
        let url_ = this.baseUrl + "/Rules/CustomerRules?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerRules2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerRules2(<any>response_);
                } catch (e) {
                    return <Observable<CustomerRulesRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerRulesRes>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerRules2(response: HttpResponseBase): Observable<CustomerRulesRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerRulesRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerRulesRes>(<any>null);
    }

    /**
     * @return Success
     */
    customerRules3(id: number): Observable<CustomerRuleDetailsDTO> {
        let url_ = this.baseUrl + "/v1/Rules/CustomerRules/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerRules3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerRules3(<any>response_);
                } catch (e) {
                    return <Observable<CustomerRuleDetailsDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerRuleDetailsDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerRules3(response: HttpResponseBase): Observable<CustomerRuleDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerRuleDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerRuleDetailsDTO>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    customerRules4(id: number, api_version: string | undefined): Observable<CustomerRuleDetailsDTO> {
        let url_ = this.baseUrl + "/Rules/CustomerRules/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerRules4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerRules4(<any>response_);
                } catch (e) {
                    return <Observable<CustomerRuleDetailsDTO>><any>_observableThrow(e);
                }
            } else
                return <Observable<CustomerRuleDetailsDTO>><any>_observableThrow(response_);
        }));
    }

    protected processCustomerRules4(response: HttpResponseBase): Observable<CustomerRuleDetailsDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerRuleDetailsDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 !== undefined ? resultData404 : <any>null;
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerRuleDetailsDTO>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCustomerRule(body: AddCustomerRuleReq | undefined): Observable<AddCustomerRuleRes> {
        let url_ = this.baseUrl + "/v1/Rules/AddCustomerRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerRule(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerRuleRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerRuleRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerRule(response: HttpResponseBase): Observable<AddCustomerRuleRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerRuleRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerRuleRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addCustomerRule2(api_version: string | undefined, body: AddCustomerRuleReq | undefined): Observable<AddCustomerRuleRes> {
        let url_ = this.baseUrl + "/Rules/AddCustomerRule?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomerRule2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomerRule2(<any>response_);
                } catch (e) {
                    return <Observable<AddCustomerRuleRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<AddCustomerRuleRes>><any>_observableThrow(response_);
        }));
    }

    protected processAddCustomerRule2(response: HttpResponseBase): Observable<AddCustomerRuleRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCustomerRuleRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCustomerRuleRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCustomerRule(body: UpdateCustomerRuleReq | undefined): Observable<UpdateCustomerRuleRes> {
        let url_ = this.baseUrl + "/v1/Rules/UpdateCustomerRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerRule(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerRuleRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerRuleRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerRule(response: HttpResponseBase): Observable<UpdateCustomerRuleRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerRuleRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerRuleRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    updateCustomerRule2(api_version: string | undefined, body: UpdateCustomerRuleReq | undefined): Observable<UpdateCustomerRuleRes> {
        let url_ = this.baseUrl + "/Rules/UpdateCustomerRule?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomerRule2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerRule2(<any>response_);
                } catch (e) {
                    return <Observable<UpdateCustomerRuleRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<UpdateCustomerRuleRes>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCustomerRule2(response: HttpResponseBase): Observable<UpdateCustomerRuleRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCustomerRuleRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCustomerRuleRes>(<any>null);
    }

    /**
     * @return Success
     */
    deleteCustomerRule(id: number): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/v1/Rules/DeleteCustomerRule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerRule(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustomerRule(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    deleteCustomerRule2(id: number, api_version: string | undefined): Observable<BaseResponse> {
        let url_ = this.baseUrl + "/Rules/DeleteCustomerRule/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomerRule2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerRule2(<any>response_);
                } catch (e) {
                    return <Observable<BaseResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<BaseResponse>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteCustomerRule2(response: HttpResponseBase): Observable<BaseResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseResponse>(<any>null);
    }

    /**
     * @return Success
     */
    about47(): Observable<string> {
        let url_ = this.baseUrl + "/v1/Rules/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout47(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout47(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout47(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about48(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/Rules/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout48(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout48(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout48(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getEnvelopeByProcessStatus(body: GetEnvelopesUUIDByProcessStatusReq | undefined): Observable<GetEnvelopesUUIDByProcessStatusRes> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/GetEnvelopeByProcessStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvelopeByProcessStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvelopeByProcessStatus(<any>response_);
                } catch (e) {
                    return <Observable<GetEnvelopesUUIDByProcessStatusRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEnvelopesUUIDByProcessStatusRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnvelopeByProcessStatus(response: HttpResponseBase): Observable<GetEnvelopesUUIDByProcessStatusRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEnvelopesUUIDByProcessStatusRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEnvelopesUUIDByProcessStatusRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    getEnvelopeByProcessStatus2(api_version: string | undefined, body: GetEnvelopesUUIDByProcessStatusReq | undefined): Observable<GetEnvelopesUUIDByProcessStatusRes> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/GetEnvelopeByProcessStatus?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnvelopeByProcessStatus2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnvelopeByProcessStatus2(<any>response_);
                } catch (e) {
                    return <Observable<GetEnvelopesUUIDByProcessStatusRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEnvelopesUUIDByProcessStatusRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetEnvelopeByProcessStatus2(response: HttpResponseBase): Observable<GetEnvelopesUUIDByProcessStatusRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEnvelopesUUIDByProcessStatusRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEnvelopesUUIDByProcessStatusRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    triggerEnvelopesStatus(body: TriggerEnvelopesStatusReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/TriggerEnvelopesStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerEnvelopesStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerEnvelopesStatus(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processTriggerEnvelopesStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    triggerEnvelopesStatus2(api_version: string | undefined, body: TriggerEnvelopesStatusReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/TriggerEnvelopesStatus?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriggerEnvelopesStatus2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriggerEnvelopesStatus2(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processTriggerEnvelopesStatus2(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getIncomingEnvelopeByProcessStatus(): Observable<GetDocumentDefaultEnvelopesUUIDRes> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/GetIncomingEnvelopeByProcessStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomingEnvelopeByProcessStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomingEnvelopeByProcessStatus(<any>response_);
                } catch (e) {
                    return <Observable<GetDocumentDefaultEnvelopesUUIDRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDocumentDefaultEnvelopesUUIDRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomingEnvelopeByProcessStatus(response: HttpResponseBase): Observable<GetDocumentDefaultEnvelopesUUIDRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentDefaultEnvelopesUUIDRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentDefaultEnvelopesUUIDRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getIncomingEnvelopeByProcessStatus2(api_version: string | undefined): Observable<GetDocumentDefaultEnvelopesUUIDRes> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/GetIncomingEnvelopeByProcessStatus?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomingEnvelopeByProcessStatus2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomingEnvelopeByProcessStatus2(<any>response_);
                } catch (e) {
                    return <Observable<GetDocumentDefaultEnvelopesUUIDRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDocumentDefaultEnvelopesUUIDRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomingEnvelopeByProcessStatus2(response: HttpResponseBase): Observable<GetDocumentDefaultEnvelopesUUIDRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentDefaultEnvelopesUUIDRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentDefaultEnvelopesUUIDRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setEnvelopesStatus1300(body: TriggerEnvelopesStatusReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/SetEnvelopesStatus1300";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEnvelopesStatus1300(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnvelopesStatus1300(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetEnvelopesStatus1300(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    setEnvelopesStatus13002(api_version: string | undefined, body: TriggerEnvelopesStatusReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/SetEnvelopesStatus1300?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetEnvelopesStatus13002(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetEnvelopesStatus13002(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processSetEnvelopesStatus13002(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getIncomingEnvelopeForProcessStatus1000(): Observable<GetDocumentDefaultEnvelopesUUIDRes> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/GetIncomingEnvelopeForProcessStatus1000";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomingEnvelopeForProcessStatus1000(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomingEnvelopeForProcessStatus1000(<any>response_);
                } catch (e) {
                    return <Observable<GetDocumentDefaultEnvelopesUUIDRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDocumentDefaultEnvelopesUUIDRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomingEnvelopeForProcessStatus1000(response: HttpResponseBase): Observable<GetDocumentDefaultEnvelopesUUIDRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentDefaultEnvelopesUUIDRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentDefaultEnvelopesUUIDRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getIncomingEnvelopeForProcessStatus10002(api_version: string | undefined): Observable<GetDocumentDefaultEnvelopesUUIDRes> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/GetIncomingEnvelopeForProcessStatus1000?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomingEnvelopeForProcessStatus10002(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomingEnvelopeForProcessStatus10002(<any>response_);
                } catch (e) {
                    return <Observable<GetDocumentDefaultEnvelopesUUIDRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDocumentDefaultEnvelopesUUIDRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncomingEnvelopeForProcessStatus10002(response: HttpResponseBase): Observable<GetDocumentDefaultEnvelopesUUIDRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDocumentDefaultEnvelopesUUIDRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDocumentDefaultEnvelopesUUIDRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addQueueEnvelopeStatus1000Req(body: TriggerEnvelopesStatusReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/AddQueueEnvelopeStatus1000Req";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQueueEnvelopeStatus1000Req(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQueueEnvelopeStatus1000Req(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddQueueEnvelopeStatus1000Req(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addQueueEnvelopeStatus1000Req2(api_version: string | undefined, body: TriggerEnvelopesStatusReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/AddQueueEnvelopeStatus1000Req?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQueueEnvelopeStatus1000Req2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQueueEnvelopeStatus1000Req2(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddQueueEnvelopeStatus1000Req2(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    getErrorSignValidateInvoice(): Observable<GetErrorSignValidateInvoiceUUIDRes> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/GetErrorSignValidateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErrorSignValidateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErrorSignValidateInvoice(<any>response_);
                } catch (e) {
                    return <Observable<GetErrorSignValidateInvoiceUUIDRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetErrorSignValidateInvoiceUUIDRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetErrorSignValidateInvoice(response: HttpResponseBase): Observable<GetErrorSignValidateInvoiceUUIDRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetErrorSignValidateInvoiceUUIDRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetErrorSignValidateInvoiceUUIDRes>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    getErrorSignValidateInvoice2(api_version: string | undefined): Observable<GetErrorSignValidateInvoiceUUIDRes> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/GetErrorSignValidateInvoice?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErrorSignValidateInvoice2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErrorSignValidateInvoice2(<any>response_);
                } catch (e) {
                    return <Observable<GetErrorSignValidateInvoiceUUIDRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetErrorSignValidateInvoiceUUIDRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetErrorSignValidateInvoice2(response: HttpResponseBase): Observable<GetErrorSignValidateInvoiceUUIDRes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetErrorSignValidateInvoiceUUIDRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetErrorSignValidateInvoiceUUIDRes>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addQueueSignEarchive(body: AddQueueSignEArchiveReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/AddQueueSignEarchive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQueueSignEarchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQueueSignEarchive(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddQueueSignEarchive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @param body (optional) 
     * @return Success
     */
    addQueueSignEarchive2(api_version: string | undefined, body: AddQueueSignEArchiveReq | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/AddQueueSignEarchive?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQueueSignEarchive2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQueueSignEarchive2(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddQueueSignEarchive2(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @return Success
     */
    about49(): Observable<string> {
        let url_ = this.baseUrl + "/v1/SystemDocumentFlow/About";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout49(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout49(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout49(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param api_version (optional) The requested API version
     * @return Success
     */
    about50(api_version: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/SystemDocumentFlow/About?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbout50(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbout50(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processAbout50(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export class FilterRequest implements IFilterRequest {
    filter?: string | undefined;

    constructor(data?: IFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): FilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IFilterRequest {
    filter?: string | undefined;
}

export class ActivationPartnerInfoDTO implements IActivationPartnerInfoDTO {
    identificatonId?: string | undefined;
    title?: string | undefined;

    constructor(data?: IActivationPartnerInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identificatonId = _data["identificatonId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ActivationPartnerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationPartnerInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identificatonId"] = this.identificatonId;
        data["title"] = this.title;
        return data; 
    }
}

export interface IActivationPartnerInfoDTO {
    identificatonId?: string | undefined;
    title?: string | undefined;
}

export class ActivationCustomersReq implements IActivationCustomersReq {
    partnerId?: string | undefined;
    filter?: string | undefined;

    constructor(data?: IActivationCustomersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): ActivationCustomersReq {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationCustomersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IActivationCustomersReq {
    partnerId?: string | undefined;
    filter?: string | undefined;
}

export class ActivationCustomerInfoDTO implements IActivationCustomerInfoDTO {
    identificatonId?: string | undefined;
    title?: string | undefined;
    eMail?: string | undefined;

    constructor(data?: IActivationCustomerInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identificatonId = _data["identificatonId"];
            this.title = _data["title"];
            this.eMail = _data["eMail"];
        }
    }

    static fromJS(data: any): ActivationCustomerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationCustomerInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identificatonId"] = this.identificatonId;
        data["title"] = this.title;
        data["eMail"] = this.eMail;
        return data; 
    }
}

export interface IActivationCustomerInfoDTO {
    identificatonId?: string | undefined;
    title?: string | undefined;
    eMail?: string | undefined;
}

export enum ServiceTypeCategory {
    ActiveService = "ActiveService",
    ArchiveService = "ArchiveService",
}

export class ServicesReq implements IServicesReq {
    category?: ServiceTypeCategory;

    constructor(data?: IServicesReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): ServicesReq {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        return data; 
    }
}

export interface IServicesReq {
    category?: ServiceTypeCategory;
}

export class ServiceDTO implements IServiceDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IServiceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ServiceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IServiceDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class AvaiableRouteTenantsReq implements IAvaiableRouteTenantsReq {
    partnerId?: string | undefined;
    serviceId?: number | undefined;

    constructor(data?: IAvaiableRouteTenantsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): AvaiableRouteTenantsReq {
        data = typeof data === 'object' ? data : {};
        let result = new AvaiableRouteTenantsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["serviceId"] = this.serviceId;
        return data; 
    }
}

export interface IAvaiableRouteTenantsReq {
    partnerId?: string | undefined;
    serviceId?: number | undefined;
}

export class RouteTenantDTO implements IRouteTenantDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IRouteTenantDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RouteTenantDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RouteTenantDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IRouteTenantDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export enum ServiceType {
    Ortak_hizmet = "ortak_hizmet",
    Usergb = "usergb",
    Usergb_yb = "usergb_yb",
    Archive = "archive",
    Earchive = "earchive",
    Ereceipt = "ereceipt",
    Gib_earchive = "gib_earchive",
    Archive_earchive = "archive_earchive",
    Eticket = "eticket",
    Edespatch = "edespatch",
    Archive_edespatch = "archive_edespatch",
    Esevoucher = "esevoucher",
    Epreceipt = "epreceipt",
    Esevoucher_archive = "esevoucher_archive",
    Epreceipt_archive = "epreceipt_archive",
    Erevenue_old = "erevenue_old",
    Erevenue_new = "erevenue_new",
    Ebreceipt = "ebreceipt",
    Eexchangecert = "eexchangecert",
    Echeck = "echeck",
    Eicommission = "eicommission",
    Erreceipt = "erreceipt",
    Eledger = "eledger",
    Eledger_archive = "eledger_archive",
    Journal_entry = "journal_entry",
    Einventory_ledger = "einventory_ledger",
    Einventory_ledger_archive = "einventory_ledger_archive",
    Esu_invoice = "esu_invoice",
}

export enum CustomerServiceStatus {
    New = "New",
    ActivationPending = "ActivationPending",
    Activated = "Activated",
    ActivationFailed = "ActivationFailed",
    CancelPending = "CancelPending",
    Cancelled = "Cancelled",
    CancelFailed = "CancelFailed",
}

export class ActivationsReq implements IActivationsReq {
    partnerId?: string | undefined;
    customerId?: string | undefined;
    serviceType?: ServiceType;
    status?: CustomerServiceStatus;

    constructor(data?: IActivationsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.customerId = _data["customerId"];
            this.serviceType = _data["serviceType"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ActivationsReq {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["customerId"] = this.customerId;
        data["serviceType"] = this.serviceType;
        data["status"] = this.status;
        return data; 
    }
}

export interface IActivationsReq {
    partnerId?: string | undefined;
    customerId?: string | undefined;
    serviceType?: ServiceType;
    status?: CustomerServiceStatus;
}

export enum AliasType {
    GondericiBirim = "GondericiBirim",
    PostaKutusu = "PostaKutusu",
}

export class ActivationDTO implements IActivationDTO {
    id?: number;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    serviceId?: number | undefined;
    serviceCode?: string | undefined;
    serviceStatus?: CustomerServiceStatus;
    gibStatus?: string | undefined;
    createEnvelopeUUID?: string | undefined;
    createEnvelopeStatus?: number | undefined;
    cancelEnvelopeUUID?: string | undefined;
    cancelEnvelopeStatus?: number | undefined;
    aliasType?: AliasType;
    alias?: string | undefined;
    routeTenantId?: number | undefined;
    routeTenantCode?: string | undefined;
    activationTime?: Date | undefined;
    activationMessage?: string | undefined;
    isTestService?: number | undefined;
    isActive?: boolean;

    constructor(data?: IActivationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerId = _data["partnerId"];
            this.partnerTitle = _data["partnerTitle"];
            this.customerId = _data["customerId"];
            this.customerTitle = _data["customerTitle"];
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.serviceStatus = _data["serviceStatus"];
            this.gibStatus = _data["gibStatus"];
            this.createEnvelopeUUID = _data["createEnvelopeUUID"];
            this.createEnvelopeStatus = _data["createEnvelopeStatus"];
            this.cancelEnvelopeUUID = _data["cancelEnvelopeUUID"];
            this.cancelEnvelopeStatus = _data["cancelEnvelopeStatus"];
            this.aliasType = _data["aliasType"];
            this.alias = _data["alias"];
            this.routeTenantId = _data["routeTenantId"];
            this.routeTenantCode = _data["routeTenantCode"];
            this.activationTime = _data["activationTime"] ? new Date(_data["activationTime"].toString()) : <any>undefined;
            this.activationMessage = _data["activationMessage"];
            this.isTestService = _data["isTestService"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ActivationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerId"] = this.partnerId;
        data["partnerTitle"] = this.partnerTitle;
        data["customerId"] = this.customerId;
        data["customerTitle"] = this.customerTitle;
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["serviceStatus"] = this.serviceStatus;
        data["gibStatus"] = this.gibStatus;
        data["createEnvelopeUUID"] = this.createEnvelopeUUID;
        data["createEnvelopeStatus"] = this.createEnvelopeStatus;
        data["cancelEnvelopeUUID"] = this.cancelEnvelopeUUID;
        data["cancelEnvelopeStatus"] = this.cancelEnvelopeStatus;
        data["aliasType"] = this.aliasType;
        data["alias"] = this.alias;
        data["routeTenantId"] = this.routeTenantId;
        data["routeTenantCode"] = this.routeTenantCode;
        data["activationTime"] = this.activationTime ? this.activationTime.toISOString() : <any>undefined;
        data["activationMessage"] = this.activationMessage;
        data["isTestService"] = this.isTestService;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IActivationDTO {
    id?: number;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    serviceId?: number | undefined;
    serviceCode?: string | undefined;
    serviceStatus?: CustomerServiceStatus;
    gibStatus?: string | undefined;
    createEnvelopeUUID?: string | undefined;
    createEnvelopeStatus?: number | undefined;
    cancelEnvelopeUUID?: string | undefined;
    cancelEnvelopeStatus?: number | undefined;
    aliasType?: AliasType;
    alias?: string | undefined;
    routeTenantId?: number | undefined;
    routeTenantCode?: string | undefined;
    activationTime?: Date | undefined;
    activationMessage?: string | undefined;
    isTestService?: number | undefined;
    isActive?: boolean;
}

export class ActivationsRes implements IActivationsRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    activations?: ActivationDTO[] | undefined;
    infoMessages?: string[] | undefined;

    constructor(data?: IActivationsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            if (Array.isArray(_data["activations"])) {
                this.activations = [] as any;
                for (let item of _data["activations"])
                    this.activations!.push(ActivationDTO.fromJS(item));
            }
            if (Array.isArray(_data["infoMessages"])) {
                this.infoMessages = [] as any;
                for (let item of _data["infoMessages"])
                    this.infoMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivationsRes {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        if (Array.isArray(this.activations)) {
            data["activations"] = [];
            for (let item of this.activations)
                data["activations"].push(item.toJSON());
        }
        if (Array.isArray(this.infoMessages)) {
            data["infoMessages"] = [];
            for (let item of this.infoMessages)
                data["infoMessages"].push(item);
        }
        return data; 
    }
}

export interface IActivationsRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    activations?: ActivationDTO[] | undefined;
    infoMessages?: string[] | undefined;
}

export class CreateActivationDTO implements ICreateActivationDTO {
    serviceId?: ServiceType;
    gbAlias?: string | undefined;
    pkAlias?: string | undefined;
    activationTime?: Date | undefined;
    routeTenantId?: number | undefined;

    constructor(data?: ICreateActivationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.gbAlias = _data["gbAlias"];
            this.pkAlias = _data["pkAlias"];
            this.activationTime = _data["activationTime"] ? new Date(_data["activationTime"].toString()) : <any>undefined;
            this.routeTenantId = _data["RouteTenantId"];
        }
    }

    static fromJS(data: any): CreateActivationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["gbAlias"] = this.gbAlias;
        data["pkAlias"] = this.pkAlias;
        data["activationTime"] = this.activationTime ? this.activationTime.toISOString() : <any>undefined;
        data["RouteTenantId"] = this.routeTenantId;
        return data; 
    }
}

export interface ICreateActivationDTO {
    serviceId?: ServiceType;
    gbAlias?: string | undefined;
    pkAlias?: string | undefined;
    activationTime?: Date | undefined;
    routeTenantId?: number | undefined;
}

export class CreateActivationReq implements ICreateActivationReq {
    partnerId?: string | undefined;
    customerId?: string | undefined;
    createActivations?: CreateActivationDTO[] | undefined;

    constructor(data?: ICreateActivationReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["createActivations"])) {
                this.createActivations = [] as any;
                for (let item of _data["createActivations"])
                    this.createActivations!.push(CreateActivationDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateActivationReq {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivationReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.createActivations)) {
            data["createActivations"] = [];
            for (let item of this.createActivations)
                data["createActivations"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICreateActivationReq {
    partnerId?: string | undefined;
    customerId?: string | undefined;
    createActivations?: CreateActivationDTO[] | undefined;
}

export class StartOverCreateActivationReq implements IStartOverCreateActivationReq {
    customerServiceId?: number;
    activationTime?: Date | undefined;

    constructor(data?: IStartOverCreateActivationReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerServiceId = _data["customerServiceId"];
            this.activationTime = _data["activationTime"] ? new Date(_data["activationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StartOverCreateActivationReq {
        data = typeof data === 'object' ? data : {};
        let result = new StartOverCreateActivationReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerServiceId"] = this.customerServiceId;
        data["activationTime"] = this.activationTime ? this.activationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStartOverCreateActivationReq {
    customerServiceId?: number;
    activationTime?: Date | undefined;
}

export class SetSignedNowRequest implements ISetSignedNowRequest {
    customerServiceId?: number;
    activate?: boolean;

    constructor(data?: ISetSignedNowRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerServiceId = _data["customerServiceId"];
            this.activate = _data["activate"];
        }
    }

    static fromJS(data: any): SetSignedNowRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetSignedNowRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerServiceId"] = this.customerServiceId;
        data["activate"] = this.activate;
        return data; 
    }
}

export interface ISetSignedNowRequest {
    customerServiceId?: number;
    activate?: boolean;
}

export class CreateTestAccountReq implements ICreateTestAccountReq {
    customerServiceId?: number;

    constructor(data?: ICreateTestAccountReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerServiceId = _data["customerServiceId"];
        }
    }

    static fromJS(data: any): CreateTestAccountReq {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTestAccountReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerServiceId"] = this.customerServiceId;
        return data; 
    }
}

export interface ICreateTestAccountReq {
    customerServiceId?: number;
}

export class CancelActivationReq implements ICancelActivationReq {
    customerServiceId?: number;
    cancellationTime?: Date | undefined;

    constructor(data?: ICancelActivationReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerServiceId = _data["customerServiceId"];
            this.cancellationTime = _data["cancellationTime"] ? new Date(_data["cancellationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelActivationReq {
        data = typeof data === 'object' ? data : {};
        let result = new CancelActivationReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerServiceId"] = this.customerServiceId;
        data["cancellationTime"] = this.cancellationTime ? this.cancellationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICancelActivationReq {
    customerServiceId?: number;
    cancellationTime?: Date | undefined;
}

export class EnvelopeQueryReq implements IEnvelopeQueryReq {
    id?: number;

    constructor(data?: IEnvelopeQueryReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EnvelopeQueryReq {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeQueryReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IEnvelopeQueryReq {
    id?: number;
}

export class BaseResponse implements IBaseResponse {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;

    constructor(data?: IBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
        }
    }

    static fromJS(data: any): BaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        return data; 
    }
}

export interface IBaseResponse {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
}

export class StartOverCancelActivationReq implements IStartOverCancelActivationReq {
    customerServiceId?: number;
    cancellationTime?: Date | undefined;

    constructor(data?: IStartOverCancelActivationReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerServiceId = _data["customerServiceId"];
            this.cancellationTime = _data["cancellationTime"] ? new Date(_data["cancellationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StartOverCancelActivationReq {
        data = typeof data === 'object' ? data : {};
        let result = new StartOverCancelActivationReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerServiceId"] = this.customerServiceId;
        data["cancellationTime"] = this.cancellationTime ? this.cancellationTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IStartOverCancelActivationReq {
    customerServiceId?: number;
    cancellationTime?: Date | undefined;
}

export class AvaiablePartnerAgreementsReq implements IAvaiablePartnerAgreementsReq {
    partnerId?: string | undefined;
    filter?: string | undefined;

    constructor(data?: IAvaiablePartnerAgreementsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): AvaiablePartnerAgreementsReq {
        data = typeof data === 'object' ? data : {};
        let result = new AvaiablePartnerAgreementsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IAvaiablePartnerAgreementsReq {
    partnerId?: string | undefined;
    filter?: string | undefined;
}

export enum AgreementStatus {
    Draft = "Draft",
    Active = "Active",
    Suspended = "Suspended",
    Cancelled = "Cancelled",
    Disabled = "Disabled",
}

export enum AgreementType {
    FixPack = "FixPack",
    UnitPrice = "UnitPrice",
    ContourPack = "ContourPack",
    BatchContour = "BatchContour",
}

export class AvailablePartnerAgreementsDetailDTO implements IAvailablePartnerAgreementsDetailDTO {
    id?: number;
    status?: AgreementStatus;
    code?: string | undefined;
    description?: string | undefined;
    partnerId?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    agreementType?: AgreementType;
    serviceId?: number;
    serviceCode?: string | undefined;
    isPartnerCreateInvoice?: number;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    partnerFixPackSize?: number;
    partnerContourPackSize?: number | undefined;
    partnerFixPackPrice?: number | undefined;
    partnerFixPackOverflowPrice?: number | undefined;
    partnerUnitPrice?: number | undefined;
    partnerCommissionRate?: number | undefined;
    partnerContourPackPrice?: number | undefined;
    expired?: boolean;

    constructor(data?: IAvailablePartnerAgreementsDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.partnerId = _data["partnerId"];
            this.partnerShortCode = _data["partnerShortCode"];
            this.partnerTitle = _data["partnerTitle"];
            this.agreementType = _data["agreementType"];
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.isPartnerCreateInvoice = _data["isPartnerCreateInvoice"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : <any>undefined;
            this.partnerFixPackSize = _data["partnerFixPackSize"];
            this.partnerContourPackSize = _data["partnerContourPackSize"];
            this.partnerFixPackPrice = _data["partnerFixPackPrice"];
            this.partnerFixPackOverflowPrice = _data["partnerFixPackOverflowPrice"];
            this.partnerUnitPrice = _data["partnerUnitPrice"];
            this.partnerCommissionRate = _data["partnerCommissionRate"];
            this.partnerContourPackPrice = _data["partnerContourPackPrice"];
            this.expired = _data["expired"];
        }
    }

    static fromJS(data: any): AvailablePartnerAgreementsDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AvailablePartnerAgreementsDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["code"] = this.code;
        data["description"] = this.description;
        data["partnerId"] = this.partnerId;
        data["partnerShortCode"] = this.partnerShortCode;
        data["partnerTitle"] = this.partnerTitle;
        data["agreementType"] = this.agreementType;
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["isPartnerCreateInvoice"] = this.isPartnerCreateInvoice;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        data["partnerFixPackSize"] = this.partnerFixPackSize;
        data["partnerContourPackSize"] = this.partnerContourPackSize;
        data["partnerFixPackPrice"] = this.partnerFixPackPrice;
        data["partnerFixPackOverflowPrice"] = this.partnerFixPackOverflowPrice;
        data["partnerUnitPrice"] = this.partnerUnitPrice;
        data["partnerCommissionRate"] = this.partnerCommissionRate;
        data["partnerContourPackPrice"] = this.partnerContourPackPrice;
        data["expired"] = this.expired;
        return data; 
    }
}

export interface IAvailablePartnerAgreementsDetailDTO {
    id?: number;
    status?: AgreementStatus;
    code?: string | undefined;
    description?: string | undefined;
    partnerId?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    agreementType?: AgreementType;
    serviceId?: number;
    serviceCode?: string | undefined;
    isPartnerCreateInvoice?: number;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    partnerFixPackSize?: number;
    partnerContourPackSize?: number | undefined;
    partnerFixPackPrice?: number | undefined;
    partnerFixPackOverflowPrice?: number | undefined;
    partnerUnitPrice?: number | undefined;
    partnerCommissionRate?: number | undefined;
    partnerContourPackPrice?: number | undefined;
    expired?: boolean;
}

export enum FilterType {
    All = "All",
    Partner = "Partner",
    Customer = "Customer",
}

export class PartnerAndCustomersReq implements IPartnerAndCustomersReq {
    filterType?: FilterType;
    filter?: string | undefined;
    partnerId?: string | undefined;

    constructor(data?: IPartnerAndCustomersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterType = _data["filterType"];
            this.filter = _data["filter"];
            this.partnerId = _data["partnerId"];
        }
    }

    static fromJS(data: any): PartnerAndCustomersReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAndCustomersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterType"] = this.filterType;
        data["filter"] = this.filter;
        data["partnerId"] = this.partnerId;
        return data; 
    }
}

export interface IPartnerAndCustomersReq {
    filterType?: FilterType;
    filter?: string | undefined;
    partnerId?: string | undefined;
}

export class UserPartnerOrCustomerInfo implements IUserPartnerOrCustomerInfo {
    identityId?: string | undefined;
    title?: string | undefined;
    userLevel?: number | undefined;

    constructor(data?: IUserPartnerOrCustomerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityId = _data["identityId"];
            this.title = _data["title"];
            this.userLevel = _data["userLevel"];
        }
    }

    static fromJS(data: any): UserPartnerOrCustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserPartnerOrCustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId;
        data["title"] = this.title;
        data["userLevel"] = this.userLevel;
        return data; 
    }
}

export interface IUserPartnerOrCustomerInfo {
    identityId?: string | undefined;
    title?: string | undefined;
    userLevel?: number | undefined;
}

export enum Condition {
    Equal = "Equal",
    Equals = "Equals",
    NotEqual = "NotEqual",
    NotEquals = "NotEquals",
    StartsWith = "StartsWith",
    EndsWith = "EndsWith",
    Contains = "Contains",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
}

export class RequestFilter implements IRequestFilter {
    name?: string | undefined;
    condition?: Condition;
    value?: any | undefined;

    constructor(data?: IRequestFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.condition = _data["condition"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RequestFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RequestFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["condition"] = this.condition;
        data["value"] = this.value;
        return data; 
    }
}

export interface IRequestFilter {
    name?: string | undefined;
    condition?: Condition;
    value?: any | undefined;
}

export class PartnerAgreementsReq implements IPartnerAgreementsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IPartnerAgreementsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerAgreementsReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAgreementsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnerAgreementsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class PartnerAgreementsDTO implements IPartnerAgreementsDTO {
    id?: number;
    status?: AgreementStatus;
    code?: string | undefined;
    description?: string | undefined;
    partnerId?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    agreementType?: AgreementType;
    serviceId?: number;
    serviceCode?: string | undefined;
    isPartnerCreateInvoice?: number;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    fixPackSize?: number;
    contourPackSize?: number | undefined;
    agreementSystemCreateDate?: Date;
    expired?: boolean;

    constructor(data?: IPartnerAgreementsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.partnerId = _data["partnerId"];
            this.partnerShortCode = _data["partnerShortCode"];
            this.partnerTitle = _data["partnerTitle"];
            this.agreementType = _data["agreementType"];
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.isPartnerCreateInvoice = _data["isPartnerCreateInvoice"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : <any>undefined;
            this.fixPackSize = _data["fixPackSize"];
            this.contourPackSize = _data["contourPackSize"];
            this.agreementSystemCreateDate = _data["agreementSystemCreateDate"] ? new Date(_data["agreementSystemCreateDate"].toString()) : <any>undefined;
            this.expired = _data["expired"];
        }
    }

    static fromJS(data: any): PartnerAgreementsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAgreementsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["code"] = this.code;
        data["description"] = this.description;
        data["partnerId"] = this.partnerId;
        data["partnerShortCode"] = this.partnerShortCode;
        data["partnerTitle"] = this.partnerTitle;
        data["agreementType"] = this.agreementType;
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["isPartnerCreateInvoice"] = this.isPartnerCreateInvoice;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        data["fixPackSize"] = this.fixPackSize;
        data["contourPackSize"] = this.contourPackSize;
        data["agreementSystemCreateDate"] = this.agreementSystemCreateDate ? this.agreementSystemCreateDate.toISOString() : <any>undefined;
        data["expired"] = this.expired;
        return data; 
    }
}

export interface IPartnerAgreementsDTO {
    id?: number;
    status?: AgreementStatus;
    code?: string | undefined;
    description?: string | undefined;
    partnerId?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    agreementType?: AgreementType;
    serviceId?: number;
    serviceCode?: string | undefined;
    isPartnerCreateInvoice?: number;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    fixPackSize?: number;
    contourPackSize?: number | undefined;
    agreementSystemCreateDate?: Date;
    expired?: boolean;
}

export class PartnerAgreementsRes implements IPartnerAgreementsRes {
    totalRecordCount?: number;
    listData?: PartnerAgreementsDTO[] | undefined;

    constructor(data?: IPartnerAgreementsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(PartnerAgreementsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerAgreementsRes {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAgreementsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnerAgreementsRes {
    totalRecordCount?: number;
    listData?: PartnerAgreementsDTO[] | undefined;
}

export class PartnerAgreementsDetailDTO implements IPartnerAgreementsDetailDTO {
    id?: number;
    status?: AgreementStatus;
    code?: string | undefined;
    description?: string | undefined;
    partnerId?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    agreementType?: AgreementType;
    serviceId?: number;
    serviceCode?: string | undefined;
    isPartnerCreateInvoice?: number;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    fixPackSize?: number;
    contourPackSize?: number | undefined;
    agreementSystemCreateDate?: Date;
    expired?: boolean;
    fixPackPrice?: number | undefined;
    fixPackOverflowPrice?: number | undefined;
    unitPrice?: number | undefined;
    commissionRate?: number | undefined;
    contourPackPrice?: number | undefined;

    constructor(data?: IPartnerAgreementsDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.partnerId = _data["partnerId"];
            this.partnerShortCode = _data["partnerShortCode"];
            this.partnerTitle = _data["partnerTitle"];
            this.agreementType = _data["agreementType"];
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.isPartnerCreateInvoice = _data["isPartnerCreateInvoice"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : <any>undefined;
            this.fixPackSize = _data["fixPackSize"];
            this.contourPackSize = _data["contourPackSize"];
            this.agreementSystemCreateDate = _data["agreementSystemCreateDate"] ? new Date(_data["agreementSystemCreateDate"].toString()) : <any>undefined;
            this.expired = _data["expired"];
            this.fixPackPrice = _data["fixPackPrice"];
            this.fixPackOverflowPrice = _data["fixPackOverflowPrice"];
            this.unitPrice = _data["unitPrice"];
            this.commissionRate = _data["commissionRate"];
            this.contourPackPrice = _data["contourPackPrice"];
        }
    }

    static fromJS(data: any): PartnerAgreementsDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAgreementsDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["code"] = this.code;
        data["description"] = this.description;
        data["partnerId"] = this.partnerId;
        data["partnerShortCode"] = this.partnerShortCode;
        data["partnerTitle"] = this.partnerTitle;
        data["agreementType"] = this.agreementType;
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["isPartnerCreateInvoice"] = this.isPartnerCreateInvoice;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        data["fixPackSize"] = this.fixPackSize;
        data["contourPackSize"] = this.contourPackSize;
        data["agreementSystemCreateDate"] = this.agreementSystemCreateDate ? this.agreementSystemCreateDate.toISOString() : <any>undefined;
        data["expired"] = this.expired;
        data["fixPackPrice"] = this.fixPackPrice;
        data["fixPackOverflowPrice"] = this.fixPackOverflowPrice;
        data["unitPrice"] = this.unitPrice;
        data["commissionRate"] = this.commissionRate;
        data["contourPackPrice"] = this.contourPackPrice;
        return data; 
    }
}

export interface IPartnerAgreementsDetailDTO {
    id?: number;
    status?: AgreementStatus;
    code?: string | undefined;
    description?: string | undefined;
    partnerId?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    agreementType?: AgreementType;
    serviceId?: number;
    serviceCode?: string | undefined;
    isPartnerCreateInvoice?: number;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    fixPackSize?: number;
    contourPackSize?: number | undefined;
    agreementSystemCreateDate?: Date;
    expired?: boolean;
    fixPackPrice?: number | undefined;
    fixPackOverflowPrice?: number | undefined;
    unitPrice?: number | undefined;
    commissionRate?: number | undefined;
    contourPackPrice?: number | undefined;
}

export class AddPartnerAgreementReq implements IAddPartnerAgreementReq {
    partnerAgreement?: PartnerAgreementsDetailDTO;

    constructor(data?: IAddPartnerAgreementReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerAgreement = _data["partnerAgreement"] ? PartnerAgreementsDetailDTO.fromJS(_data["partnerAgreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerAgreementReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerAgreementReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerAgreement"] = this.partnerAgreement ? this.partnerAgreement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPartnerAgreementReq {
    partnerAgreement?: PartnerAgreementsDetailDTO;
}

export class AddPartnerAgreementRes implements IAddPartnerAgreementRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    partnerAgreement?: PartnerAgreementsDetailDTO;

    constructor(data?: IAddPartnerAgreementRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.partnerAgreement = _data["partnerAgreement"] ? PartnerAgreementsDetailDTO.fromJS(_data["partnerAgreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerAgreementRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerAgreementRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["partnerAgreement"] = this.partnerAgreement ? this.partnerAgreement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPartnerAgreementRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    partnerAgreement?: PartnerAgreementsDetailDTO;
}

export class UpdatePartnerAgreementReq implements IUpdatePartnerAgreementReq {
    partnerAgreement?: PartnerAgreementsDetailDTO;

    constructor(data?: IUpdatePartnerAgreementReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerAgreement = _data["partnerAgreement"] ? PartnerAgreementsDetailDTO.fromJS(_data["partnerAgreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerAgreementReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerAgreementReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerAgreement"] = this.partnerAgreement ? this.partnerAgreement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePartnerAgreementReq {
    partnerAgreement?: PartnerAgreementsDetailDTO;
}

export class UpdatePartnerAgreementRes implements IUpdatePartnerAgreementRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    partnerAgreement?: PartnerAgreementsDetailDTO;

    constructor(data?: IUpdatePartnerAgreementRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.partnerAgreement = _data["partnerAgreement"] ? PartnerAgreementsDetailDTO.fromJS(_data["partnerAgreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerAgreementRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerAgreementRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["partnerAgreement"] = this.partnerAgreement ? this.partnerAgreement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePartnerAgreementRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    partnerAgreement?: PartnerAgreementsDetailDTO;
}

export class ExpirePartnerAgreementRequest implements IExpirePartnerAgreementRequest {
    id?: number;

    constructor(data?: IExpirePartnerAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExpirePartnerAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExpirePartnerAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IExpirePartnerAgreementRequest {
    id?: number;
}

export class CustomerAgreementsReq implements ICustomerAgreementsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    partnerId?: string | undefined;

    constructor(data?: ICustomerAgreementsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
            this.partnerId = _data["partnerId"];
        }
    }

    static fromJS(data: any): CustomerAgreementsReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAgreementsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["partnerId"] = this.partnerId;
        return data; 
    }
}

export interface ICustomerAgreementsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    partnerId?: string | undefined;
}

export class CustomerAgreementsDTO implements ICustomerAgreementsDTO {
    id?: number;
    status?: AgreementStatus;
    customerId?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
    partnerAgreementId?: number;
    partnerAgreementCode?: string | undefined;
    partnerAgreementType?: AgreementType;
    partnerFixPackSize?: number;
    partnerContourPackSize?: number | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    fixPackSize?: number;
    description?: string | undefined;
    isFreeService?: number | undefined;
    contourPackSize?: number | undefined;
    agreementSystemCreateDate?: Date;
    serviceId?: number | undefined;

    constructor(data?: ICustomerAgreementsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.customerId = _data["customerId"];
            this.customerShortCode = _data["customerShortCode"];
            this.customerTitle = _data["customerTitle"];
            this.partnerAgreementId = _data["partnerAgreementId"];
            this.partnerAgreementCode = _data["partnerAgreementCode"];
            this.partnerAgreementType = _data["partnerAgreementType"];
            this.partnerFixPackSize = _data["partnerFixPackSize"];
            this.partnerContourPackSize = _data["partnerContourPackSize"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : <any>undefined;
            this.fixPackSize = _data["fixPackSize"];
            this.description = _data["description"];
            this.isFreeService = _data["isFreeService"];
            this.contourPackSize = _data["contourPackSize"];
            this.agreementSystemCreateDate = _data["agreementSystemCreateDate"] ? new Date(_data["agreementSystemCreateDate"].toString()) : <any>undefined;
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): CustomerAgreementsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAgreementsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["customerId"] = this.customerId;
        data["customerShortCode"] = this.customerShortCode;
        data["customerTitle"] = this.customerTitle;
        data["partnerAgreementId"] = this.partnerAgreementId;
        data["partnerAgreementCode"] = this.partnerAgreementCode;
        data["partnerAgreementType"] = this.partnerAgreementType;
        data["partnerFixPackSize"] = this.partnerFixPackSize;
        data["partnerContourPackSize"] = this.partnerContourPackSize;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        data["fixPackSize"] = this.fixPackSize;
        data["description"] = this.description;
        data["isFreeService"] = this.isFreeService;
        data["contourPackSize"] = this.contourPackSize;
        data["agreementSystemCreateDate"] = this.agreementSystemCreateDate ? this.agreementSystemCreateDate.toISOString() : <any>undefined;
        data["serviceId"] = this.serviceId;
        return data; 
    }
}

export interface ICustomerAgreementsDTO {
    id?: number;
    status?: AgreementStatus;
    customerId?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
    partnerAgreementId?: number;
    partnerAgreementCode?: string | undefined;
    partnerAgreementType?: AgreementType;
    partnerFixPackSize?: number;
    partnerContourPackSize?: number | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    fixPackSize?: number;
    description?: string | undefined;
    isFreeService?: number | undefined;
    contourPackSize?: number | undefined;
    agreementSystemCreateDate?: Date;
    serviceId?: number | undefined;
}

export class CustomerAgreementsRes implements ICustomerAgreementsRes {
    totalRecordCount?: number;
    listData?: CustomerAgreementsDTO[] | undefined;

    constructor(data?: ICustomerAgreementsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerAgreementsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerAgreementsRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAgreementsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerAgreementsRes {
    totalRecordCount?: number;
    listData?: CustomerAgreementsDTO[] | undefined;
}

export class CustomerAgreementsDetailDTO implements ICustomerAgreementsDetailDTO {
    id?: number;
    status?: AgreementStatus;
    customerId?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
    partnerAgreementId?: number;
    partnerAgreementCode?: string | undefined;
    partnerAgreementType?: AgreementType;
    partnerFixPackSize?: number;
    partnerContourPackSize?: number | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    fixPackSize?: number;
    description?: string | undefined;
    isFreeService?: number | undefined;
    contourPackSize?: number | undefined;
    agreementSystemCreateDate?: Date;
    serviceId?: number | undefined;
    isPriceFieldsUpdatable?: boolean;
    fixPackPrice?: number | undefined;
    fixPackOverflowPrice?: number | undefined;
    unitPrice?: number | undefined;
    partnerAgreementFixPackPrice?: number | undefined;
    partnerAgreementContourPackPrice?: number | undefined;
    partnerAgreementFixPackOverflowPrice?: number | undefined;
    partnerAgreementUnitPrice?: number | undefined;
    partnerAgreementServiceId?: number | undefined;
    partnerAgreementServiceCode?: string | undefined;
    contourPackPrice?: number | undefined;

    constructor(data?: ICustomerAgreementsDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.customerId = _data["customerId"];
            this.customerShortCode = _data["customerShortCode"];
            this.customerTitle = _data["customerTitle"];
            this.partnerAgreementId = _data["partnerAgreementId"];
            this.partnerAgreementCode = _data["partnerAgreementCode"];
            this.partnerAgreementType = _data["partnerAgreementType"];
            this.partnerFixPackSize = _data["partnerFixPackSize"];
            this.partnerContourPackSize = _data["partnerContourPackSize"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : <any>undefined;
            this.fixPackSize = _data["fixPackSize"];
            this.description = _data["description"];
            this.isFreeService = _data["isFreeService"];
            this.contourPackSize = _data["contourPackSize"];
            this.agreementSystemCreateDate = _data["agreementSystemCreateDate"] ? new Date(_data["agreementSystemCreateDate"].toString()) : <any>undefined;
            this.serviceId = _data["serviceId"];
            this.isPriceFieldsUpdatable = _data["isPriceFieldsUpdatable"];
            this.fixPackPrice = _data["fixPackPrice"];
            this.fixPackOverflowPrice = _data["fixPackOverflowPrice"];
            this.unitPrice = _data["unitPrice"];
            this.partnerAgreementFixPackPrice = _data["partnerAgreementFixPackPrice"];
            this.partnerAgreementContourPackPrice = _data["partnerAgreementContourPackPrice"];
            this.partnerAgreementFixPackOverflowPrice = _data["partnerAgreementFixPackOverflowPrice"];
            this.partnerAgreementUnitPrice = _data["partnerAgreementUnitPrice"];
            this.partnerAgreementServiceId = _data["partnerAgreementServiceId"];
            this.partnerAgreementServiceCode = _data["partnerAgreementServiceCode"];
            this.contourPackPrice = _data["contourPackPrice"];
        }
    }

    static fromJS(data: any): CustomerAgreementsDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAgreementsDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["customerId"] = this.customerId;
        data["customerShortCode"] = this.customerShortCode;
        data["customerTitle"] = this.customerTitle;
        data["partnerAgreementId"] = this.partnerAgreementId;
        data["partnerAgreementCode"] = this.partnerAgreementCode;
        data["partnerAgreementType"] = this.partnerAgreementType;
        data["partnerFixPackSize"] = this.partnerFixPackSize;
        data["partnerContourPackSize"] = this.partnerContourPackSize;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        data["fixPackSize"] = this.fixPackSize;
        data["description"] = this.description;
        data["isFreeService"] = this.isFreeService;
        data["contourPackSize"] = this.contourPackSize;
        data["agreementSystemCreateDate"] = this.agreementSystemCreateDate ? this.agreementSystemCreateDate.toISOString() : <any>undefined;
        data["serviceId"] = this.serviceId;
        data["isPriceFieldsUpdatable"] = this.isPriceFieldsUpdatable;
        data["fixPackPrice"] = this.fixPackPrice;
        data["fixPackOverflowPrice"] = this.fixPackOverflowPrice;
        data["unitPrice"] = this.unitPrice;
        data["partnerAgreementFixPackPrice"] = this.partnerAgreementFixPackPrice;
        data["partnerAgreementContourPackPrice"] = this.partnerAgreementContourPackPrice;
        data["partnerAgreementFixPackOverflowPrice"] = this.partnerAgreementFixPackOverflowPrice;
        data["partnerAgreementUnitPrice"] = this.partnerAgreementUnitPrice;
        data["partnerAgreementServiceId"] = this.partnerAgreementServiceId;
        data["partnerAgreementServiceCode"] = this.partnerAgreementServiceCode;
        data["contourPackPrice"] = this.contourPackPrice;
        return data; 
    }
}

export interface ICustomerAgreementsDetailDTO {
    id?: number;
    status?: AgreementStatus;
    customerId?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
    partnerAgreementId?: number;
    partnerAgreementCode?: string | undefined;
    partnerAgreementType?: AgreementType;
    partnerFixPackSize?: number;
    partnerContourPackSize?: number | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    fixPackSize?: number;
    description?: string | undefined;
    isFreeService?: number | undefined;
    contourPackSize?: number | undefined;
    agreementSystemCreateDate?: Date;
    serviceId?: number | undefined;
    isPriceFieldsUpdatable?: boolean;
    fixPackPrice?: number | undefined;
    fixPackOverflowPrice?: number | undefined;
    unitPrice?: number | undefined;
    partnerAgreementFixPackPrice?: number | undefined;
    partnerAgreementContourPackPrice?: number | undefined;
    partnerAgreementFixPackOverflowPrice?: number | undefined;
    partnerAgreementUnitPrice?: number | undefined;
    partnerAgreementServiceId?: number | undefined;
    partnerAgreementServiceCode?: string | undefined;
    contourPackPrice?: number | undefined;
}

export class AddCustomerAgreementsReq implements IAddCustomerAgreementsReq {
    customerAgreement?: CustomerAgreementsDetailDTO;

    constructor(data?: IAddCustomerAgreementsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAgreement = _data["customerAgreement"] ? CustomerAgreementsDetailDTO.fromJS(_data["customerAgreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerAgreementsReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerAgreementsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAgreement"] = this.customerAgreement ? this.customerAgreement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerAgreementsReq {
    customerAgreement?: CustomerAgreementsDetailDTO;
}

export class AddCustomerAgreementsRes implements IAddCustomerAgreementsRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerAgreement?: CustomerAgreementsDetailDTO;

    constructor(data?: IAddCustomerAgreementsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerAgreement = _data["customerAgreement"] ? CustomerAgreementsDetailDTO.fromJS(_data["customerAgreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerAgreementsRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerAgreementsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerAgreement"] = this.customerAgreement ? this.customerAgreement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerAgreementsRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerAgreement?: CustomerAgreementsDetailDTO;
}

export class UpdateCustomerAgreementsReq implements IUpdateCustomerAgreementsReq {
    customerAgreement?: CustomerAgreementsDetailDTO;

    constructor(data?: IUpdateCustomerAgreementsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAgreement = _data["customerAgreement"] ? CustomerAgreementsDetailDTO.fromJS(_data["customerAgreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerAgreementsReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerAgreementsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAgreement"] = this.customerAgreement ? this.customerAgreement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerAgreementsReq {
    customerAgreement?: CustomerAgreementsDetailDTO;
}

export class UpdateCustomerAgreementsRes implements IUpdateCustomerAgreementsRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerAgreement?: CustomerAgreementsDetailDTO;

    constructor(data?: IUpdateCustomerAgreementsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerAgreement = _data["customerAgreement"] ? CustomerAgreementsDetailDTO.fromJS(_data["customerAgreement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerAgreementsRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerAgreementsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerAgreement"] = this.customerAgreement ? this.customerAgreement.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerAgreementsRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerAgreement?: CustomerAgreementsDetailDTO;
}

export class AgreementServiceCoefReq implements IAgreementServiceCoefReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IAgreementServiceCoefReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgreementServiceCoefReq {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementServiceCoefReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAgreementServiceCoefReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class AgreementServiceCoefDTO implements IAgreementServiceCoefDTO {
    id?: number;
    serviceId?: number;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    divideCoef?: number;
    description?: string | undefined;
    serviceCode?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;

    constructor(data?: IAgreementServiceCoefDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.partnerId = _data["partnerId"];
            this.customerId = _data["customerId"];
            this.divideCoef = _data["divideCoef"];
            this.description = _data["description"];
            this.serviceCode = _data["serviceCode"];
            this.partnerShortCode = _data["partnerShortCode"];
            this.partnerTitle = _data["partnerTitle"];
            this.customerShortCode = _data["customerShortCode"];
            this.customerTitle = _data["customerTitle"];
        }
    }

    static fromJS(data: any): AgreementServiceCoefDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementServiceCoefDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["partnerId"] = this.partnerId;
        data["customerId"] = this.customerId;
        data["divideCoef"] = this.divideCoef;
        data["description"] = this.description;
        data["serviceCode"] = this.serviceCode;
        data["partnerShortCode"] = this.partnerShortCode;
        data["partnerTitle"] = this.partnerTitle;
        data["customerShortCode"] = this.customerShortCode;
        data["customerTitle"] = this.customerTitle;
        return data; 
    }
}

export interface IAgreementServiceCoefDTO {
    id?: number;
    serviceId?: number;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    divideCoef?: number;
    description?: string | undefined;
    serviceCode?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
}

export class AgreementServiceCoefRes implements IAgreementServiceCoefRes {
    totalRecordCount?: number;
    listData?: AgreementServiceCoefDTO[] | undefined;

    constructor(data?: IAgreementServiceCoefRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(AgreementServiceCoefDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgreementServiceCoefRes {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementServiceCoefRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAgreementServiceCoefRes {
    totalRecordCount?: number;
    listData?: AgreementServiceCoefDTO[] | undefined;
}

export class AddAgreementServiceCoefReq implements IAddAgreementServiceCoefReq {
    agreementServiceCoef?: AgreementServiceCoefDTO;

    constructor(data?: IAddAgreementServiceCoefReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementServiceCoef = _data["agreementServiceCoef"] ? AgreementServiceCoefDTO.fromJS(_data["agreementServiceCoef"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddAgreementServiceCoefReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddAgreementServiceCoefReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementServiceCoef"] = this.agreementServiceCoef ? this.agreementServiceCoef.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddAgreementServiceCoefReq {
    agreementServiceCoef?: AgreementServiceCoefDTO;
}

export class AddAgreementServiceCoefRes implements IAddAgreementServiceCoefRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    agreementServiceCoef?: AgreementServiceCoefDTO;

    constructor(data?: IAddAgreementServiceCoefRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.agreementServiceCoef = _data["agreementServiceCoef"] ? AgreementServiceCoefDTO.fromJS(_data["agreementServiceCoef"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddAgreementServiceCoefRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddAgreementServiceCoefRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["agreementServiceCoef"] = this.agreementServiceCoef ? this.agreementServiceCoef.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddAgreementServiceCoefRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    agreementServiceCoef?: AgreementServiceCoefDTO;
}

export class UpdateAgreementServiceCoefReq implements IUpdateAgreementServiceCoefReq {
    agreementServiceCoef?: AgreementServiceCoefDTO;

    constructor(data?: IUpdateAgreementServiceCoefReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementServiceCoef = _data["agreementServiceCoef"] ? AgreementServiceCoefDTO.fromJS(_data["agreementServiceCoef"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAgreementServiceCoefReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgreementServiceCoefReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementServiceCoef"] = this.agreementServiceCoef ? this.agreementServiceCoef.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateAgreementServiceCoefReq {
    agreementServiceCoef?: AgreementServiceCoefDTO;
}

export class UpdateAgreementServiceCoefRes implements IUpdateAgreementServiceCoefRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    agreementServiceCoef?: AgreementServiceCoefDTO;

    constructor(data?: IUpdateAgreementServiceCoefRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.agreementServiceCoef = _data["agreementServiceCoef"] ? AgreementServiceCoefDTO.fromJS(_data["agreementServiceCoef"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAgreementServiceCoefRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAgreementServiceCoefRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["agreementServiceCoef"] = this.agreementServiceCoef ? this.agreementServiceCoef.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateAgreementServiceCoefRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    agreementServiceCoef?: AgreementServiceCoefDTO;
}

export class PathListReq implements IPathListReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IPathListReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PathListReq {
        data = typeof data === 'object' ? data : {};
        let result = new PathListReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPathListReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class ApiLocalizationPathDTO implements IApiLocalizationPathDTO {
    id?: number;
    isActive?: boolean;
    requestPath?: string | undefined;
    responseJsonPath?: string | undefined;

    constructor(data?: IApiLocalizationPathDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.requestPath = _data["requestPath"];
            this.responseJsonPath = _data["responseJsonPath"];
        }
    }

    static fromJS(data: any): ApiLocalizationPathDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApiLocalizationPathDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["requestPath"] = this.requestPath;
        data["responseJsonPath"] = this.responseJsonPath;
        return data; 
    }
}

export interface IApiLocalizationPathDTO {
    id?: number;
    isActive?: boolean;
    requestPath?: string | undefined;
    responseJsonPath?: string | undefined;
}

export class PathListRes implements IPathListRes {
    totalRecordCount?: number;
    listData?: ApiLocalizationPathDTO[] | undefined;

    constructor(data?: IPathListRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(ApiLocalizationPathDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PathListRes {
        data = typeof data === 'object' ? data : {};
        let result = new PathListRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPathListRes {
    totalRecordCount?: number;
    listData?: ApiLocalizationPathDTO[] | undefined;
}

export class AddPathReq implements IAddPathReq {
    apiLocalizationPath?: ApiLocalizationPathDTO;

    constructor(data?: IAddPathReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiLocalizationPath = _data["apiLocalizationPath"] ? ApiLocalizationPathDTO.fromJS(_data["apiLocalizationPath"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPathReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddPathReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiLocalizationPath"] = this.apiLocalizationPath ? this.apiLocalizationPath.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPathReq {
    apiLocalizationPath?: ApiLocalizationPathDTO;
}

export class AddPathRes implements IAddPathRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    apiLocalizationPath?: ApiLocalizationPathDTO;

    constructor(data?: IAddPathRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.apiLocalizationPath = _data["apiLocalizationPath"] ? ApiLocalizationPathDTO.fromJS(_data["apiLocalizationPath"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPathRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddPathRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["apiLocalizationPath"] = this.apiLocalizationPath ? this.apiLocalizationPath.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPathRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    apiLocalizationPath?: ApiLocalizationPathDTO;
}

export class UpdatePathReq implements IUpdatePathReq {
    apiLocalizationPath?: ApiLocalizationPathDTO;

    constructor(data?: IUpdatePathReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiLocalizationPath = _data["apiLocalizationPath"] ? ApiLocalizationPathDTO.fromJS(_data["apiLocalizationPath"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePathReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePathReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiLocalizationPath"] = this.apiLocalizationPath ? this.apiLocalizationPath.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePathReq {
    apiLocalizationPath?: ApiLocalizationPathDTO;
}

export class UpdatePathRes implements IUpdatePathRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    apiLocalizationPath?: ApiLocalizationPathDTO;

    constructor(data?: IUpdatePathRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.apiLocalizationPath = _data["apiLocalizationPath"] ? ApiLocalizationPathDTO.fromJS(_data["apiLocalizationPath"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePathRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePathRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["apiLocalizationPath"] = this.apiLocalizationPath ? this.apiLocalizationPath.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePathRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    apiLocalizationPath?: ApiLocalizationPathDTO;
}

export class CustomerApiLanguagesListReq implements ICustomerApiLanguagesListReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: ICustomerApiLanguagesListReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerApiLanguagesListReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerApiLanguagesListReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerApiLanguagesListReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class CustomerApiLanguagesDTO implements ICustomerApiLanguagesDTO {
    id?: number;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    langCode?: string | undefined;
    isLocalizationDisabled?: boolean;

    constructor(data?: ICustomerApiLanguagesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customerTitle = _data["customerTitle"];
            this.langCode = _data["langCode"];
            this.isLocalizationDisabled = _data["isLocalizationDisabled"];
        }
    }

    static fromJS(data: any): CustomerApiLanguagesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerApiLanguagesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customerTitle"] = this.customerTitle;
        data["langCode"] = this.langCode;
        data["isLocalizationDisabled"] = this.isLocalizationDisabled;
        return data; 
    }
}

export interface ICustomerApiLanguagesDTO {
    id?: number;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    langCode?: string | undefined;
    isLocalizationDisabled?: boolean;
}

export class CustomerApiLanguagesListRes implements ICustomerApiLanguagesListRes {
    totalRecordCount?: number;
    listData?: CustomerApiLanguagesDTO[] | undefined;

    constructor(data?: ICustomerApiLanguagesListRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerApiLanguagesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerApiLanguagesListRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerApiLanguagesListRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerApiLanguagesListRes {
    totalRecordCount?: number;
    listData?: CustomerApiLanguagesDTO[] | undefined;
}

export class AddCustomerApiLanguagesReq implements IAddCustomerApiLanguagesReq {
    customerApiLanguages?: CustomerApiLanguagesDTO;

    constructor(data?: IAddCustomerApiLanguagesReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerApiLanguages = _data["customerApiLanguages"] ? CustomerApiLanguagesDTO.fromJS(_data["customerApiLanguages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerApiLanguagesReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerApiLanguagesReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerApiLanguages"] = this.customerApiLanguages ? this.customerApiLanguages.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerApiLanguagesReq {
    customerApiLanguages?: CustomerApiLanguagesDTO;
}

export class AddCustomerApiLanguagesRes implements IAddCustomerApiLanguagesRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerApiLanguages?: CustomerApiLanguagesDTO;

    constructor(data?: IAddCustomerApiLanguagesRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerApiLanguages = _data["customerApiLanguages"] ? CustomerApiLanguagesDTO.fromJS(_data["customerApiLanguages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerApiLanguagesRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerApiLanguagesRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerApiLanguages"] = this.customerApiLanguages ? this.customerApiLanguages.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerApiLanguagesRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerApiLanguages?: CustomerApiLanguagesDTO;
}

export class UpdateCustomerApiLanguagesReq implements IUpdateCustomerApiLanguagesReq {
    customerApiLanguages?: CustomerApiLanguagesDTO;

    constructor(data?: IUpdateCustomerApiLanguagesReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerApiLanguages = _data["customerApiLanguages"] ? CustomerApiLanguagesDTO.fromJS(_data["customerApiLanguages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerApiLanguagesReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerApiLanguagesReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerApiLanguages"] = this.customerApiLanguages ? this.customerApiLanguages.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerApiLanguagesReq {
    customerApiLanguages?: CustomerApiLanguagesDTO;
}

export class UpdateCustomerApiLanguagesRes implements IUpdateCustomerApiLanguagesRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerApiLanguages?: CustomerApiLanguagesDTO;

    constructor(data?: IUpdateCustomerApiLanguagesRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerApiLanguages = _data["customerApiLanguages"] ? CustomerApiLanguagesDTO.fromJS(_data["customerApiLanguages"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerApiLanguagesRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerApiLanguagesRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerApiLanguages"] = this.customerApiLanguages ? this.customerApiLanguages.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerApiLanguagesRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerApiLanguages?: CustomerApiLanguagesDTO;
}

export class ApiTextValuesReq implements IApiTextValuesReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IApiTextValuesReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiTextValuesReq {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTextValuesReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApiTextValuesReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class ApiTextValueDTO implements IApiTextValueDTO {
    id?: number;
    requestPath?: string | undefined;
    responseJsonPath?: string | undefined;
    langCode?: string | undefined;
    textCode?: string | undefined;
    textValue?: string | undefined;
    isIgnored?: boolean;

    constructor(data?: IApiTextValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.requestPath = _data["requestPath"];
            this.responseJsonPath = _data["responseJsonPath"];
            this.langCode = _data["langCode"];
            this.textCode = _data["textCode"];
            this.textValue = _data["textValue"];
            this.isIgnored = _data["isIgnored"];
        }
    }

    static fromJS(data: any): ApiTextValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTextValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["requestPath"] = this.requestPath;
        data["responseJsonPath"] = this.responseJsonPath;
        data["langCode"] = this.langCode;
        data["textCode"] = this.textCode;
        data["textValue"] = this.textValue;
        data["isIgnored"] = this.isIgnored;
        return data; 
    }
}

export interface IApiTextValueDTO {
    id?: number;
    requestPath?: string | undefined;
    responseJsonPath?: string | undefined;
    langCode?: string | undefined;
    textCode?: string | undefined;
    textValue?: string | undefined;
    isIgnored?: boolean;
}

export class ApiTextValuesRes implements IApiTextValuesRes {
    totalRecordCount?: number;
    listData?: ApiTextValueDTO[] | undefined;

    constructor(data?: IApiTextValuesRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(ApiTextValueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiTextValuesRes {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTextValuesRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IApiTextValuesRes {
    totalRecordCount?: number;
    listData?: ApiTextValueDTO[] | undefined;
}

export class UpdateApiTextValueReq implements IUpdateApiTextValueReq {
    id?: number;
    textValue?: string | undefined;
    isIgnored?: boolean;

    constructor(data?: IUpdateApiTextValueReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.textValue = _data["textValue"];
            this.isIgnored = _data["isIgnored"];
        }
    }

    static fromJS(data: any): UpdateApiTextValueReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApiTextValueReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["textValue"] = this.textValue;
        data["isIgnored"] = this.isIgnored;
        return data; 
    }
}

export interface IUpdateApiTextValueReq {
    id?: number;
    textValue?: string | undefined;
    isIgnored?: boolean;
}

export class AppPrmDefinitionsReq implements IAppPrmDefinitionsReq {
    serviceId?: number | undefined;
    appParameterGroupId?: number | undefined;

    constructor(data?: IAppPrmDefinitionsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.appParameterGroupId = _data["appParameterGroupId"];
        }
    }

    static fromJS(data: any): AppPrmDefinitionsReq {
        data = typeof data === 'object' ? data : {};
        let result = new AppPrmDefinitionsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["appParameterGroupId"] = this.appParameterGroupId;
        return data; 
    }
}

export interface IAppPrmDefinitionsReq {
    serviceId?: number | undefined;
    appParameterGroupId?: number | undefined;
}

export enum ParameterValueType {
    Numeric = "Numeric",
    String = "String",
    Date = "Date",
    Datetime = "Datetime",
    Bool = "Bool",
    List = "List",
}

export class AppPrmDefinitionDTO implements IAppPrmDefinitionDTO {
    serviceId?: number | undefined;
    serviceCode?: string | undefined;
    appParameterGroupId?: number | undefined;
    appParameterGroupName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    valueType?: ParameterValueType;
    valueList?: string[] | undefined;
    valueFilterRegExpr?: string | undefined;

    constructor(data?: IAppPrmDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.appParameterGroupId = _data["appParameterGroupId"];
            this.appParameterGroupName = _data["appParameterGroupName"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.valueType = _data["valueType"];
            if (Array.isArray(_data["valueList"])) {
                this.valueList = [] as any;
                for (let item of _data["valueList"])
                    this.valueList!.push(item);
            }
            this.valueFilterRegExpr = _data["valueFilterRegExpr"];
        }
    }

    static fromJS(data: any): AppPrmDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppPrmDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["appParameterGroupId"] = this.appParameterGroupId;
        data["appParameterGroupName"] = this.appParameterGroupName;
        data["code"] = this.code;
        data["description"] = this.description;
        data["valueType"] = this.valueType;
        if (Array.isArray(this.valueList)) {
            data["valueList"] = [];
            for (let item of this.valueList)
                data["valueList"].push(item);
        }
        data["valueFilterRegExpr"] = this.valueFilterRegExpr;
        return data; 
    }
}

export interface IAppPrmDefinitionDTO {
    serviceId?: number | undefined;
    serviceCode?: string | undefined;
    appParameterGroupId?: number | undefined;
    appParameterGroupName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    valueType?: ParameterValueType;
    valueList?: string[] | undefined;
    valueFilterRegExpr?: string | undefined;
}

export class AppPrmDefinitionsRes implements IAppPrmDefinitionsRes {
    appPrmDefinitions?: AppPrmDefinitionDTO[] | undefined;

    constructor(data?: IAppPrmDefinitionsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["appPrmDefinitions"])) {
                this.appPrmDefinitions = [] as any;
                for (let item of _data["appPrmDefinitions"])
                    this.appPrmDefinitions!.push(AppPrmDefinitionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppPrmDefinitionsRes {
        data = typeof data === 'object' ? data : {};
        let result = new AppPrmDefinitionsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.appPrmDefinitions)) {
            data["appPrmDefinitions"] = [];
            for (let item of this.appPrmDefinitions)
                data["appPrmDefinitions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAppPrmDefinitionsRes {
    appPrmDefinitions?: AppPrmDefinitionDTO[] | undefined;
}

export class PartnerParametersReq implements IPartnerParametersReq {
    partnerId?: string | undefined;
    serviceId?: number | undefined;
    appParameterGroupId?: number | undefined;
    language?: string | undefined;

    constructor(data?: IPartnerParametersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.serviceId = _data["serviceId"];
            this.appParameterGroupId = _data["appParameterGroupId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): PartnerParametersReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerParametersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["serviceId"] = this.serviceId;
        data["appParameterGroupId"] = this.appParameterGroupId;
        data["language"] = this.language;
        return data; 
    }
}

export interface IPartnerParametersReq {
    partnerId?: string | undefined;
    serviceId?: number | undefined;
    appParameterGroupId?: number | undefined;
    language?: string | undefined;
}

export class AppParameterInfoDTO implements IAppParameterInfoDTO {
    serviceId?: number | undefined;
    serviceCode?: string | undefined;
    appParameterGroupId?: number | undefined;
    appParameterGroupName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    valueType?: ParameterValueType;
    value?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IAppParameterInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.appParameterGroupId = _data["appParameterGroupId"];
            this.appParameterGroupName = _data["appParameterGroupName"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.valueType = _data["valueType"];
            this.value = _data["value"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AppParameterInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppParameterInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["appParameterGroupId"] = this.appParameterGroupId;
        data["appParameterGroupName"] = this.appParameterGroupName;
        data["code"] = this.code;
        data["description"] = this.description;
        data["valueType"] = this.valueType;
        data["value"] = this.value;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface IAppParameterInfoDTO {
    serviceId?: number | undefined;
    serviceCode?: string | undefined;
    appParameterGroupId?: number | undefined;
    appParameterGroupName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    valueType?: ParameterValueType;
    value?: string | undefined;
    notes?: string | undefined;
}

export class CustomerParametersReq implements ICustomerParametersReq {
    customerId?: string | undefined;
    serviceId?: number | undefined;
    appParameterGroupId?: number | undefined;
    language?: string | undefined;

    constructor(data?: ICustomerParametersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
            this.appParameterGroupId = _data["appParameterGroupId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): CustomerParametersReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerParametersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        data["appParameterGroupId"] = this.appParameterGroupId;
        data["language"] = this.language;
        return data; 
    }
}

export interface ICustomerParametersReq {
    customerId?: string | undefined;
    serviceId?: number | undefined;
    appParameterGroupId?: number | undefined;
    language?: string | undefined;
}

export class ParameterDetailReq implements IParameterDetailReq {
    parameterCode?: string | undefined;
    serviceId?: number | undefined;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    customerBranchId?: number | undefined;
    language?: string | undefined;

    constructor(data?: IParameterDetailReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterCode = _data["parameterCode"];
            this.partnerId = _data["partnerId"];
            this.customerId = _data["customerId"];
            this.customerBranchId = _data["customerBranchId"];
            this.language = _data["language"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): ParameterDetailReq {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterDetailReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterCode"] = this.parameterCode;
        data["partnerId"] = this.partnerId;
        data["customerId"] = this.customerId;
        data["customerBranchId"] = this.customerBranchId;
        data["language"] = this.language;
        data["serviceId"] = this.serviceId;
        return data; 
    }
}

export interface IParameterDetailReq {
    parameterCode?: string | undefined;
    serviceId?: number | undefined;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    customerBranchId?: number | undefined;
    language?: string | undefined;
}

export class AppParameterValuesDTO implements IAppParameterValuesDTO {
    parameterCode?: string | undefined;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    customerBranchId?: number | undefined;
    language?: string | undefined;
    isSystemParameterUpdatable?: boolean;
    isPartnerParameterUpdatable?: boolean;
    isCustomerParameterUpdatable?: boolean;
    isCustomerBranchParameterUpdatable?: boolean;
    id?: string | undefined;
    systemValue?: string | undefined;
    partnerValue?: string | undefined;
    customerValue?: string | undefined;
    customerBranchValue?: string | undefined;
    systemNotes?: string | undefined;
    partnerNotes?: string | undefined;
    customerNotes?: string | undefined;
    customerBranchNotes?: string | undefined;
    serviceId?: number;

    constructor(data?: IAppParameterValuesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterCode = _data["parameterCode"];
            this.partnerId = _data["partnerId"];
            this.customerId = _data["customerId"];
            this.customerBranchId = _data["customerBranchId"];
            this.language = _data["language"];
            this.isSystemParameterUpdatable = _data["isSystemParameterUpdatable"];
            this.isPartnerParameterUpdatable = _data["isPartnerParameterUpdatable"];
            this.isCustomerParameterUpdatable = _data["isCustomerParameterUpdatable"];
            this.isCustomerBranchParameterUpdatable = _data["isCustomerBranchParameterUpdatable"];
            this.id = _data["id"];
            this.systemValue = _data["systemValue"];
            this.partnerValue = _data["partnerValue"];
            this.customerValue = _data["customerValue"];
            this.customerBranchValue = _data["customerBranchValue"];
            this.systemNotes = _data["systemNotes"];
            this.partnerNotes = _data["partnerNotes"];
            this.customerNotes = _data["customerNotes"];
            this.customerBranchNotes = _data["customerBranchNotes"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): AppParameterValuesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppParameterValuesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterCode"] = this.parameterCode;
        data["partnerId"] = this.partnerId;
        data["customerId"] = this.customerId;
        data["customerBranchId"] = this.customerBranchId;
        data["language"] = this.language;
        data["isSystemParameterUpdatable"] = this.isSystemParameterUpdatable;
        data["isPartnerParameterUpdatable"] = this.isPartnerParameterUpdatable;
        data["isCustomerParameterUpdatable"] = this.isCustomerParameterUpdatable;
        data["isCustomerBranchParameterUpdatable"] = this.isCustomerBranchParameterUpdatable;
        data["id"] = this.id;
        data["systemValue"] = this.systemValue;
        data["partnerValue"] = this.partnerValue;
        data["customerValue"] = this.customerValue;
        data["customerBranchValue"] = this.customerBranchValue;
        data["systemNotes"] = this.systemNotes;
        data["partnerNotes"] = this.partnerNotes;
        data["customerNotes"] = this.customerNotes;
        data["customerBranchNotes"] = this.customerBranchNotes;
        data["serviceId"] = this.serviceId;
        return data; 
    }
}

export interface IAppParameterValuesDTO {
    parameterCode?: string | undefined;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    customerBranchId?: number | undefined;
    language?: string | undefined;
    isSystemParameterUpdatable?: boolean;
    isPartnerParameterUpdatable?: boolean;
    isCustomerParameterUpdatable?: boolean;
    isCustomerBranchParameterUpdatable?: boolean;
    id?: string | undefined;
    systemValue?: string | undefined;
    partnerValue?: string | undefined;
    customerValue?: string | undefined;
    customerBranchValue?: string | undefined;
    systemNotes?: string | undefined;
    partnerNotes?: string | undefined;
    customerNotes?: string | undefined;
    customerBranchNotes?: string | undefined;
    serviceId?: number;
}

export class ParameterDetailRes implements IParameterDetailRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    parameterValues?: AppParameterValuesDTO;

    constructor(data?: IParameterDetailRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.parameterValues = _data["parameterValues"] ? AppParameterValuesDTO.fromJS(_data["parameterValues"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParameterDetailRes {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterDetailRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["parameterValues"] = this.parameterValues ? this.parameterValues.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IParameterDetailRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    parameterValues?: AppParameterValuesDTO;
}

export class UpdateParameterReq implements IUpdateParameterReq {
    parameterValues?: AppParameterValuesDTO;

    constructor(data?: IUpdateParameterReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterValues = _data["parameterValues"] ? AppParameterValuesDTO.fromJS(_data["parameterValues"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateParameterReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParameterReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterValues"] = this.parameterValues ? this.parameterValues.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateParameterReq {
    parameterValues?: AppParameterValuesDTO;
}

export class UpdateParameterRes implements IUpdateParameterRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    parameterValues?: AppParameterValuesDTO;

    constructor(data?: IUpdateParameterRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.parameterValues = _data["parameterValues"] ? AppParameterValuesDTO.fromJS(_data["parameterValues"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateParameterRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateParameterRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["parameterValues"] = this.parameterValues ? this.parameterValues.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateParameterRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    parameterValues?: AppParameterValuesDTO;
}

export class CustomerContactsDTO implements ICustomerContactsDTO {
    id?: number | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobilPhone?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICustomerContactsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobilPhone = _data["mobilPhone"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CustomerContactsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContactsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["title"] = this.title;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobilPhone"] = this.mobilPhone;
        data["description"] = this.description;
        return data; 
    }
}

export interface ICustomerContactsDTO {
    id?: number | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobilPhone?: string | undefined;
    description?: string | undefined;
}

export class CustomerDTO implements ICustomerDTO {
    id?: string | undefined;
    shortCode?: string | undefined;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    contourMasterCustomerId?: string | undefined;
    contourMasterCustomerTitle?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    businessCode?: string | undefined;
    notes?: string | undefined;
    isStateAgency?: number | undefined;
    personName?: string | undefined;
    personSurname?: string | undefined;
    creatorPartnerId?: string | undefined;
    personMiddleName?: string | undefined;
    neviIdentificationId?: string | undefined;

    constructor(data?: ICustomerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortCode = _data["shortCode"];
            this.partnerId = _data["partnerId"];
            this.partnerTitle = _data["partnerTitle"];
            this.title = _data["title"];
            this.identificationId = _data["identificationId"];
            this.contourMasterCustomerId = _data["contourMasterCustomerId"];
            this.contourMasterCustomerTitle = _data["contourMasterCustomerTitle"];
            this.addressRoomNumber = _data["addressRoomNumber"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressBuildingName = _data["addressBuildingName"];
            this.addressBuildingNumber = _data["addressBuildingNumber"];
            this.addressCitySubdivisionId = _data["addressCitySubdivisionId"];
            this.addressCitySubdivisionName = _data["addressCitySubdivisionName"];
            this.addressCityId = _data["addressCityId"];
            this.addressCityName = _data["addressCityName"];
            this.addressPostalZone = _data["addressPostalZone"];
            this.addressRegion = _data["addressRegion"];
            this.addressCountryId = _data["addressCountryId"];
            this.addressCountryName = _data["addressCountryName"];
            this.taxAdministrationName = _data["taxAdministrationName"];
            this.telephone = _data["telephone"];
            this.eMail = _data["eMail"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.registrationNumber = _data["registrationNumber"];
            this.mersisNumber = _data["mersisNumber"];
            this.businessCode = _data["businessCode"];
            this.notes = _data["notes"];
            this.isStateAgency = _data["isStateAgency"];
            this.personName = _data["personName"];
            this.personSurname = _data["personSurname"];
            this.creatorPartnerId = _data["creatorPartnerId"];
            this.personMiddleName = _data["personMiddleName"];
            this.neviIdentificationId = _data["neviIdentificationId"];
        }
    }

    static fromJS(data: any): CustomerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortCode"] = this.shortCode;
        data["partnerId"] = this.partnerId;
        data["partnerTitle"] = this.partnerTitle;
        data["title"] = this.title;
        data["identificationId"] = this.identificationId;
        data["contourMasterCustomerId"] = this.contourMasterCustomerId;
        data["contourMasterCustomerTitle"] = this.contourMasterCustomerTitle;
        data["addressRoomNumber"] = this.addressRoomNumber;
        data["addressStreetName"] = this.addressStreetName;
        data["addressBuildingName"] = this.addressBuildingName;
        data["addressBuildingNumber"] = this.addressBuildingNumber;
        data["addressCitySubdivisionId"] = this.addressCitySubdivisionId;
        data["addressCitySubdivisionName"] = this.addressCitySubdivisionName;
        data["addressCityId"] = this.addressCityId;
        data["addressCityName"] = this.addressCityName;
        data["addressPostalZone"] = this.addressPostalZone;
        data["addressRegion"] = this.addressRegion;
        data["addressCountryId"] = this.addressCountryId;
        data["addressCountryName"] = this.addressCountryName;
        data["taxAdministrationName"] = this.taxAdministrationName;
        data["telephone"] = this.telephone;
        data["eMail"] = this.eMail;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["registrationNumber"] = this.registrationNumber;
        data["mersisNumber"] = this.mersisNumber;
        data["businessCode"] = this.businessCode;
        data["notes"] = this.notes;
        data["isStateAgency"] = this.isStateAgency;
        data["personName"] = this.personName;
        data["personSurname"] = this.personSurname;
        data["creatorPartnerId"] = this.creatorPartnerId;
        data["personMiddleName"] = this.personMiddleName;
        data["neviIdentificationId"] = this.neviIdentificationId;
        return data; 
    }
}

export interface ICustomerDTO {
    id?: string | undefined;
    shortCode?: string | undefined;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    contourMasterCustomerId?: string | undefined;
    contourMasterCustomerTitle?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    businessCode?: string | undefined;
    notes?: string | undefined;
    isStateAgency?: number | undefined;
    personName?: string | undefined;
    personSurname?: string | undefined;
    creatorPartnerId?: string | undefined;
    personMiddleName?: string | undefined;
    neviIdentificationId?: string | undefined;
}

export class CustomerDetailDTO implements ICustomerDetailDTO {
    id?: string | undefined;
    shortCode?: string | undefined;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    contourMasterCustomerId?: string | undefined;
    contourMasterCustomerTitle?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    businessCode?: string | undefined;
    notes?: string | undefined;
    isStateAgency?: number | undefined;
    personName?: string | undefined;
    personSurname?: string | undefined;
    creatorPartnerId?: string | undefined;
    personMiddleName?: string | undefined;
    neviIdentificationId?: string | undefined;
    contacts?: CustomerContactsDTO[] | undefined;
    mutualContourCustomerList?: CustomerDTO[] | undefined;

    constructor(data?: ICustomerDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortCode = _data["shortCode"];
            this.partnerId = _data["partnerId"];
            this.partnerTitle = _data["partnerTitle"];
            this.title = _data["title"];
            this.identificationId = _data["identificationId"];
            this.contourMasterCustomerId = _data["contourMasterCustomerId"];
            this.contourMasterCustomerTitle = _data["contourMasterCustomerTitle"];
            this.addressRoomNumber = _data["addressRoomNumber"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressBuildingName = _data["addressBuildingName"];
            this.addressBuildingNumber = _data["addressBuildingNumber"];
            this.addressCitySubdivisionId = _data["addressCitySubdivisionId"];
            this.addressCitySubdivisionName = _data["addressCitySubdivisionName"];
            this.addressCityId = _data["addressCityId"];
            this.addressCityName = _data["addressCityName"];
            this.addressPostalZone = _data["addressPostalZone"];
            this.addressRegion = _data["addressRegion"];
            this.addressCountryId = _data["addressCountryId"];
            this.addressCountryName = _data["addressCountryName"];
            this.taxAdministrationName = _data["taxAdministrationName"];
            this.telephone = _data["telephone"];
            this.eMail = _data["eMail"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.registrationNumber = _data["registrationNumber"];
            this.mersisNumber = _data["mersisNumber"];
            this.businessCode = _data["businessCode"];
            this.notes = _data["notes"];
            this.isStateAgency = _data["isStateAgency"];
            this.personName = _data["personName"];
            this.personSurname = _data["personSurname"];
            this.creatorPartnerId = _data["creatorPartnerId"];
            this.personMiddleName = _data["personMiddleName"];
            this.neviIdentificationId = _data["neviIdentificationId"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(CustomerContactsDTO.fromJS(item));
            }
            if (Array.isArray(_data["mutualContourCustomerList"])) {
                this.mutualContourCustomerList = [] as any;
                for (let item of _data["mutualContourCustomerList"])
                    this.mutualContourCustomerList!.push(CustomerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortCode"] = this.shortCode;
        data["partnerId"] = this.partnerId;
        data["partnerTitle"] = this.partnerTitle;
        data["title"] = this.title;
        data["identificationId"] = this.identificationId;
        data["contourMasterCustomerId"] = this.contourMasterCustomerId;
        data["contourMasterCustomerTitle"] = this.contourMasterCustomerTitle;
        data["addressRoomNumber"] = this.addressRoomNumber;
        data["addressStreetName"] = this.addressStreetName;
        data["addressBuildingName"] = this.addressBuildingName;
        data["addressBuildingNumber"] = this.addressBuildingNumber;
        data["addressCitySubdivisionId"] = this.addressCitySubdivisionId;
        data["addressCitySubdivisionName"] = this.addressCitySubdivisionName;
        data["addressCityId"] = this.addressCityId;
        data["addressCityName"] = this.addressCityName;
        data["addressPostalZone"] = this.addressPostalZone;
        data["addressRegion"] = this.addressRegion;
        data["addressCountryId"] = this.addressCountryId;
        data["addressCountryName"] = this.addressCountryName;
        data["taxAdministrationName"] = this.taxAdministrationName;
        data["telephone"] = this.telephone;
        data["eMail"] = this.eMail;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["registrationNumber"] = this.registrationNumber;
        data["mersisNumber"] = this.mersisNumber;
        data["businessCode"] = this.businessCode;
        data["notes"] = this.notes;
        data["isStateAgency"] = this.isStateAgency;
        data["personName"] = this.personName;
        data["personSurname"] = this.personSurname;
        data["creatorPartnerId"] = this.creatorPartnerId;
        data["personMiddleName"] = this.personMiddleName;
        data["neviIdentificationId"] = this.neviIdentificationId;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.mutualContourCustomerList)) {
            data["mutualContourCustomerList"] = [];
            for (let item of this.mutualContourCustomerList)
                data["mutualContourCustomerList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerDetailDTO {
    id?: string | undefined;
    shortCode?: string | undefined;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    contourMasterCustomerId?: string | undefined;
    contourMasterCustomerTitle?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    businessCode?: string | undefined;
    notes?: string | undefined;
    isStateAgency?: number | undefined;
    personName?: string | undefined;
    personSurname?: string | undefined;
    creatorPartnerId?: string | undefined;
    personMiddleName?: string | undefined;
    neviIdentificationId?: string | undefined;
    contacts?: CustomerContactsDTO[] | undefined;
    mutualContourCustomerList?: CustomerDTO[] | undefined;
}

export class CustomersReq implements ICustomersReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    partnerId?: string | undefined;

    constructor(data?: ICustomersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
            this.partnerId = _data["partnerId"];
        }
    }

    static fromJS(data: any): CustomersReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["partnerId"] = this.partnerId;
        return data; 
    }
}

export interface ICustomersReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    partnerId?: string | undefined;
}

export class CustomersRes implements ICustomersRes {
    totalRecordCount?: number;
    listData?: CustomerDTO[] | undefined;

    constructor(data?: ICustomersRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomersRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomersRes {
    totalRecordCount?: number;
    listData?: CustomerDTO[] | undefined;
}

export class LockedAndUnLockedCustomersReq implements ILockedAndUnLockedCustomersReq {
    customerId?: string | undefined;
    actionType?: boolean;
    serviceList?: number[] | undefined;

    constructor(data?: ILockedAndUnLockedCustomersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.actionType = _data["actionType"];
            if (Array.isArray(_data["serviceList"])) {
                this.serviceList = [] as any;
                for (let item of _data["serviceList"])
                    this.serviceList!.push(item);
            }
        }
    }

    static fromJS(data: any): LockedAndUnLockedCustomersReq {
        data = typeof data === 'object' ? data : {};
        let result = new LockedAndUnLockedCustomersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["actionType"] = this.actionType;
        if (Array.isArray(this.serviceList)) {
            data["serviceList"] = [];
            for (let item of this.serviceList)
                data["serviceList"].push(item);
        }
        return data; 
    }
}

export interface ILockedAndUnLockedCustomersReq {
    customerId?: string | undefined;
    actionType?: boolean;
    serviceList?: number[] | undefined;
}

export enum DealerCustomerActivitionServiceType {
    NONE = "NONE",
    Usergb = "usergb",
    Earchive = "earchive",
    Edespatch = "edespatch",
    Epreceipt = "epreceipt",
    Eledger = "eledger",
    Eledger_archive = "eledger_archive",
    Journal_entry = "journal_entry",
}

export enum DealerCustomerActivitionType {
    REGISTER = "REGISTER",
    UNRESGISTER = "UNRESGISTER",
}

export class ActivationInfo implements IActivationInfo {
    serviceDefinition?: DealerCustomerActivitionServiceType;
    activationType?: DealerCustomerActivitionType;
    customerVKNTCKN?: string | undefined;
    pk?: string | undefined;
    gb?: string | undefined;
    activationDate?: Date;

    constructor(data?: IActivationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDefinition = _data["serviceDefinition"];
            this.activationType = _data["activationType"];
            this.customerVKNTCKN = _data["customerVKNTCKN"];
            this.pk = _data["pk"];
            this.gb = _data["gb"];
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDefinition"] = this.serviceDefinition;
        data["activationType"] = this.activationType;
        data["customerVKNTCKN"] = this.customerVKNTCKN;
        data["pk"] = this.pk;
        data["gb"] = this.gb;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IActivationInfo {
    serviceDefinition?: DealerCustomerActivitionServiceType;
    activationType?: DealerCustomerActivitionType;
    customerVKNTCKN?: string | undefined;
    pk?: string | undefined;
    gb?: string | undefined;
    activationDate?: Date;
}

export class DealerApiOrAdminPanelActivationAddInputs implements IDealerApiOrAdminPanelActivationAddInputs {
    partnerVKN?: string | undefined;
    activationInfo?: ActivationInfo;
    searchApplicationName?: boolean;

    constructor(data?: IDealerApiOrAdminPanelActivationAddInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerVKN = _data["partnerVKN"];
            this.activationInfo = _data["activationInfo"] ? ActivationInfo.fromJS(_data["activationInfo"]) : <any>undefined;
            this.searchApplicationName = _data["searchApplicationName"];
        }
    }

    static fromJS(data: any): DealerApiOrAdminPanelActivationAddInputs {
        data = typeof data === 'object' ? data : {};
        let result = new DealerApiOrAdminPanelActivationAddInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerVKN"] = this.partnerVKN;
        data["activationInfo"] = this.activationInfo ? this.activationInfo.toJSON() : <any>undefined;
        data["searchApplicationName"] = this.searchApplicationName;
        return data; 
    }
}

export interface IDealerApiOrAdminPanelActivationAddInputs {
    partnerVKN?: string | undefined;
    activationInfo?: ActivationInfo;
    searchApplicationName?: boolean;
}

export class CustomerDetail implements ICustomerDetail {
    partnerVKN?: string | undefined;
    customerVKNTCKN?: string | undefined;
    customerTitle?: string | undefined;
    personName?: string | undefined;
    personSurname?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    telephone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    shortCode?: string | undefined;
    contactName?: string | undefined;
    contactSurname?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    taxAdministrationName?: string | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressRoomNumber?: string | undefined;
    addressPostalZone?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;
    citySubdivision?: string | undefined;
    password?: string | undefined;

    constructor(data?: ICustomerDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerVKN = _data["partnerVKN"];
            this.customerVKNTCKN = _data["customerVKNTCKN"];
            this.customerTitle = _data["customerTitle"];
            this.personName = _data["personName"];
            this.personSurname = _data["personSurname"];
            this.registrationNumber = _data["registrationNumber"];
            this.mersisNumber = _data["mersisNumber"];
            this.telephone = _data["telephone"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.website = _data["website"];
            this.shortCode = _data["shortCode"];
            this.contactName = _data["contactName"];
            this.contactSurname = _data["contactSurname"];
            this.contactTelephone = _data["contactTelephone"];
            this.contactEmail = _data["contactEmail"];
            this.taxAdministrationName = _data["taxAdministrationName"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressBuildingName = _data["addressBuildingName"];
            this.addressBuildingNumber = _data["addressBuildingNumber"];
            this.addressRoomNumber = _data["addressRoomNumber"];
            this.addressPostalZone = _data["addressPostalZone"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.citySubdivision = _data["citySubdivision"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CustomerDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerVKN"] = this.partnerVKN;
        data["customerVKNTCKN"] = this.customerVKNTCKN;
        data["customerTitle"] = this.customerTitle;
        data["personName"] = this.personName;
        data["personSurname"] = this.personSurname;
        data["registrationNumber"] = this.registrationNumber;
        data["mersisNumber"] = this.mersisNumber;
        data["telephone"] = this.telephone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["website"] = this.website;
        data["shortCode"] = this.shortCode;
        data["contactName"] = this.contactName;
        data["contactSurname"] = this.contactSurname;
        data["contactTelephone"] = this.contactTelephone;
        data["contactEmail"] = this.contactEmail;
        data["taxAdministrationName"] = this.taxAdministrationName;
        data["addressStreetName"] = this.addressStreetName;
        data["addressBuildingName"] = this.addressBuildingName;
        data["addressBuildingNumber"] = this.addressBuildingNumber;
        data["addressRoomNumber"] = this.addressRoomNumber;
        data["addressPostalZone"] = this.addressPostalZone;
        data["country"] = this.country;
        data["city"] = this.city;
        data["citySubdivision"] = this.citySubdivision;
        data["password"] = this.password;
        return data; 
    }
}

export interface ICustomerDetail {
    partnerVKN?: string | undefined;
    customerVKNTCKN?: string | undefined;
    customerTitle?: string | undefined;
    personName?: string | undefined;
    personSurname?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    telephone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    website?: string | undefined;
    shortCode?: string | undefined;
    contactName?: string | undefined;
    contactSurname?: string | undefined;
    contactTelephone?: string | undefined;
    contactEmail?: string | undefined;
    taxAdministrationName?: string | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressRoomNumber?: string | undefined;
    addressPostalZone?: string | undefined;
    country?: string | undefined;
    city?: string | undefined;
    citySubdivision?: string | undefined;
    password?: string | undefined;
}

export class CustomerActivionInfo implements ICustomerActivionInfo {
    serviceDefinition?: DealerCustomerActivitionServiceType;
    pk?: string | undefined;
    gb?: string | undefined;
    activitionDate?: Date;

    constructor(data?: ICustomerActivionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDefinition = _data["serviceDefinition"];
            this.pk = _data["pk"];
            this.gb = _data["gb"];
            this.activitionDate = _data["activitionDate"] ? new Date(_data["activitionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerActivionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerActivionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDefinition"] = this.serviceDefinition;
        data["pk"] = this.pk;
        data["gb"] = this.gb;
        data["activitionDate"] = this.activitionDate ? this.activitionDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ICustomerActivionInfo {
    serviceDefinition?: DealerCustomerActivitionServiceType;
    pk?: string | undefined;
    gb?: string | undefined;
    activitionDate?: Date;
}

export class CustomerAgreementInfo implements ICustomerAgreementInfo {
    partnerAgreementCode?: string | undefined;
    contourCount?: number;

    constructor(data?: ICustomerAgreementInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerAgreementCode = _data["partnerAgreementCode"];
            this.contourCount = _data["contourCount"];
        }
    }

    static fromJS(data: any): CustomerAgreementInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAgreementInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerAgreementCode"] = this.partnerAgreementCode;
        data["contourCount"] = this.contourCount;
        return data; 
    }
}

export interface ICustomerAgreementInfo {
    partnerAgreementCode?: string | undefined;
    contourCount?: number;
}

export class CustomerImageInfo implements ICustomerImageInfo {
    logoImage?: string | undefined;
    signImage?: string | undefined;

    constructor(data?: ICustomerImageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoImage = _data["logoImage"];
            this.signImage = _data["signImage"];
        }
    }

    static fromJS(data: any): CustomerImageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerImageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoImage"] = this.logoImage;
        data["signImage"] = this.signImage;
        return data; 
    }
}

export interface ICustomerImageInfo {
    logoImage?: string | undefined;
    signImage?: string | undefined;
}

export class DealerApiOrAdminPanelCustomerAddInputs implements IDealerApiOrAdminPanelCustomerAddInputs {
    customer?: CustomerDetail;
    customerActivions?: CustomerActivionInfo[] | undefined;
    agreementInfo?: CustomerAgreementInfo;
    customerImageInfo?: CustomerImageInfo;
    searchApplicationName?: boolean;

    constructor(data?: IDealerApiOrAdminPanelCustomerAddInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? CustomerDetail.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["customerActivions"])) {
                this.customerActivions = [] as any;
                for (let item of _data["customerActivions"])
                    this.customerActivions!.push(CustomerActivionInfo.fromJS(item));
            }
            this.agreementInfo = _data["agreementInfo"] ? CustomerAgreementInfo.fromJS(_data["agreementInfo"]) : <any>undefined;
            this.customerImageInfo = _data["customerImageInfo"] ? CustomerImageInfo.fromJS(_data["customerImageInfo"]) : <any>undefined;
            this.searchApplicationName = _data["searchApplicationName"];
        }
    }

    static fromJS(data: any): DealerApiOrAdminPanelCustomerAddInputs {
        data = typeof data === 'object' ? data : {};
        let result = new DealerApiOrAdminPanelCustomerAddInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.customerActivions)) {
            data["customerActivions"] = [];
            for (let item of this.customerActivions)
                data["customerActivions"].push(item.toJSON());
        }
        data["agreementInfo"] = this.agreementInfo ? this.agreementInfo.toJSON() : <any>undefined;
        data["customerImageInfo"] = this.customerImageInfo ? this.customerImageInfo.toJSON() : <any>undefined;
        data["searchApplicationName"] = this.searchApplicationName;
        return data; 
    }
}

export interface IDealerApiOrAdminPanelCustomerAddInputs {
    customer?: CustomerDetail;
    customerActivions?: CustomerActivionInfo[] | undefined;
    agreementInfo?: CustomerAgreementInfo;
    customerImageInfo?: CustomerImageInfo;
    searchApplicationName?: boolean;
}

export class CustomerFileUploadDTO implements ICustomerFileUploadDTO {
    partner_VKN?: string | undefined;
    firma_VKN_TCKN?: string | undefined;
    firma_Ünvan?: string | undefined;
    firma_Adı?: string | undefined;
    firma_Soyadı?: string | undefined;
    vergi_Dairesi?: string | undefined;
    ticaret_Sicil_No?: string | undefined;
    mersis_No?: string | undefined;
    telefon?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    web_Site?: string | undefined;
    kısa_Kod?: string | undefined;
    adres_Satırı?: string | undefined;
    bina_Adı?: string | undefined;
    bina_No?: string | undefined;
    daire_No?: string | undefined;
    posta_No?: string | undefined;
    ülke?: string | undefined;
    şehir?: string | undefined;
    İlçe?: string | undefined;
    İletişim_Ad?: string | undefined;
    İletişim_Soyad?: string | undefined;
    İletişim_Telefon?: string | undefined;
    İletişim_Email?: string | undefined;
    serviceType?: ServiceType;
    pk?: string | undefined;
    gb?: string | undefined;
    aktivasyon_Tarihi?: string | undefined;
    partner_Sözleşme_Kodu?: string | undefined;
    sifre?: string | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    readonly hizmet_Tanımı?: string | undefined;
    logoImageBase64Data?: string | undefined;
    signatureImageBase64Data?: string | undefined;

    constructor(data?: ICustomerFileUploadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner_VKN = _data["partner_VKN"];
            this.firma_VKN_TCKN = _data["firma_VKN_TCKN"];
            this.firma_Ünvan = _data["firma_Ünvan"];
            this.firma_Adı = _data["firma_Adı"];
            this.firma_Soyadı = _data["firma_Soyadı"];
            this.vergi_Dairesi = _data["vergi_Dairesi"];
            this.ticaret_Sicil_No = _data["ticaret_Sicil_No"];
            this.mersis_No = _data["mersis_No"];
            this.telefon = _data["telefon"];
            this.fax = _data["fax"];
            this.email = _data["email"];
            this.web_Site = _data["web_Site"];
            this.kısa_Kod = _data["kısa_Kod"];
            this.adres_Satırı = _data["adres_Satırı"];
            this.bina_Adı = _data["bina_Adı"];
            this.bina_No = _data["bina_No"];
            this.daire_No = _data["daire_No"];
            this.posta_No = _data["posta_No"];
            this.ülke = _data["ülke"];
            this.şehir = _data["şehir"];
            this.İlçe = _data["İlçe"];
            this.İletişim_Ad = _data["İletişim_Ad"];
            this.İletişim_Soyad = _data["İletişim_Soyad"];
            this.İletişim_Telefon = _data["İletişim_Telefon"];
            this.İletişim_Email = _data["İletişim_Email"];
            this.serviceType = _data["serviceType"];
            this.pk = _data["pk"];
            this.gb = _data["gb"];
            this.aktivasyon_Tarihi = _data["aktivasyon_Tarihi"];
            this.partner_Sözleşme_Kodu = _data["partner_Sözleşme_Kodu"];
            this.sifre = _data["sifre"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : <any>undefined;
            (<any>this).hizmet_Tanımı = _data["hizmet_Tanımı"];
            this.logoImageBase64Data = _data["logoImageBase64Data"];
            this.signatureImageBase64Data = _data["signatureImageBase64Data"];
        }
    }

    static fromJS(data: any): CustomerFileUploadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFileUploadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner_VKN"] = this.partner_VKN;
        data["firma_VKN_TCKN"] = this.firma_VKN_TCKN;
        data["firma_Ünvan"] = this.firma_Ünvan;
        data["firma_Adı"] = this.firma_Adı;
        data["firma_Soyadı"] = this.firma_Soyadı;
        data["vergi_Dairesi"] = this.vergi_Dairesi;
        data["ticaret_Sicil_No"] = this.ticaret_Sicil_No;
        data["mersis_No"] = this.mersis_No;
        data["telefon"] = this.telefon;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["web_Site"] = this.web_Site;
        data["kısa_Kod"] = this.kısa_Kod;
        data["adres_Satırı"] = this.adres_Satırı;
        data["bina_Adı"] = this.bina_Adı;
        data["bina_No"] = this.bina_No;
        data["daire_No"] = this.daire_No;
        data["posta_No"] = this.posta_No;
        data["ülke"] = this.ülke;
        data["şehir"] = this.şehir;
        data["İlçe"] = this.İlçe;
        data["İletişim_Ad"] = this.İletişim_Ad;
        data["İletişim_Soyad"] = this.İletişim_Soyad;
        data["İletişim_Telefon"] = this.İletişim_Telefon;
        data["İletişim_Email"] = this.İletişim_Email;
        data["serviceType"] = this.serviceType;
        data["pk"] = this.pk;
        data["gb"] = this.gb;
        data["aktivasyon_Tarihi"] = this.aktivasyon_Tarihi;
        data["partner_Sözleşme_Kodu"] = this.partner_Sözleşme_Kodu;
        data["sifre"] = this.sifre;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        data["hizmet_Tanımı"] = this.hizmet_Tanımı;
        data["logoImageBase64Data"] = this.logoImageBase64Data;
        data["signatureImageBase64Data"] = this.signatureImageBase64Data;
        return data; 
    }
}

export interface ICustomerFileUploadDTO {
    partner_VKN?: string | undefined;
    firma_VKN_TCKN?: string | undefined;
    firma_Ünvan?: string | undefined;
    firma_Adı?: string | undefined;
    firma_Soyadı?: string | undefined;
    vergi_Dairesi?: string | undefined;
    ticaret_Sicil_No?: string | undefined;
    mersis_No?: string | undefined;
    telefon?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    web_Site?: string | undefined;
    kısa_Kod?: string | undefined;
    adres_Satırı?: string | undefined;
    bina_Adı?: string | undefined;
    bina_No?: string | undefined;
    daire_No?: string | undefined;
    posta_No?: string | undefined;
    ülke?: string | undefined;
    şehir?: string | undefined;
    İlçe?: string | undefined;
    İletişim_Ad?: string | undefined;
    İletişim_Soyad?: string | undefined;
    İletişim_Telefon?: string | undefined;
    İletişim_Email?: string | undefined;
    serviceType?: ServiceType;
    pk?: string | undefined;
    gb?: string | undefined;
    aktivasyon_Tarihi?: string | undefined;
    partner_Sözleşme_Kodu?: string | undefined;
    sifre?: string | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    hizmet_Tanımı?: string | undefined;
    logoImageBase64Data?: string | undefined;
    signatureImageBase64Data?: string | undefined;
}

export enum SearchInfoForAddCustomer {
    DealerApi = "DealerApi",
    FastTransaction = "FastTransaction",
    Excel = "Excel",
}

export class CustomerFileUploadReq implements ICustomerFileUploadReq {
    fileUpload?: CustomerFileUploadDTO[] | undefined;
    isServiceDefinition?: boolean;
    isAgreementDefinition?: boolean;
    isContourDefinition?: boolean;
    partnerAgreementCode?: string | undefined;
    contourCount?: number;
    searchInfo?: SearchInfoForAddCustomer;

    constructor(data?: ICustomerFileUploadReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileUpload"])) {
                this.fileUpload = [] as any;
                for (let item of _data["fileUpload"])
                    this.fileUpload!.push(CustomerFileUploadDTO.fromJS(item));
            }
            this.isServiceDefinition = _data["isServiceDefinition"];
            this.isAgreementDefinition = _data["isAgreementDefinition"];
            this.isContourDefinition = _data["isContourDefinition"];
            this.partnerAgreementCode = _data["partnerAgreementCode"];
            this.contourCount = _data["contourCount"];
            this.searchInfo = _data["searchInfo"];
        }
    }

    static fromJS(data: any): CustomerFileUploadReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFileUploadReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileUpload)) {
            data["fileUpload"] = [];
            for (let item of this.fileUpload)
                data["fileUpload"].push(item.toJSON());
        }
        data["isServiceDefinition"] = this.isServiceDefinition;
        data["isAgreementDefinition"] = this.isAgreementDefinition;
        data["isContourDefinition"] = this.isContourDefinition;
        data["partnerAgreementCode"] = this.partnerAgreementCode;
        data["contourCount"] = this.contourCount;
        data["searchInfo"] = this.searchInfo;
        return data; 
    }
}

export interface ICustomerFileUploadReq {
    fileUpload?: CustomerFileUploadDTO[] | undefined;
    isServiceDefinition?: boolean;
    isAgreementDefinition?: boolean;
    isContourDefinition?: boolean;
    partnerAgreementCode?: string | undefined;
    contourCount?: number;
    searchInfo?: SearchInfoForAddCustomer;
}

export class FileUploadDetailRes implements IFileUploadDetailRes {
    customerId?: string | undefined;
    statusDetails?: string | undefined;

    constructor(data?: IFileUploadDetailRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.statusDetails = _data["statusDetails"];
        }
    }

    static fromJS(data: any): FileUploadDetailRes {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadDetailRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["statusDetails"] = this.statusDetails;
        return data; 
    }
}

export interface IFileUploadDetailRes {
    customerId?: string | undefined;
    statusDetails?: string | undefined;
}

export class CustomerFileUploadRes implements ICustomerFileUploadRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    fileUploadDetailRes?: FileUploadDetailRes[] | undefined;

    constructor(data?: ICustomerFileUploadRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            if (Array.isArray(_data["fileUploadDetailRes"])) {
                this.fileUploadDetailRes = [] as any;
                for (let item of _data["fileUploadDetailRes"])
                    this.fileUploadDetailRes!.push(FileUploadDetailRes.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerFileUploadRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFileUploadRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        if (Array.isArray(this.fileUploadDetailRes)) {
            data["fileUploadDetailRes"] = [];
            for (let item of this.fileUploadDetailRes)
                data["fileUploadDetailRes"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerFileUploadRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    fileUploadDetailRes?: FileUploadDetailRes[] | undefined;
}

export class AddCustomerReq implements IAddCustomerReq {
    creatorPartnerId?: string | undefined;
    customer?: CustomerDetailDTO;

    constructor(data?: IAddCustomerReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorPartnerId = _data["creatorPartnerId"];
            this.customer = _data["customer"] ? CustomerDetailDTO.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorPartnerId"] = this.creatorPartnerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerReq {
    creatorPartnerId?: string | undefined;
    customer?: CustomerDetailDTO;
}

export class CustomerSummaryInfoDTO implements ICustomerSummaryInfoDTO {
    id?: number;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    isMapping?: number;
    isPrefixManagement?: number;
    isXsltManagement?: number;
    dataSendMethod?: number;
    description?: string | undefined;

    constructor(data?: ICustomerSummaryInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerId = _data["partnerId"];
            this.customerId = _data["customerId"];
            this.isMapping = _data["isMapping"];
            this.isPrefixManagement = _data["isPrefixManagement"];
            this.isXsltManagement = _data["isXsltManagement"];
            this.dataSendMethod = _data["dataSendMethod"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CustomerSummaryInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSummaryInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerId"] = this.partnerId;
        data["customerId"] = this.customerId;
        data["isMapping"] = this.isMapping;
        data["isPrefixManagement"] = this.isPrefixManagement;
        data["isXsltManagement"] = this.isXsltManagement;
        data["dataSendMethod"] = this.dataSendMethod;
        data["description"] = this.description;
        return data; 
    }
}

export interface ICustomerSummaryInfoDTO {
    id?: number;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    isMapping?: number;
    isPrefixManagement?: number;
    isXsltManagement?: number;
    dataSendMethod?: number;
    description?: string | undefined;
}

export class AddCustomerRes implements IAddCustomerRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customer?: CustomerDetailDTO;
    customerSummaryInfoDTO?: CustomerSummaryInfoDTO;
    isPartnerSummaryInfo?: boolean;

    constructor(data?: IAddCustomerRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customer = _data["customer"] ? CustomerDetailDTO.fromJS(_data["customer"]) : <any>undefined;
            this.customerSummaryInfoDTO = _data["customerSummaryInfoDTO"] ? CustomerSummaryInfoDTO.fromJS(_data["customerSummaryInfoDTO"]) : <any>undefined;
            this.isPartnerSummaryInfo = _data["isPartnerSummaryInfo"];
        }
    }

    static fromJS(data: any): AddCustomerRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["customerSummaryInfoDTO"] = this.customerSummaryInfoDTO ? this.customerSummaryInfoDTO.toJSON() : <any>undefined;
        data["isPartnerSummaryInfo"] = this.isPartnerSummaryInfo;
        return data; 
    }
}

export interface IAddCustomerRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customer?: CustomerDetailDTO;
    customerSummaryInfoDTO?: CustomerSummaryInfoDTO;
    isPartnerSummaryInfo?: boolean;
}

export class UpdateCustomerReq implements IUpdateCustomerReq {
    customer?: CustomerDetailDTO;

    constructor(data?: IUpdateCustomerReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? CustomerDetailDTO.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerReq {
    customer?: CustomerDetailDTO;
}

export class UpdateCustomerRes implements IUpdateCustomerRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customer?: CustomerDetailDTO;

    constructor(data?: IUpdateCustomerRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customer = _data["customer"] ? CustomerDetailDTO.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customer?: CustomerDetailDTO;
}

export class AddCustomerLogoAndSignInfoReq implements IAddCustomerLogoAndSignInfoReq {
    customerId?: string | undefined;
    isXsltManagement?: number;
    logoImage?: string | undefined;
    signImage?: string | undefined;

    constructor(data?: IAddCustomerLogoAndSignInfoReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.isXsltManagement = _data["isXsltManagement"];
            this.logoImage = _data["logoImage"];
            this.signImage = _data["signImage"];
        }
    }

    static fromJS(data: any): AddCustomerLogoAndSignInfoReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerLogoAndSignInfoReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["isXsltManagement"] = this.isXsltManagement;
        data["logoImage"] = this.logoImage;
        data["signImage"] = this.signImage;
        return data; 
    }
}

export interface IAddCustomerLogoAndSignInfoReq {
    customerId?: string | undefined;
    isXsltManagement?: number;
    logoImage?: string | undefined;
    signImage?: string | undefined;
}

export class AddCustomerSummaryInfoReq implements IAddCustomerSummaryInfoReq {
    partnerId?: string | undefined;
    customerSummaryInfo?: CustomerSummaryInfoDTO;

    constructor(data?: IAddCustomerSummaryInfoReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.customerSummaryInfo = _data["customerSummaryInfo"] ? CustomerSummaryInfoDTO.fromJS(_data["customerSummaryInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerSummaryInfoReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerSummaryInfoReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["customerSummaryInfo"] = this.customerSummaryInfo ? this.customerSummaryInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerSummaryInfoReq {
    partnerId?: string | undefined;
    customerSummaryInfo?: CustomerSummaryInfoDTO;
}

export class UpdateCustomerSummaryInfoReq implements IUpdateCustomerSummaryInfoReq {
    customerSummaryInfoDTO?: CustomerSummaryInfoDTO;

    constructor(data?: IUpdateCustomerSummaryInfoReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerSummaryInfoDTO = _data["customerSummaryInfoDTO"] ? CustomerSummaryInfoDTO.fromJS(_data["customerSummaryInfoDTO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerSummaryInfoReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerSummaryInfoReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerSummaryInfoDTO"] = this.customerSummaryInfoDTO ? this.customerSummaryInfoDTO.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerSummaryInfoReq {
    customerSummaryInfoDTO?: CustomerSummaryInfoDTO;
}

export class ChangeCustomerPartnerRequest implements IChangeCustomerPartnerRequest {
    customerId?: string | undefined;
    oldPartnerId?: string | undefined;
    newPartnerId?: string | undefined;
    moveContour?: boolean;
    moveLedger?: boolean;
    newPartnerAggrementId?: number | undefined;

    constructor(data?: IChangeCustomerPartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.oldPartnerId = _data["oldPartnerId"];
            this.newPartnerId = _data["newPartnerId"];
            this.moveContour = _data["moveContour"];
            this.moveLedger = _data["moveLedger"];
            this.newPartnerAggrementId = _data["newPartnerAggrementId"];
        }
    }

    static fromJS(data: any): ChangeCustomerPartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCustomerPartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["oldPartnerId"] = this.oldPartnerId;
        data["newPartnerId"] = this.newPartnerId;
        data["moveContour"] = this.moveContour;
        data["moveLedger"] = this.moveLedger;
        data["newPartnerAggrementId"] = this.newPartnerAggrementId;
        return data; 
    }
}

export interface IChangeCustomerPartnerRequest {
    customerId?: string | undefined;
    oldPartnerId?: string | undefined;
    newPartnerId?: string | undefined;
    moveContour?: boolean;
    moveLedger?: boolean;
    newPartnerAggrementId?: number | undefined;
}

export class ChangeCustomerIdRequest implements IChangeCustomerIdRequest {
    oldCustomerId?: string | undefined;
    newCustomerId?: string | undefined;

    constructor(data?: IChangeCustomerIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldCustomerId = _data["oldCustomerId"];
            this.newCustomerId = _data["newCustomerId"];
        }
    }

    static fromJS(data: any): ChangeCustomerIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeCustomerIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldCustomerId"] = this.oldCustomerId;
        data["newCustomerId"] = this.newCustomerId;
        return data; 
    }
}

export interface IChangeCustomerIdRequest {
    oldCustomerId?: string | undefined;
    newCustomerId?: string | undefined;
}

export class CustomerAllowedIPFiltersReq implements ICustomerAllowedIPFiltersReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: ICustomerAllowedIPFiltersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerAllowedIPFiltersReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAllowedIPFiltersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerAllowedIPFiltersReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class CustomerAllowedIPDTO implements ICustomerAllowedIPDTO {
    id?: number;
    isActive?: number | undefined;
    isForAllCustomers?: number | undefined;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    applicationName?: string | undefined;
    ipFilterExpression?: string | undefined;

    constructor(data?: ICustomerAllowedIPDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.isForAllCustomers = _data["isForAllCustomers"];
            this.customerId = _data["customerId"];
            this.customerTitle = _data["customerTitle"];
            this.applicationName = _data["applicationName"];
            this.ipFilterExpression = _data["ipFilterExpression"];
        }
    }

    static fromJS(data: any): CustomerAllowedIPDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAllowedIPDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["isForAllCustomers"] = this.isForAllCustomers;
        data["customerId"] = this.customerId;
        data["customerTitle"] = this.customerTitle;
        data["applicationName"] = this.applicationName;
        data["ipFilterExpression"] = this.ipFilterExpression;
        return data; 
    }
}

export interface ICustomerAllowedIPDTO {
    id?: number;
    isActive?: number | undefined;
    isForAllCustomers?: number | undefined;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    applicationName?: string | undefined;
    ipFilterExpression?: string | undefined;
}

export class CustomerAllowedIPFiltersRes implements ICustomerAllowedIPFiltersRes {
    totalRecordCount?: number;
    listData?: CustomerAllowedIPDTO[] | undefined;

    constructor(data?: ICustomerAllowedIPFiltersRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerAllowedIPDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerAllowedIPFiltersRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAllowedIPFiltersRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerAllowedIPFiltersRes {
    totalRecordCount?: number;
    listData?: CustomerAllowedIPDTO[] | undefined;
}

export class CustomerAllowedIPAddFilterReq implements ICustomerAllowedIPAddFilterReq {
    customerAllowedIP?: CustomerAllowedIPDTO;

    constructor(data?: ICustomerAllowedIPAddFilterReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAllowedIP = _data["customerAllowedIP"] ? CustomerAllowedIPDTO.fromJS(_data["customerAllowedIP"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerAllowedIPAddFilterReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAllowedIPAddFilterReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAllowedIP"] = this.customerAllowedIP ? this.customerAllowedIP.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerAllowedIPAddFilterReq {
    customerAllowedIP?: CustomerAllowedIPDTO;
}

export class CustomerAllowedIPAddFilterRes implements ICustomerAllowedIPAddFilterRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerAllowedIP?: CustomerAllowedIPDTO;

    constructor(data?: ICustomerAllowedIPAddFilterRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerAllowedIP = _data["customerAllowedIP"] ? CustomerAllowedIPDTO.fromJS(_data["customerAllowedIP"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerAllowedIPAddFilterRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAllowedIPAddFilterRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerAllowedIP"] = this.customerAllowedIP ? this.customerAllowedIP.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerAllowedIPAddFilterRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerAllowedIP?: CustomerAllowedIPDTO;
}

export class CustomerAllowedIPUpdateFilterReq implements ICustomerAllowedIPUpdateFilterReq {
    customerAllowedIP?: CustomerAllowedIPDTO;

    constructor(data?: ICustomerAllowedIPUpdateFilterReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAllowedIP = _data["customerAllowedIP"] ? CustomerAllowedIPDTO.fromJS(_data["customerAllowedIP"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerAllowedIPUpdateFilterReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAllowedIPUpdateFilterReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAllowedIP"] = this.customerAllowedIP ? this.customerAllowedIP.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerAllowedIPUpdateFilterReq {
    customerAllowedIP?: CustomerAllowedIPDTO;
}

export class CustomerAllowedIPUpdateFilterRes implements ICustomerAllowedIPUpdateFilterRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerAllowedIP?: CustomerAllowedIPDTO;

    constructor(data?: ICustomerAllowedIPUpdateFilterRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerAllowedIP = _data["customerAllowedIP"] ? CustomerAllowedIPDTO.fromJS(_data["customerAllowedIP"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerAllowedIPUpdateFilterRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAllowedIPUpdateFilterRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerAllowedIP"] = this.customerAllowedIP ? this.customerAllowedIP.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerAllowedIPUpdateFilterRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerAllowedIP?: CustomerAllowedIPDTO;
}

export class FilterQueryUserReq implements IFilterQueryUserReq {
    filter?: string | undefined;
    customerId!: string;

    constructor(data?: IFilterQueryUserReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): FilterQueryUserReq {
        data = typeof data === 'object' ? data : {};
        let result = new FilterQueryUserReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IFilterQueryUserReq {
    filter?: string | undefined;
    customerId: string;
}

export class UserInfo implements IUserInfo {
    id?: number;
    eMail?: string | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eMail = _data["eMail"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eMail"] = this.eMail;
        return data; 
    }
}

export interface IUserInfo {
    id?: number;
    eMail?: string | undefined;
}

export class CustomersBranchsRequest implements ICustomersBranchsRequest {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerId?: string | undefined;

    constructor(data?: ICustomersBranchsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): CustomersBranchsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersBranchsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface ICustomersBranchsRequest {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerId?: string | undefined;
}

export class CustomerBranchDTO implements ICustomerBranchDTO {
    id?: number;
    status?: number | undefined;
    customerId?: string | undefined;
    code?: string | undefined;
    isMainBranch?: number | undefined;
    title?: string | undefined;
    description?: string | undefined;
    shortCode?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    mersisNumber?: string | undefined;
    invoicePk?: string | undefined;
    despatchAdvivePk?: string | undefined;

    constructor(data?: ICustomerBranchDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.customerId = _data["customerId"];
            this.code = _data["code"];
            this.isMainBranch = _data["isMainBranch"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.shortCode = _data["shortCode"];
            this.addressRoomNumber = _data["addressRoomNumber"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressBuildingName = _data["addressBuildingName"];
            this.addressBuildingNumber = _data["addressBuildingNumber"];
            this.addressCitySubdivisionId = _data["addressCitySubdivisionId"];
            this.addressCitySubdivisionName = _data["addressCitySubdivisionName"];
            this.addressCityId = _data["addressCityId"];
            this.addressCityName = _data["addressCityName"];
            this.addressPostalZone = _data["addressPostalZone"];
            this.addressRegion = _data["addressRegion"];
            this.addressCountryId = _data["addressCountryId"];
            this.addressCountryName = _data["addressCountryName"];
            this.taxAdministrationName = _data["taxAdministrationName"];
            this.telephone = _data["telephone"];
            this.eMail = _data["eMail"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.mersisNumber = _data["mersisNumber"];
            this.invoicePk = _data["invoicePk"];
            this.despatchAdvivePk = _data["despatchAdvivePk"];
        }
    }

    static fromJS(data: any): CustomerBranchDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBranchDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["customerId"] = this.customerId;
        data["code"] = this.code;
        data["isMainBranch"] = this.isMainBranch;
        data["title"] = this.title;
        data["description"] = this.description;
        data["shortCode"] = this.shortCode;
        data["addressRoomNumber"] = this.addressRoomNumber;
        data["addressStreetName"] = this.addressStreetName;
        data["addressBuildingName"] = this.addressBuildingName;
        data["addressBuildingNumber"] = this.addressBuildingNumber;
        data["addressCitySubdivisionId"] = this.addressCitySubdivisionId;
        data["addressCitySubdivisionName"] = this.addressCitySubdivisionName;
        data["addressCityId"] = this.addressCityId;
        data["addressCityName"] = this.addressCityName;
        data["addressPostalZone"] = this.addressPostalZone;
        data["addressRegion"] = this.addressRegion;
        data["addressCountryId"] = this.addressCountryId;
        data["addressCountryName"] = this.addressCountryName;
        data["taxAdministrationName"] = this.taxAdministrationName;
        data["telephone"] = this.telephone;
        data["eMail"] = this.eMail;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["mersisNumber"] = this.mersisNumber;
        data["invoicePk"] = this.invoicePk;
        data["despatchAdvivePk"] = this.despatchAdvivePk;
        return data; 
    }
}

export interface ICustomerBranchDTO {
    id?: number;
    status?: number | undefined;
    customerId?: string | undefined;
    code?: string | undefined;
    isMainBranch?: number | undefined;
    title?: string | undefined;
    description?: string | undefined;
    shortCode?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    mersisNumber?: string | undefined;
    invoicePk?: string | undefined;
    despatchAdvivePk?: string | undefined;
}

export class CustomersBranchsResponse implements ICustomersBranchsResponse {
    totalRecordCount?: number;
    listData?: CustomerBranchDTO[] | undefined;

    constructor(data?: ICustomersBranchsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerBranchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomersBranchsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersBranchsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomersBranchsResponse {
    totalRecordCount?: number;
    listData?: CustomerBranchDTO[] | undefined;
}

export class CustomerBranchRequest implements ICustomerBranchRequest {
    customerBranch?: CustomerBranchDTO;

    constructor(data?: ICustomerBranchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerBranch = _data["customerBranch"] ? CustomerBranchDTO.fromJS(_data["customerBranch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerBranchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBranchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerBranch"] = this.customerBranch ? this.customerBranch.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICustomerBranchRequest {
    customerBranch?: CustomerBranchDTO;
}

export class CustomersBranchsUsersReq implements ICustomersBranchsUsersReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerBranchId?: number;

    constructor(data?: ICustomersBranchsUsersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
            this.customerBranchId = _data["customerBranchId"];
        }
    }

    static fromJS(data: any): CustomersBranchsUsersReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersBranchsUsersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["customerBranchId"] = this.customerBranchId;
        return data; 
    }
}

export interface ICustomersBranchsUsersReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerBranchId?: number;
}

export class CustomerBranchUsersDTO implements ICustomerBranchUsersDTO {
    id?: number;
    userId?: number | undefined;
    userName?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchCode?: string | undefined;
    status?: number | undefined;

    constructor(data?: ICustomerBranchUsersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.customerBranchId = _data["customerBranchId"];
            this.customerBranchCode = _data["customerBranchCode"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CustomerBranchUsersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBranchUsersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["customerBranchId"] = this.customerBranchId;
        data["customerBranchCode"] = this.customerBranchCode;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICustomerBranchUsersDTO {
    id?: number;
    userId?: number | undefined;
    userName?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchCode?: string | undefined;
    status?: number | undefined;
}

export class CustomersBranchUsersRes implements ICustomersBranchUsersRes {
    totalRecordCount?: number;
    listData?: CustomerBranchUsersDTO[] | undefined;

    constructor(data?: ICustomersBranchUsersRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerBranchUsersDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomersBranchUsersRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersBranchUsersRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomersBranchUsersRes {
    totalRecordCount?: number;
    listData?: CustomerBranchUsersDTO[] | undefined;
}

export class CustomerBranchUsersDetailDTO implements ICustomerBranchUsersDetailDTO {
    id?: number;
    userId?: number | undefined;
    userName?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchCode?: string | undefined;
    status?: number | undefined;

    constructor(data?: ICustomerBranchUsersDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.customerBranchId = _data["customerBranchId"];
            this.customerBranchCode = _data["customerBranchCode"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CustomerBranchUsersDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBranchUsersDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["customerBranchId"] = this.customerBranchId;
        data["customerBranchCode"] = this.customerBranchCode;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICustomerBranchUsersDetailDTO {
    id?: number;
    userId?: number | undefined;
    userName?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchCode?: string | undefined;
    status?: number | undefined;
}

export class AddCustomerBranchUsersReq implements IAddCustomerBranchUsersReq {
    customerBranchUsers?: CustomerBranchUsersDetailDTO;

    constructor(data?: IAddCustomerBranchUsersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerBranchUsers = _data["customerBranchUsers"] ? CustomerBranchUsersDetailDTO.fromJS(_data["customerBranchUsers"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerBranchUsersReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerBranchUsersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerBranchUsers"] = this.customerBranchUsers ? this.customerBranchUsers.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerBranchUsersReq {
    customerBranchUsers?: CustomerBranchUsersDetailDTO;
}

export class UpdateCustomerBranchUsersReq implements IUpdateCustomerBranchUsersReq {
    customerBranchUser?: CustomerBranchUsersDetailDTO;

    constructor(data?: IUpdateCustomerBranchUsersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerBranchUser = _data["customerBranchUser"] ? CustomerBranchUsersDetailDTO.fromJS(_data["customerBranchUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerBranchUsersReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerBranchUsersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerBranchUser"] = this.customerBranchUser ? this.customerBranchUser.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerBranchUsersReq {
    customerBranchUser?: CustomerBranchUsersDetailDTO;
}

export class AvaiableCustomerAgreementsReq implements IAvaiableCustomerAgreementsReq {
    customerId?: string | undefined;
    serviceId?: number | undefined;
    filter?: string | undefined;

    constructor(data?: IAvaiableCustomerAgreementsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): AvaiableCustomerAgreementsReq {
        data = typeof data === 'object' ? data : {};
        let result = new AvaiableCustomerAgreementsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IAvaiableCustomerAgreementsReq {
    customerId?: string | undefined;
    serviceId?: number | undefined;
    filter?: string | undefined;
}

export class CustomerAgreementsInfoDTO implements ICustomerAgreementsInfoDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    serviceId?: number;
    serviceCode?: string | undefined;
    contourPackSize?: number | undefined;
    contourPackPrice?: number | undefined;
    agreementType?: AgreementType;

    constructor(data?: ICustomerAgreementsInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.contourPackSize = _data["contourPackSize"];
            this.contourPackPrice = _data["contourPackPrice"];
            this.agreementType = _data["agreementType"];
        }
    }

    static fromJS(data: any): CustomerAgreementsInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAgreementsInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["contourPackSize"] = this.contourPackSize;
        data["contourPackPrice"] = this.contourPackPrice;
        data["agreementType"] = this.agreementType;
        return data; 
    }
}

export interface ICustomerAgreementsInfoDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    serviceId?: number;
    serviceCode?: string | undefined;
    contourPackSize?: number | undefined;
    contourPackPrice?: number | undefined;
    agreementType?: AgreementType;
}

export class CustomersForContourReq implements ICustomersForContourReq {
    serviceId?: number | undefined;
    filter?: string | undefined;

    constructor(data?: ICustomersForContourReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): CustomersForContourReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersForContourReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface ICustomersForContourReq {
    serviceId?: number | undefined;
    filter?: string | undefined;
}

export class CustomerContoursDocumentsReq implements ICustomerContoursDocumentsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: ICustomerContoursDocumentsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerContoursDocumentsReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContoursDocumentsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerContoursDocumentsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export enum ContourDocumentType {
    ContourTransfer = "ContourTransfer",
    ContourReturn = "ContourReturn",
}

export class CustomerContourDocumentDTO implements ICustomerContourDocumentDTO {
    id?: number;
    customerAgreementId?: number | undefined;
    partnerAgreementCode?: string | undefined;
    partnerAgreementType?: AgreementType;
    customerId?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
    invoiceNo?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceAmount?: number | undefined;
    invoiceCurrency?: string | undefined;
    currencyRate?: number | undefined;
    documentType?: ContourDocumentType;
    contourCount?: number;
    documentDate?: Date;
    documentTime?: Date;
    description?: string | undefined;
    serviceId?: number;

    constructor(data?: ICustomerContourDocumentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerAgreementId = _data["customerAgreementId"];
            this.partnerAgreementCode = _data["partnerAgreementCode"];
            this.partnerAgreementType = _data["partnerAgreementType"];
            this.customerId = _data["customerId"];
            this.customerShortCode = _data["customerShortCode"];
            this.customerTitle = _data["customerTitle"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.invoiceAmount = _data["invoiceAmount"];
            this.invoiceCurrency = _data["invoiceCurrency"];
            this.currencyRate = _data["currencyRate"];
            this.documentType = _data["documentType"];
            this.contourCount = _data["contourCount"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.documentTime = _data["documentTime"] ? new Date(_data["documentTime"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): CustomerContourDocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContourDocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerAgreementId"] = this.customerAgreementId;
        data["partnerAgreementCode"] = this.partnerAgreementCode;
        data["partnerAgreementType"] = this.partnerAgreementType;
        data["customerId"] = this.customerId;
        data["customerShortCode"] = this.customerShortCode;
        data["customerTitle"] = this.customerTitle;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["invoiceAmount"] = this.invoiceAmount;
        data["invoiceCurrency"] = this.invoiceCurrency;
        data["currencyRate"] = this.currencyRate;
        data["documentType"] = this.documentType;
        data["contourCount"] = this.contourCount;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["documentTime"] = this.documentTime ? this.documentTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["serviceId"] = this.serviceId;
        return data; 
    }
}

export interface ICustomerContourDocumentDTO {
    id?: number;
    customerAgreementId?: number | undefined;
    partnerAgreementCode?: string | undefined;
    partnerAgreementType?: AgreementType;
    customerId?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
    invoiceNo?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceAmount?: number | undefined;
    invoiceCurrency?: string | undefined;
    currencyRate?: number | undefined;
    documentType?: ContourDocumentType;
    contourCount?: number;
    documentDate?: Date;
    documentTime?: Date;
    description?: string | undefined;
    serviceId?: number;
}

export class CustomerContoursDocumentsRes implements ICustomerContoursDocumentsRes {
    totalRecordCount?: number;
    listData?: CustomerContourDocumentDTO[] | undefined;

    constructor(data?: ICustomerContoursDocumentsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerContourDocumentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerContoursDocumentsRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContoursDocumentsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerContoursDocumentsRes {
    totalRecordCount?: number;
    listData?: CustomerContourDocumentDTO[] | undefined;
}

export class DealerApiContourAddInputs implements IDealerApiContourAddInputs {
    partnerVKN?: string | undefined;
    customerVKN?: string | undefined;
    partnerAgreementId?: number;
    contourCount?: number;
    documentType?: ContourDocumentType;
    searchApplicationName?: boolean;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;

    constructor(data?: IDealerApiContourAddInputs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerVKN = _data["partnerVKN"];
            this.customerVKN = _data["customerVKN"];
            this.partnerAgreementId = _data["partnerAgreementId"];
            this.contourCount = _data["contourCount"];
            this.documentType = _data["documentType"];
            this.searchApplicationName = _data["searchApplicationName"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : <any>undefined;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DealerApiContourAddInputs {
        data = typeof data === 'object' ? data : {};
        let result = new DealerApiContourAddInputs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerVKN"] = this.partnerVKN;
        data["customerVKN"] = this.customerVKN;
        data["partnerAgreementId"] = this.partnerAgreementId;
        data["contourCount"] = this.contourCount;
        data["documentType"] = this.documentType;
        data["searchApplicationName"] = this.searchApplicationName;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : <any>undefined;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDealerApiContourAddInputs {
    partnerVKN?: string | undefined;
    customerVKN?: string | undefined;
    partnerAgreementId?: number;
    contourCount?: number;
    documentType?: ContourDocumentType;
    searchApplicationName?: boolean;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
}

export class AddCustomerContourDocumentReq implements IAddCustomerContourDocumentReq {
    document?: CustomerContourDocumentDTO;

    constructor(data?: IAddCustomerContourDocumentReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? CustomerContourDocumentDTO.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerContourDocumentReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerContourDocumentReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerContourDocumentReq {
    document?: CustomerContourDocumentDTO;
}

export class AddCustomerContourDocumentRes implements IAddCustomerContourDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    document?: CustomerContourDocumentDTO;

    constructor(data?: IAddCustomerContourDocumentRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.document = _data["document"] ? CustomerContourDocumentDTO.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerContourDocumentRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerContourDocumentRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerContourDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    document?: CustomerContourDocumentDTO;
}

export class UpdateCustomerContourDocumentReq implements IUpdateCustomerContourDocumentReq {
    document?: CustomerContourDocumentDTO;

    constructor(data?: IUpdateCustomerContourDocumentReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? CustomerContourDocumentDTO.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerContourDocumentReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerContourDocumentReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerContourDocumentReq {
    document?: CustomerContourDocumentDTO;
}

export class UpdateCustomerContourDocumentRes implements IUpdateCustomerContourDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    document?: CustomerContourDocumentDTO;

    constructor(data?: IUpdateCustomerContourDocumentRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.document = _data["document"] ? CustomerContourDocumentDTO.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerContourDocumentRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerContourDocumentRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerContourDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    document?: CustomerContourDocumentDTO;
}

export class ResetCustomerContourRequest implements IResetCustomerContourRequest {
    customerId?: string | undefined;
    serviceId?: number;

    constructor(data?: IResetCustomerContourRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): ResetCustomerContourRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetCustomerContourRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        return data; 
    }
}

export interface IResetCustomerContourRequest {
    customerId?: string | undefined;
    serviceId?: number;
}

export class CustomerInfoDTO implements ICustomerInfoDTO {
    id?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    addressStreetName?: string | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityName?: string | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    registrationNumber?: string | undefined;
    creatorPartnerId?: string | undefined;
    personName?: string | undefined;
    personSurname?: string | undefined;
    permissionPersonName?: string | undefined;
    permissionPersonSurname?: string | undefined;
    permissionPersonEmail?: string | undefined;
    attachDocument?: string | undefined;

    constructor(data?: ICustomerInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.identificationId = _data["identificationId"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressCitySubdivisionName = _data["addressCitySubdivisionName"];
            this.addressCityName = _data["addressCityName"];
            this.addressCountryName = _data["addressCountryName"];
            this.taxAdministrationName = _data["taxAdministrationName"];
            this.telephone = _data["telephone"];
            this.eMail = _data["eMail"];
            this.registrationNumber = _data["registrationNumber"];
            this.creatorPartnerId = _data["creatorPartnerId"];
            this.personName = _data["personName"];
            this.personSurname = _data["personSurname"];
            this.permissionPersonName = _data["permissionPersonName"];
            this.permissionPersonSurname = _data["permissionPersonSurname"];
            this.permissionPersonEmail = _data["permissionPersonEmail"];
            this.attachDocument = _data["attachDocument"];
        }
    }

    static fromJS(data: any): CustomerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["identificationId"] = this.identificationId;
        data["addressStreetName"] = this.addressStreetName;
        data["addressCitySubdivisionName"] = this.addressCitySubdivisionName;
        data["addressCityName"] = this.addressCityName;
        data["addressCountryName"] = this.addressCountryName;
        data["taxAdministrationName"] = this.taxAdministrationName;
        data["telephone"] = this.telephone;
        data["eMail"] = this.eMail;
        data["registrationNumber"] = this.registrationNumber;
        data["creatorPartnerId"] = this.creatorPartnerId;
        data["personName"] = this.personName;
        data["personSurname"] = this.personSurname;
        data["permissionPersonName"] = this.permissionPersonName;
        data["permissionPersonSurname"] = this.permissionPersonSurname;
        data["permissionPersonEmail"] = this.permissionPersonEmail;
        data["attachDocument"] = this.attachDocument;
        return data; 
    }
}

export interface ICustomerInfoDTO {
    id?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    addressStreetName?: string | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityName?: string | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    registrationNumber?: string | undefined;
    creatorPartnerId?: string | undefined;
    personName?: string | undefined;
    personSurname?: string | undefined;
    permissionPersonName?: string | undefined;
    permissionPersonSurname?: string | undefined;
    permissionPersonEmail?: string | undefined;
    attachDocument?: string | undefined;
}

export class AddCustomerInfoReq implements IAddCustomerInfoReq {
    customerInfo?: CustomerInfoDTO;

    constructor(data?: IAddCustomerInfoReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerInfo = _data["customerInfo"] ? CustomerInfoDTO.fromJS(_data["customerInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerInfoReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerInfoReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerInfo"] = this.customerInfo ? this.customerInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerInfoReq {
    customerInfo?: CustomerInfoDTO;
}

export class CustomersFtpReq implements ICustomersFtpReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: ICustomersFtpReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomersFtpReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersFtpReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomersFtpReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class CustomerFtpInfoDTO implements ICustomerFtpInfoDTO {
    id?: number;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    connectType?: number;
    format?: string | undefined;
    isMapping?: boolean;
    mappingCode?: string | undefined;
    searchpattern?: string | undefined;
    isPreprocessActive?: boolean;
    preprocessSearchPattern?: string | undefined;
    isGetDocumentsActive?: boolean;

    constructor(data?: ICustomerFtpInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customerTitle = _data["customerTitle"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.connectType = _data["connectType"];
            this.format = _data["format"];
            this.isMapping = _data["isMapping"];
            this.mappingCode = _data["mappingCode"];
            this.searchpattern = _data["searchpattern"];
            this.isPreprocessActive = _data["isPreprocessActive"];
            this.preprocessSearchPattern = _data["preprocessSearchPattern"];
            this.isGetDocumentsActive = _data["isGetDocumentsActive"];
        }
    }

    static fromJS(data: any): CustomerFtpInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFtpInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customerTitle"] = this.customerTitle;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["connectType"] = this.connectType;
        data["format"] = this.format;
        data["isMapping"] = this.isMapping;
        data["mappingCode"] = this.mappingCode;
        data["searchpattern"] = this.searchpattern;
        data["isPreprocessActive"] = this.isPreprocessActive;
        data["preprocessSearchPattern"] = this.preprocessSearchPattern;
        data["isGetDocumentsActive"] = this.isGetDocumentsActive;
        return data; 
    }
}

export interface ICustomerFtpInfoDTO {
    id?: number;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    connectType?: number;
    format?: string | undefined;
    isMapping?: boolean;
    mappingCode?: string | undefined;
    searchpattern?: string | undefined;
    isPreprocessActive?: boolean;
    preprocessSearchPattern?: string | undefined;
    isGetDocumentsActive?: boolean;
}

export class CustomersFtpRes implements ICustomersFtpRes {
    totalRecordCount?: number;
    listData?: CustomerFtpInfoDTO[] | undefined;

    constructor(data?: ICustomersFtpRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerFtpInfoDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomersFtpRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersFtpRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomersFtpRes {
    totalRecordCount?: number;
    listData?: CustomerFtpInfoDTO[] | undefined;
}

export class AddCustomerFtpReq implements IAddCustomerFtpReq {
    customerFtpInfo?: CustomerFtpInfoDTO;

    constructor(data?: IAddCustomerFtpReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerFtpInfo = _data["customerFtpInfo"] ? CustomerFtpInfoDTO.fromJS(_data["customerFtpInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerFtpReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerFtpReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerFtpInfo"] = this.customerFtpInfo ? this.customerFtpInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerFtpReq {
    customerFtpInfo?: CustomerFtpInfoDTO;
}

export class AddCustomerFtpRes implements IAddCustomerFtpRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerFtpDTO?: CustomerFtpInfoDTO;

    constructor(data?: IAddCustomerFtpRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerFtpDTO = _data["customerFtpDTO"] ? CustomerFtpInfoDTO.fromJS(_data["customerFtpDTO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerFtpRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerFtpRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerFtpDTO"] = this.customerFtpDTO ? this.customerFtpDTO.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerFtpRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerFtpDTO?: CustomerFtpInfoDTO;
}

export class UpdateCustomerFtpReq implements IUpdateCustomerFtpReq {
    customerFtpInfo?: CustomerFtpInfoDTO;

    constructor(data?: IUpdateCustomerFtpReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerFtpInfo = _data["customerFtpInfo"] ? CustomerFtpInfoDTO.fromJS(_data["customerFtpInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerFtpReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerFtpReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerFtpInfo"] = this.customerFtpInfo ? this.customerFtpInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerFtpReq {
    customerFtpInfo?: CustomerFtpInfoDTO;
}

export class UpdateCustomerFtpRes implements IUpdateCustomerFtpRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerFtpInfo?: CustomerFtpInfoDTO;

    constructor(data?: IUpdateCustomerFtpRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerFtpInfo = _data["customerFtpInfo"] ? CustomerFtpInfoDTO.fromJS(_data["customerFtpInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerFtpRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerFtpRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerFtpInfo"] = this.customerFtpInfo ? this.customerFtpInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerFtpRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerFtpInfo?: CustomerFtpInfoDTO;
}

export class PartnerAndSubPartnerDTO implements IPartnerAndSubPartnerDTO {
    id?: string | undefined;
    identificationId?: string | undefined;
    title?: string | undefined;

    constructor(data?: IPartnerAndSubPartnerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identificationId = _data["identificationId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PartnerAndSubPartnerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerAndSubPartnerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identificationId"] = this.identificationId;
        data["title"] = this.title;
        return data; 
    }
}

export interface IPartnerAndSubPartnerDTO {
    id?: string | undefined;
    identificationId?: string | undefined;
    title?: string | undefined;
}

export class PartnerCustomersReq implements IPartnerCustomersReq {
    partnerId?: string | undefined;
    customerId?: string | undefined;
    multipleCustomerContourInfo?: boolean;
    contourInfoLevel?: string | undefined;

    constructor(data?: IPartnerCustomersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.customerId = _data["customerId"];
            this.multipleCustomerContourInfo = _data["multipleCustomerContourInfo"];
            this.contourInfoLevel = _data["contourInfoLevel"];
        }
    }

    static fromJS(data: any): PartnerCustomersReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCustomersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["customerId"] = this.customerId;
        data["multipleCustomerContourInfo"] = this.multipleCustomerContourInfo;
        data["contourInfoLevel"] = this.contourInfoLevel;
        return data; 
    }
}

export interface IPartnerCustomersReq {
    partnerId?: string | undefined;
    customerId?: string | undefined;
    multipleCustomerContourInfo?: boolean;
    contourInfoLevel?: string | undefined;
}

export class PartnerCustomersDTO implements IPartnerCustomersDTO {
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    serviceId?: number | undefined;
    totalContour?: number;
    fall10Percent?: boolean;
    fall0Percent?: boolean;
    lastContourDocument?: number | undefined;
    customerContactName?: string | undefined;
    customerContactSurName?: string | undefined;
    customerContactEmail?: string | undefined;
    customerContactPhone?: string | undefined;
    lastContourDocumentDate?: Date;
    dataSendMethod?: number | undefined;
    isXsltManagement?: number | undefined;
    isPrefixManagement?: number | undefined;
    isMapping?: number | undefined;
    contourMasterCustomerId?: string | undefined;
    contourMasterCustomerTitle?: string | undefined;
    neviIdentificationId?: string | undefined;

    constructor(data?: IPartnerCustomersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerTitle = _data["customerTitle"];
            this.partnerId = _data["partnerId"];
            this.partnerTitle = _data["partnerTitle"];
            this.serviceId = _data["serviceId"];
            this.totalContour = _data["totalContour"];
            this.fall10Percent = _data["fall10Percent"];
            this.fall0Percent = _data["fall0Percent"];
            this.lastContourDocument = _data["lastContourDocument"];
            this.customerContactName = _data["customerContactName"];
            this.customerContactSurName = _data["customerContactSurName"];
            this.customerContactEmail = _data["customerContactEmail"];
            this.customerContactPhone = _data["customerContactPhone"];
            this.lastContourDocumentDate = _data["lastContourDocumentDate"] ? new Date(_data["lastContourDocumentDate"].toString()) : <any>undefined;
            this.dataSendMethod = _data["dataSendMethod"];
            this.isXsltManagement = _data["isXsltManagement"];
            this.isPrefixManagement = _data["isPrefixManagement"];
            this.isMapping = _data["isMapping"];
            this.contourMasterCustomerId = _data["contourMasterCustomerId"];
            this.contourMasterCustomerTitle = _data["contourMasterCustomerTitle"];
            this.neviIdentificationId = _data["neviIdentificationId"];
        }
    }

    static fromJS(data: any): PartnerCustomersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCustomersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerTitle"] = this.customerTitle;
        data["partnerId"] = this.partnerId;
        data["partnerTitle"] = this.partnerTitle;
        data["serviceId"] = this.serviceId;
        data["totalContour"] = this.totalContour;
        data["fall10Percent"] = this.fall10Percent;
        data["fall0Percent"] = this.fall0Percent;
        data["lastContourDocument"] = this.lastContourDocument;
        data["customerContactName"] = this.customerContactName;
        data["customerContactSurName"] = this.customerContactSurName;
        data["customerContactEmail"] = this.customerContactEmail;
        data["customerContactPhone"] = this.customerContactPhone;
        data["lastContourDocumentDate"] = this.lastContourDocumentDate ? this.lastContourDocumentDate.toISOString() : <any>undefined;
        data["dataSendMethod"] = this.dataSendMethod;
        data["isXsltManagement"] = this.isXsltManagement;
        data["isPrefixManagement"] = this.isPrefixManagement;
        data["isMapping"] = this.isMapping;
        data["contourMasterCustomerId"] = this.contourMasterCustomerId;
        data["contourMasterCustomerTitle"] = this.contourMasterCustomerTitle;
        data["neviIdentificationId"] = this.neviIdentificationId;
        return data; 
    }
}

export interface IPartnerCustomersDTO {
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    serviceId?: number | undefined;
    totalContour?: number;
    fall10Percent?: boolean;
    fall0Percent?: boolean;
    lastContourDocument?: number | undefined;
    customerContactName?: string | undefined;
    customerContactSurName?: string | undefined;
    customerContactEmail?: string | undefined;
    customerContactPhone?: string | undefined;
    lastContourDocumentDate?: Date;
    dataSendMethod?: number | undefined;
    isXsltManagement?: number | undefined;
    isPrefixManagement?: number | undefined;
    isMapping?: number | undefined;
    contourMasterCustomerId?: string | undefined;
    contourMasterCustomerTitle?: string | undefined;
    neviIdentificationId?: string | undefined;
}

export class PartnerRemainingContourDTO implements IPartnerRemainingContourDTO {
    serviceId?: number | undefined;
    totalContour?: number;
    fall10Percent?: boolean;
    fall0Percent?: boolean;

    constructor(data?: IPartnerRemainingContourDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.totalContour = _data["totalContour"];
            this.fall10Percent = _data["fall10Percent"];
            this.fall0Percent = _data["fall0Percent"];
        }
    }

    static fromJS(data: any): PartnerRemainingContourDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRemainingContourDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["totalContour"] = this.totalContour;
        data["fall10Percent"] = this.fall10Percent;
        data["fall0Percent"] = this.fall0Percent;
        return data; 
    }
}

export interface IPartnerRemainingContourDTO {
    serviceId?: number | undefined;
    totalContour?: number;
    fall10Percent?: boolean;
    fall0Percent?: boolean;
}

export class PartnerCustomersRes implements IPartnerCustomersRes {
    partnerCustomersList?: PartnerCustomersDTO[] | undefined;
    partnerRemainingContours?: PartnerRemainingContourDTO[] | undefined;
    customerRemainingContoursLevelInfo?: PartnerCustomersDTO[] | undefined;

    constructor(data?: IPartnerCustomersRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partnerCustomersList"])) {
                this.partnerCustomersList = [] as any;
                for (let item of _data["partnerCustomersList"])
                    this.partnerCustomersList!.push(PartnerCustomersDTO.fromJS(item));
            }
            if (Array.isArray(_data["partnerRemainingContours"])) {
                this.partnerRemainingContours = [] as any;
                for (let item of _data["partnerRemainingContours"])
                    this.partnerRemainingContours!.push(PartnerRemainingContourDTO.fromJS(item));
            }
            if (Array.isArray(_data["customerRemainingContoursLevelInfo"])) {
                this.customerRemainingContoursLevelInfo = [] as any;
                for (let item of _data["customerRemainingContoursLevelInfo"])
                    this.customerRemainingContoursLevelInfo!.push(PartnerCustomersDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerCustomersRes {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCustomersRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partnerCustomersList)) {
            data["partnerCustomersList"] = [];
            for (let item of this.partnerCustomersList)
                data["partnerCustomersList"].push(item.toJSON());
        }
        if (Array.isArray(this.partnerRemainingContours)) {
            data["partnerRemainingContours"] = [];
            for (let item of this.partnerRemainingContours)
                data["partnerRemainingContours"].push(item.toJSON());
        }
        if (Array.isArray(this.customerRemainingContoursLevelInfo)) {
            data["customerRemainingContoursLevelInfo"] = [];
            for (let item of this.customerRemainingContoursLevelInfo)
                data["customerRemainingContoursLevelInfo"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnerCustomersRes {
    partnerCustomersList?: PartnerCustomersDTO[] | undefined;
    partnerRemainingContours?: PartnerRemainingContourDTO[] | undefined;
    customerRemainingContoursLevelInfo?: PartnerCustomersDTO[] | undefined;
}

export enum DocumentType {
    Unknown = "unknown",
    Einvoice = "einvoice",
    Earchive = "earchive",
    Earchive_onlineSale = "earchive_onlineSale",
    Earchive_receipt = "earchive_receipt",
    Eticket = "eticket",
    EdespatchAdvice = "edespatchAdvice",
    EreceiptAdvice = "ereceiptAdvice",
    Esevoucher = "esevoucher",
    Epreceipt = "epreceipt",
    Erevenue_old = "erevenue_old",
    Erevenue_new = "erevenue_new",
    Ebreceipt = "ebreceipt",
    Echeck = "echeck",
    Eicommission = "eicommission",
    Eereceipt = "eereceipt",
}

export class MonthlyDocumentCountReq implements IMonthlyDocumentCountReq {
    documentType?: DocumentType;
    customerID?: string | undefined;

    constructor(data?: IMonthlyDocumentCountReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.customerID = _data["customerID"];
        }
    }

    static fromJS(data: any): MonthlyDocumentCountReq {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyDocumentCountReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["customerID"] = this.customerID;
        return data; 
    }
}

export interface IMonthlyDocumentCountReq {
    documentType?: DocumentType;
    customerID?: string | undefined;
}

export class MonthlyDocumentCountDTO implements IMonthlyDocumentCountDTO {
    documentType?: string | undefined;
    documentDirection?: string | undefined;
    totalCount?: number | undefined;
    month?: number | undefined;
    year?: number | undefined;

    constructor(data?: IMonthlyDocumentCountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.documentDirection = _data["documentDirection"];
            this.totalCount = _data["totalCount"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): MonthlyDocumentCountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyDocumentCountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentDirection"] = this.documentDirection;
        data["totalCount"] = this.totalCount;
        data["month"] = this.month;
        data["year"] = this.year;
        return data; 
    }
}

export interface IMonthlyDocumentCountDTO {
    documentType?: string | undefined;
    documentDirection?: string | undefined;
    totalCount?: number | undefined;
    month?: number | undefined;
    year?: number | undefined;
}

export class MonthlyDocumentCountRes implements IMonthlyDocumentCountRes {
    monthlyDocumentCountList?: MonthlyDocumentCountDTO[] | undefined;

    constructor(data?: IMonthlyDocumentCountRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["monthlyDocumentCountList"])) {
                this.monthlyDocumentCountList = [] as any;
                for (let item of _data["monthlyDocumentCountList"])
                    this.monthlyDocumentCountList!.push(MonthlyDocumentCountDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthlyDocumentCountRes {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyDocumentCountRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.monthlyDocumentCountList)) {
            data["monthlyDocumentCountList"] = [];
            for (let item of this.monthlyDocumentCountList)
                data["monthlyDocumentCountList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMonthlyDocumentCountRes {
    monthlyDocumentCountList?: MonthlyDocumentCountDTO[] | undefined;
}

export class ContourHistoryReq implements IContourHistoryReq {
    customerID?: string | undefined;

    constructor(data?: IContourHistoryReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerID = _data["customerID"];
        }
    }

    static fromJS(data: any): ContourHistoryReq {
        data = typeof data === 'object' ? data : {};
        let result = new ContourHistoryReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerID"] = this.customerID;
        return data; 
    }
}

export interface IContourHistoryReq {
    customerID?: string | undefined;
}

export enum ContourTransactionTypeType {
    ContourInForPurchase = "ContourInForPurchase",
    ContourInForUpdate = "ContourInForUpdate",
    ContourInForDelete = "ContourInForDelete",
    ContourInForReturn = "ContourInForReturn",
    ContourOutForSales = "ContourOutForSales",
    ContourOutForUpdate = "ContourOutForUpdate",
    ContourOutForDelete = "ContourOutForDelete",
    ContourOutForReturn = "ContourOutForReturn",
    ContourOutForExpire = "ContourOutForExpire",
}

export class ContourHistoryDTO implements IContourHistoryDTO {
    partnerTitle?: string | undefined;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    transactionTime?: Date;
    transactionType?: ContourTransactionTypeType;
    contourCount?: number;
    serviceId?: number | undefined;

    constructor(data?: IContourHistoryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerTitle = _data["partnerTitle"];
            this.partnerId = _data["partnerId"];
            this.customerId = _data["customerId"];
            this.transactionTime = _data["transactionTime"] ? new Date(_data["transactionTime"].toString()) : <any>undefined;
            this.transactionType = _data["transactionType"];
            this.contourCount = _data["contourCount"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): ContourHistoryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ContourHistoryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerTitle"] = this.partnerTitle;
        data["partnerId"] = this.partnerId;
        data["customerId"] = this.customerId;
        data["transactionTime"] = this.transactionTime ? this.transactionTime.toISOString() : <any>undefined;
        data["transactionType"] = this.transactionType;
        data["contourCount"] = this.contourCount;
        data["serviceId"] = this.serviceId;
        return data; 
    }
}

export interface IContourHistoryDTO {
    partnerTitle?: string | undefined;
    partnerId?: string | undefined;
    customerId?: string | undefined;
    transactionTime?: Date;
    transactionType?: ContourTransactionTypeType;
    contourCount?: number;
    serviceId?: number | undefined;
}

export class ContourHistoryRes implements IContourHistoryRes {
    contourHistoryList?: ContourHistoryDTO[] | undefined;

    constructor(data?: IContourHistoryRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["contourHistoryList"])) {
                this.contourHistoryList = [] as any;
                for (let item of _data["contourHistoryList"])
                    this.contourHistoryList!.push(ContourHistoryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContourHistoryRes {
        data = typeof data === 'object' ? data : {};
        let result = new ContourHistoryRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contourHistoryList)) {
            data["contourHistoryList"] = [];
            for (let item of this.contourHistoryList)
                data["contourHistoryList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IContourHistoryRes {
    contourHistoryList?: ContourHistoryDTO[] | undefined;
}

export class MonthlyAllServicesDocumentCountReq implements IMonthlyAllServicesDocumentCountReq {
    customerID?: string | undefined;

    constructor(data?: IMonthlyAllServicesDocumentCountReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerID = _data["customerID"];
        }
    }

    static fromJS(data: any): MonthlyAllServicesDocumentCountReq {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyAllServicesDocumentCountReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerID"] = this.customerID;
        return data; 
    }
}

export interface IMonthlyAllServicesDocumentCountReq {
    customerID?: string | undefined;
}

export class RunLowContourMailToPartnerServiceResponse implements IRunLowContourMailToPartnerServiceResponse {
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IRunLowContourMailToPartnerServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): RunLowContourMailToPartnerServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RunLowContourMailToPartnerServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data; 
    }
}

export interface IRunLowContourMailToPartnerServiceResponse {
    isSuccess?: boolean;
    message?: string | undefined;
}

export class CountryDTO implements ICountryDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICountryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data; 
    }
}

export interface ICountryDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
}

export class CountriesRes implements ICountriesRes {
    countries?: CountryDTO[] | undefined;

    constructor(data?: ICountriesRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountriesRes {
        data = typeof data === 'object' ? data : {};
        let result = new CountriesRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICountriesRes {
    countries?: CountryDTO[] | undefined;
}

export class CityDTO implements ICityDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    countryId?: number | undefined;

    constructor(data?: ICityDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CityDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CityDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["countryId"] = this.countryId;
        return data; 
    }
}

export interface ICityDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    countryId?: number | undefined;
}

export class CitiesRes implements ICitiesRes {
    cities?: CityDTO[] | undefined;

    constructor(data?: ICitiesRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CitiesRes {
        data = typeof data === 'object' ? data : {};
        let result = new CitiesRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICitiesRes {
    cities?: CityDTO[] | undefined;
}

export class CitySubdivisionDTO implements ICitySubdivisionDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    cityId?: number | undefined;

    constructor(data?: ICitySubdivisionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.cityId = _data["cityId"];
        }
    }

    static fromJS(data: any): CitySubdivisionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CitySubdivisionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["cityId"] = this.cityId;
        return data; 
    }
}

export interface ICitySubdivisionDTO {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    cityId?: number | undefined;
}

export class CitySubdivisionsRes implements ICitySubdivisionsRes {
    citySubdivisions?: CitySubdivisionDTO[] | undefined;

    constructor(data?: ICitySubdivisionsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["citySubdivisions"])) {
                this.citySubdivisions = [] as any;
                for (let item of _data["citySubdivisions"])
                    this.citySubdivisions!.push(CitySubdivisionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CitySubdivisionsRes {
        data = typeof data === 'object' ? data : {};
        let result = new CitySubdivisionsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.citySubdivisions)) {
            data["citySubdivisions"] = [];
            for (let item of this.citySubdivisions)
                data["citySubdivisions"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICitySubdivisionsRes {
    citySubdivisions?: CitySubdivisionDTO[] | undefined;
}

export class RouteTenantReq implements IRouteTenantReq {
    serviceId?: number | undefined;

    constructor(data?: IRouteTenantReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): RouteTenantReq {
        data = typeof data === 'object' ? data : {};
        let result = new RouteTenantReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        return data; 
    }
}

export interface IRouteTenantReq {
    serviceId?: number | undefined;
}

export class CustomerServicesInfoReq implements ICustomerServicesInfoReq {
    customerId?: string | undefined;
    unLocked?: boolean;

    constructor(data?: ICustomerServicesInfoReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.unLocked = _data["unLocked"];
        }
    }

    static fromJS(data: any): CustomerServicesInfoReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerServicesInfoReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["unLocked"] = this.unLocked;
        return data; 
    }
}

export interface ICustomerServicesInfoReq {
    customerId?: string | undefined;
    unLocked?: boolean;
}

export class CustomerServicesDTO implements ICustomerServicesDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICustomerServicesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CustomerServicesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerServicesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface ICustomerServicesDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class CustomerServicesInfoRes implements ICustomerServicesInfoRes {
    customerServicesInfo?: CustomerServicesDTO[] | undefined;

    constructor(data?: ICustomerServicesInfoRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerServicesInfo"])) {
                this.customerServicesInfo = [] as any;
                for (let item of _data["customerServicesInfo"])
                    this.customerServicesInfo!.push(CustomerServicesDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerServicesInfoRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerServicesInfoRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerServicesInfo)) {
            data["customerServicesInfo"] = [];
            for (let item of this.customerServicesInfo)
                data["customerServicesInfo"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerServicesInfoRes {
    customerServicesInfo?: CustomerServicesDTO[] | undefined;
}

export class DocumentMappingReq implements IDocumentMappingReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerId?: string | undefined;

    constructor(data?: IDocumentMappingReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): DocumentMappingReq {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMappingReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IDocumentMappingReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerId?: string | undefined;
}

export class DocumentMappingDTO implements IDocumentMappingDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    mapCode?: string | undefined;
    description?: string | undefined;
    fileExtensionFilter?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    mapXsltFileName?: string | undefined;
    mappingFileData?: string | undefined;
    direction?: number;

    constructor(data?: IDocumentMappingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.mapCode = _data["mapCode"];
            this.description = _data["description"];
            this.fileExtensionFilter = _data["fileExtensionFilter"];
            this.customerBranchId = _data["customerBranchId"];
            this.customerBranchName = _data["customerBranchName"];
            this.mapXsltFileName = _data["mapXsltFileName"];
            this.mappingFileData = _data["mappingFileData"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): DocumentMappingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMappingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["mapCode"] = this.mapCode;
        data["description"] = this.description;
        data["fileExtensionFilter"] = this.fileExtensionFilter;
        data["customerBranchId"] = this.customerBranchId;
        data["customerBranchName"] = this.customerBranchName;
        data["mapXsltFileName"] = this.mapXsltFileName;
        data["mappingFileData"] = this.mappingFileData;
        data["direction"] = this.direction;
        return data; 
    }
}

export interface IDocumentMappingDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    mapCode?: string | undefined;
    description?: string | undefined;
    fileExtensionFilter?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    mapXsltFileName?: string | undefined;
    mappingFileData?: string | undefined;
    direction?: number;
}

export class DocumentMappingRes implements IDocumentMappingRes {
    totalRecordCount?: number;
    listData?: DocumentMappingDTO[] | undefined;
    customerBranches?: CustomerBranchDTO[] | undefined;

    constructor(data?: IDocumentMappingRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(DocumentMappingDTO.fromJS(item));
            }
            if (Array.isArray(_data["customerBranches"])) {
                this.customerBranches = [] as any;
                for (let item of _data["customerBranches"])
                    this.customerBranches!.push(CustomerBranchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentMappingRes {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMappingRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        if (Array.isArray(this.customerBranches)) {
            data["customerBranches"] = [];
            for (let item of this.customerBranches)
                data["customerBranches"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDocumentMappingRes {
    totalRecordCount?: number;
    listData?: DocumentMappingDTO[] | undefined;
    customerBranches?: CustomerBranchDTO[] | undefined;
}

export class DocumentMappingDetailDTO implements IDocumentMappingDetailDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    mapCode?: string | undefined;
    description?: string | undefined;
    fileExtensionFilter?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    mapXsltFileName?: string | undefined;
    mappingFileData?: string | undefined;
    direction?: number;

    constructor(data?: IDocumentMappingDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.mapCode = _data["mapCode"];
            this.description = _data["description"];
            this.fileExtensionFilter = _data["fileExtensionFilter"];
            this.customerBranchId = _data["customerBranchId"];
            this.customerBranchName = _data["customerBranchName"];
            this.mapXsltFileName = _data["mapXsltFileName"];
            this.mappingFileData = _data["mappingFileData"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): DocumentMappingDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentMappingDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["mapCode"] = this.mapCode;
        data["description"] = this.description;
        data["fileExtensionFilter"] = this.fileExtensionFilter;
        data["customerBranchId"] = this.customerBranchId;
        data["customerBranchName"] = this.customerBranchName;
        data["mapXsltFileName"] = this.mapXsltFileName;
        data["mappingFileData"] = this.mappingFileData;
        data["direction"] = this.direction;
        return data; 
    }
}

export interface IDocumentMappingDetailDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    mapCode?: string | undefined;
    description?: string | undefined;
    fileExtensionFilter?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    mapXsltFileName?: string | undefined;
    mappingFileData?: string | undefined;
    direction?: number;
}

export class AddDocumentMappingReq implements IAddDocumentMappingReq {
    documentMapping?: DocumentMappingDetailDTO;
    customerId?: string | undefined;

    constructor(data?: IAddDocumentMappingReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentMapping = _data["documentMapping"] ? DocumentMappingDetailDTO.fromJS(_data["documentMapping"]) : <any>undefined;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): AddDocumentMappingReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddDocumentMappingReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentMapping"] = this.documentMapping ? this.documentMapping.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IAddDocumentMappingReq {
    documentMapping?: DocumentMappingDetailDTO;
    customerId?: string | undefined;
}

export class UpdateDocumentMappingReq implements IUpdateDocumentMappingReq {
    documentMapping?: DocumentMappingDetailDTO;
    customerId?: string | undefined;

    constructor(data?: IUpdateDocumentMappingReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentMapping = _data["documentMapping"] ? DocumentMappingDetailDTO.fromJS(_data["documentMapping"]) : <any>undefined;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): UpdateDocumentMappingReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentMappingReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentMapping"] = this.documentMapping ? this.documentMapping.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IUpdateDocumentMappingReq {
    documentMapping?: DocumentMappingDetailDTO;
    customerId?: string | undefined;
}

export class DocumentPrefixReq implements IDocumentPrefixReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerId?: string | undefined;

    constructor(data?: IDocumentPrefixReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): DocumentPrefixReq {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrefixReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IDocumentPrefixReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerId?: string | undefined;
}

export class DocumentPrefixDTO implements IDocumentPrefixDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    documentType?: DocumentType;
    isDefault?: number | undefined;
    prefix?: string | undefined;
    description?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    isPortal?: number | undefined;
    isAutoCreated?: number | undefined;
    recordStatus?: number | undefined;

    constructor(data?: IDocumentPrefixDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.documentType = _data["documentType"];
            this.isDefault = _data["isDefault"];
            this.prefix = _data["prefix"];
            this.description = _data["description"];
            this.customerBranchId = _data["customerBranchId"];
            this.customerBranchName = _data["customerBranchName"];
            this.isPortal = _data["isPortal"];
            this.isAutoCreated = _data["isAutoCreated"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DocumentPrefixDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrefixDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["documentType"] = this.documentType;
        data["isDefault"] = this.isDefault;
        data["prefix"] = this.prefix;
        data["description"] = this.description;
        data["customerBranchId"] = this.customerBranchId;
        data["customerBranchName"] = this.customerBranchName;
        data["isPortal"] = this.isPortal;
        data["isAutoCreated"] = this.isAutoCreated;
        data["recordStatus"] = this.recordStatus;
        return data; 
    }
}

export interface IDocumentPrefixDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    documentType?: DocumentType;
    isDefault?: number | undefined;
    prefix?: string | undefined;
    description?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    isPortal?: number | undefined;
    isAutoCreated?: number | undefined;
    recordStatus?: number | undefined;
}

export class DocumentPrefixRes implements IDocumentPrefixRes {
    totalRecordCount?: number;
    listData?: DocumentPrefixDTO[] | undefined;
    customerBranches?: CustomerBranchDTO[] | undefined;

    constructor(data?: IDocumentPrefixRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(DocumentPrefixDTO.fromJS(item));
            }
            if (Array.isArray(_data["customerBranches"])) {
                this.customerBranches = [] as any;
                for (let item of _data["customerBranches"])
                    this.customerBranches!.push(CustomerBranchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentPrefixRes {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrefixRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        if (Array.isArray(this.customerBranches)) {
            data["customerBranches"] = [];
            for (let item of this.customerBranches)
                data["customerBranches"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDocumentPrefixRes {
    totalRecordCount?: number;
    listData?: DocumentPrefixDTO[] | undefined;
    customerBranches?: CustomerBranchDTO[] | undefined;
}

export class DocumentPrefixDetailDTO implements IDocumentPrefixDetailDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    documentType?: DocumentType;
    isDefault?: number | undefined;
    prefix?: string | undefined;
    description?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    isPortal?: number | undefined;
    isAutoCreated?: number | undefined;
    recordStatus?: number | undefined;

    constructor(data?: IDocumentPrefixDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.documentType = _data["documentType"];
            this.isDefault = _data["isDefault"];
            this.prefix = _data["prefix"];
            this.description = _data["description"];
            this.customerBranchId = _data["customerBranchId"];
            this.customerBranchName = _data["customerBranchName"];
            this.isPortal = _data["isPortal"];
            this.isAutoCreated = _data["isAutoCreated"];
            this.recordStatus = _data["recordStatus"];
        }
    }

    static fromJS(data: any): DocumentPrefixDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrefixDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["documentType"] = this.documentType;
        data["isDefault"] = this.isDefault;
        data["prefix"] = this.prefix;
        data["description"] = this.description;
        data["customerBranchId"] = this.customerBranchId;
        data["customerBranchName"] = this.customerBranchName;
        data["isPortal"] = this.isPortal;
        data["isAutoCreated"] = this.isAutoCreated;
        data["recordStatus"] = this.recordStatus;
        return data; 
    }
}

export interface IDocumentPrefixDetailDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    documentType?: DocumentType;
    isDefault?: number | undefined;
    prefix?: string | undefined;
    description?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    isPortal?: number | undefined;
    isAutoCreated?: number | undefined;
    recordStatus?: number | undefined;
}

export class AddDocumentPrefixReq implements IAddDocumentPrefixReq {
    documentPrefix?: DocumentPrefixDetailDTO;
    customerId?: string | undefined;

    constructor(data?: IAddDocumentPrefixReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentPrefix = _data["documentPrefix"] ? DocumentPrefixDetailDTO.fromJS(_data["documentPrefix"]) : <any>undefined;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): AddDocumentPrefixReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddDocumentPrefixReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentPrefix"] = this.documentPrefix ? this.documentPrefix.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IAddDocumentPrefixReq {
    documentPrefix?: DocumentPrefixDetailDTO;
    customerId?: string | undefined;
}

export class DocumentPrefixPagePartnerCustomersReq implements IDocumentPrefixPagePartnerCustomersReq {
    filter?: string | undefined;

    constructor(data?: IDocumentPrefixPagePartnerCustomersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): DocumentPrefixPagePartnerCustomersReq {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentPrefixPagePartnerCustomersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IDocumentPrefixPagePartnerCustomersReq {
    filter?: string | undefined;
}

export class PartnerCustomersInfo implements IPartnerCustomersInfo {
    identityId?: string | undefined;
    title?: string | undefined;
    userLevel?: number | undefined;

    constructor(data?: IPartnerCustomersInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityId = _data["identityId"];
            this.title = _data["title"];
            this.userLevel = _data["userLevel"];
        }
    }

    static fromJS(data: any): PartnerCustomersInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCustomersInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId;
        data["title"] = this.title;
        data["userLevel"] = this.userLevel;
        return data; 
    }
}

export interface IPartnerCustomersInfo {
    identityId?: string | undefined;
    title?: string | undefined;
    userLevel?: number | undefined;
}

export class UpdateDocumentPrefixReq implements IUpdateDocumentPrefixReq {
    documentPrefix?: DocumentPrefixDetailDTO;
    customerId?: string | undefined;

    constructor(data?: IUpdateDocumentPrefixReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentPrefix = _data["documentPrefix"] ? DocumentPrefixDetailDTO.fromJS(_data["documentPrefix"]) : <any>undefined;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): UpdateDocumentPrefixReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentPrefixReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentPrefix"] = this.documentPrefix ? this.documentPrefix.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IUpdateDocumentPrefixReq {
    documentPrefix?: DocumentPrefixDetailDTO;
    customerId?: string | undefined;
}

export class ControlDocumentPrefixNumberReq implements IControlDocumentPrefixNumberReq {
    id?: number;

    constructor(data?: IControlDocumentPrefixNumberReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ControlDocumentPrefixNumberReq {
        data = typeof data === 'object' ? data : {};
        let result = new ControlDocumentPrefixNumberReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IControlDocumentPrefixNumberReq {
    id?: number;
}

export class XsltDocumentsReq implements IXsltDocumentsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerId?: string | undefined;

    constructor(data?: IXsltDocumentsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): XsltDocumentsReq {
        data = typeof data === 'object' ? data : {};
        let result = new XsltDocumentsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IXsltDocumentsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
    customerId?: string | undefined;
}

export class XsltDocumentsDTO implements IXsltDocumentsDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    documentType?: DocumentType;
    isDefault?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    xsltData?: string | undefined;

    constructor(data?: IXsltDocumentsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.documentType = _data["documentType"];
            this.isDefault = _data["isDefault"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.customerBranchId = _data["customerBranchId"];
            this.customerBranchName = _data["customerBranchName"];
            this.xsltData = _data["xsltData"];
        }
    }

    static fromJS(data: any): XsltDocumentsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XsltDocumentsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["documentType"] = this.documentType;
        data["isDefault"] = this.isDefault;
        data["name"] = this.name;
        data["description"] = this.description;
        data["customerBranchId"] = this.customerBranchId;
        data["customerBranchName"] = this.customerBranchName;
        data["xsltData"] = this.xsltData;
        return data; 
    }
}

export interface IXsltDocumentsDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    documentType?: DocumentType;
    isDefault?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    xsltData?: string | undefined;
}

export class XsltDocumentsRes implements IXsltDocumentsRes {
    totalRecordCount?: number;
    listData?: XsltDocumentsDTO[] | undefined;
    customerBranches?: CustomerBranchDTO[] | undefined;

    constructor(data?: IXsltDocumentsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(XsltDocumentsDTO.fromJS(item));
            }
            if (Array.isArray(_data["customerBranches"])) {
                this.customerBranches = [] as any;
                for (let item of _data["customerBranches"])
                    this.customerBranches!.push(CustomerBranchDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): XsltDocumentsRes {
        data = typeof data === 'object' ? data : {};
        let result = new XsltDocumentsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        if (Array.isArray(this.customerBranches)) {
            data["customerBranches"] = [];
            for (let item of this.customerBranches)
                data["customerBranches"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IXsltDocumentsRes {
    totalRecordCount?: number;
    listData?: XsltDocumentsDTO[] | undefined;
    customerBranches?: CustomerBranchDTO[] | undefined;
}

export class XsltDocumentsDetailDTO implements IXsltDocumentsDetailDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    documentType?: DocumentType;
    isDefault?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    xsltData?: string | undefined;

    constructor(data?: IXsltDocumentsDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.documentType = _data["documentType"];
            this.isDefault = _data["isDefault"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.customerBranchId = _data["customerBranchId"];
            this.customerBranchName = _data["customerBranchName"];
            this.xsltData = _data["xsltData"];
        }
    }

    static fromJS(data: any): XsltDocumentsDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new XsltDocumentsDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["documentType"] = this.documentType;
        data["isDefault"] = this.isDefault;
        data["name"] = this.name;
        data["description"] = this.description;
        data["customerBranchId"] = this.customerBranchId;
        data["customerBranchName"] = this.customerBranchName;
        data["xsltData"] = this.xsltData;
        return data; 
    }
}

export interface IXsltDocumentsDetailDTO {
    id?: number;
    customerId?: string | undefined;
    serviceId?: number;
    serviceName?: string | undefined;
    documentType?: DocumentType;
    isDefault?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    customerBranchId?: number | undefined;
    customerBranchName?: string | undefined;
    xsltData?: string | undefined;
}

export class AddXsltDocumentsReq implements IAddXsltDocumentsReq {
    xsltDocument?: XsltDocumentsDetailDTO;
    customerId?: string | undefined;

    constructor(data?: IAddXsltDocumentsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xsltDocument = _data["xsltDocument"] ? XsltDocumentsDetailDTO.fromJS(_data["xsltDocument"]) : <any>undefined;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): AddXsltDocumentsReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddXsltDocumentsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xsltDocument"] = this.xsltDocument ? this.xsltDocument.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IAddXsltDocumentsReq {
    xsltDocument?: XsltDocumentsDetailDTO;
    customerId?: string | undefined;
}

export class UpdateXsltDocumentsReq implements IUpdateXsltDocumentsReq {
    xsltDocument?: XsltDocumentsDetailDTO;
    customerId?: string | undefined;

    constructor(data?: IUpdateXsltDocumentsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xsltDocument = _data["xsltDocument"] ? XsltDocumentsDetailDTO.fromJS(_data["xsltDocument"]) : <any>undefined;
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): UpdateXsltDocumentsReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateXsltDocumentsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xsltDocument"] = this.xsltDocument ? this.xsltDocument.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IUpdateXsltDocumentsReq {
    xsltDocument?: XsltDocumentsDetailDTO;
    customerId?: string | undefined;
}

export class PaymentInfo implements IPaymentInfo {
    iban?: string | undefined;
    currencyCode?: string | undefined;
    bankName?: string | undefined;

    constructor(data?: IPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iban = _data["iban"];
            this.currencyCode = _data["currencyCode"];
            this.bankName = _data["bankName"];
        }
    }

    static fromJS(data: any): PaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iban"] = this.iban;
        data["currencyCode"] = this.currencyCode;
        data["bankName"] = this.bankName;
        return data; 
    }
}

export interface IPaymentInfo {
    iban?: string | undefined;
    currencyCode?: string | undefined;
    bankName?: string | undefined;
}

export class AddPaymentInfoToXsltDocumentReq implements IAddPaymentInfoToXsltDocumentReq {
    customerId?: string | undefined;
    xsltId?: number;
    logoBase64?: string | undefined;
    signatureImageBase64?: string | undefined;
    paymentInfos?: PaymentInfo[] | undefined;

    constructor(data?: IAddPaymentInfoToXsltDocumentReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.xsltId = _data["xsltId"];
            this.logoBase64 = _data["logoBase64"];
            this.signatureImageBase64 = _data["signatureImageBase64"];
            if (Array.isArray(_data["paymentInfos"])) {
                this.paymentInfos = [] as any;
                for (let item of _data["paymentInfos"])
                    this.paymentInfos!.push(PaymentInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddPaymentInfoToXsltDocumentReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddPaymentInfoToXsltDocumentReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["xsltId"] = this.xsltId;
        data["logoBase64"] = this.logoBase64;
        data["signatureImageBase64"] = this.signatureImageBase64;
        if (Array.isArray(this.paymentInfos)) {
            data["paymentInfos"] = [];
            for (let item of this.paymentInfos)
                data["paymentInfos"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAddPaymentInfoToXsltDocumentReq {
    customerId?: string | undefined;
    xsltId?: number;
    logoBase64?: string | undefined;
    signatureImageBase64?: string | undefined;
    paymentInfos?: PaymentInfo[] | undefined;
}

export class GetPaymentInfoFromXsltDocumentRes implements IGetPaymentInfoFromXsltDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    paymentInfos?: PaymentInfo[] | undefined;

    constructor(data?: IGetPaymentInfoFromXsltDocumentRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            if (Array.isArray(_data["paymentInfos"])) {
                this.paymentInfos = [] as any;
                for (let item of _data["paymentInfos"])
                    this.paymentInfos!.push(PaymentInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPaymentInfoFromXsltDocumentRes {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentInfoFromXsltDocumentRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        if (Array.isArray(this.paymentInfos)) {
            data["paymentInfos"] = [];
            for (let item of this.paymentInfos)
                data["paymentInfos"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetPaymentInfoFromXsltDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    paymentInfos?: PaymentInfo[] | undefined;
}

export class ELedgerGibAppServerDTO implements IELedgerGibAppServerDTO {
    id?: number;
    isDefault?: boolean;
    serverName?: string | undefined;
    serverIP?: string | undefined;
    gibAppDbPath?: string | undefined;
    gibAppDbName?: string | undefined;
    gibAppDocumentRootPath?: string | undefined;
    gibAppLogsRootPath?: string | undefined;
    maxCustomerCount?: number;

    constructor(data?: IELedgerGibAppServerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isDefault = _data["isDefault"];
            this.serverName = _data["serverName"];
            this.serverIP = _data["serverIP"];
            this.gibAppDbPath = _data["gibAppDbPath"];
            this.gibAppDbName = _data["gibAppDbName"];
            this.gibAppDocumentRootPath = _data["gibAppDocumentRootPath"];
            this.gibAppLogsRootPath = _data["gibAppLogsRootPath"];
            this.maxCustomerCount = _data["maxCustomerCount"];
        }
    }

    static fromJS(data: any): ELedgerGibAppServerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ELedgerGibAppServerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isDefault"] = this.isDefault;
        data["serverName"] = this.serverName;
        data["serverIP"] = this.serverIP;
        data["gibAppDbPath"] = this.gibAppDbPath;
        data["gibAppDbName"] = this.gibAppDbName;
        data["gibAppDocumentRootPath"] = this.gibAppDocumentRootPath;
        data["gibAppLogsRootPath"] = this.gibAppLogsRootPath;
        data["maxCustomerCount"] = this.maxCustomerCount;
        return data; 
    }
}

export interface IELedgerGibAppServerDTO {
    id?: number;
    isDefault?: boolean;
    serverName?: string | undefined;
    serverIP?: string | undefined;
    gibAppDbPath?: string | undefined;
    gibAppDbName?: string | undefined;
    gibAppDocumentRootPath?: string | undefined;
    gibAppLogsRootPath?: string | undefined;
    maxCustomerCount?: number;
}

export class GibAppServerAddServerReq implements IGibAppServerAddServerReq {
    eLedgerGibAppServer?: ELedgerGibAppServerDTO;

    constructor(data?: IGibAppServerAddServerReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eLedgerGibAppServer = _data["eLedgerGibAppServer"] ? ELedgerGibAppServerDTO.fromJS(_data["eLedgerGibAppServer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GibAppServerAddServerReq {
        data = typeof data === 'object' ? data : {};
        let result = new GibAppServerAddServerReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eLedgerGibAppServer"] = this.eLedgerGibAppServer ? this.eLedgerGibAppServer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGibAppServerAddServerReq {
    eLedgerGibAppServer?: ELedgerGibAppServerDTO;
}

export class GibAppServerUpdateServerReq implements IGibAppServerUpdateServerReq {
    eLedgerGibAppServer?: ELedgerGibAppServerDTO;

    constructor(data?: IGibAppServerUpdateServerReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eLedgerGibAppServer = _data["eLedgerGibAppServer"] ? ELedgerGibAppServerDTO.fromJS(_data["eLedgerGibAppServer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GibAppServerUpdateServerReq {
        data = typeof data === 'object' ? data : {};
        let result = new GibAppServerUpdateServerReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eLedgerGibAppServer"] = this.eLedgerGibAppServer ? this.eLedgerGibAppServer.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IGibAppServerUpdateServerReq {
    eLedgerGibAppServer?: ELedgerGibAppServerDTO;
}

export class ELedgerArchiveCustomersListReq implements IELedgerArchiveCustomersListReq {
    filter?: string | undefined;

    constructor(data?: IELedgerArchiveCustomersListReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): ELedgerArchiveCustomersListReq {
        data = typeof data === 'object' ? data : {};
        let result = new ELedgerArchiveCustomersListReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IELedgerArchiveCustomersListReq {
    filter?: string | undefined;
}

export class ELedgerArchiveCustomerInfoDTO implements IELedgerArchiveCustomerInfoDTO {
    customerId?: string | undefined;
    shortCode?: string | undefined;
    title?: string | undefined;

    constructor(data?: IELedgerArchiveCustomerInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.shortCode = _data["shortCode"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): ELedgerArchiveCustomerInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ELedgerArchiveCustomerInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["shortCode"] = this.shortCode;
        data["title"] = this.title;
        return data; 
    }
}

export interface IELedgerArchiveCustomerInfoDTO {
    customerId?: string | undefined;
    shortCode?: string | undefined;
    title?: string | undefined;
}

export class CustomerGibAppServersListReq implements ICustomerGibAppServersListReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: ICustomerGibAppServersListReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerGibAppServersListReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGibAppServersListReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerGibAppServersListReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class CustomerGibAppServersDTO implements ICustomerGibAppServersDTO {
    id?: number;
    customerId?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
    serverName?: string | undefined;
    serverNameID?: number;

    constructor(data?: ICustomerGibAppServersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customerShortCode = _data["customerShortCode"];
            this.customerTitle = _data["customerTitle"];
            this.serverName = _data["serverName"];
            this.serverNameID = _data["serverNameID"];
        }
    }

    static fromJS(data: any): CustomerGibAppServersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGibAppServersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customerShortCode"] = this.customerShortCode;
        data["customerTitle"] = this.customerTitle;
        data["serverName"] = this.serverName;
        data["serverNameID"] = this.serverNameID;
        return data; 
    }
}

export interface ICustomerGibAppServersDTO {
    id?: number;
    customerId?: string | undefined;
    customerShortCode?: string | undefined;
    customerTitle?: string | undefined;
    serverName?: string | undefined;
    serverNameID?: number;
}

export class CustomerGibAppServersListRes implements ICustomerGibAppServersListRes {
    totalRecordCount?: number;
    listData?: CustomerGibAppServersDTO[] | undefined;

    constructor(data?: ICustomerGibAppServersListRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerGibAppServersDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerGibAppServersListRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGibAppServersListRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerGibAppServersListRes {
    totalRecordCount?: number;
    listData?: CustomerGibAppServersDTO[] | undefined;
}

export class CustomerGibAppServersAddOrUpdateCustomerReq implements ICustomerGibAppServersAddOrUpdateCustomerReq {
    customerId?: string | undefined;
    gibAppServersId?: number;

    constructor(data?: ICustomerGibAppServersAddOrUpdateCustomerReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.gibAppServersId = _data["gibAppServersId"];
        }
    }

    static fromJS(data: any): CustomerGibAppServersAddOrUpdateCustomerReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerGibAppServersAddOrUpdateCustomerReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["gibAppServersId"] = this.gibAppServersId;
        return data; 
    }
}

export interface ICustomerGibAppServersAddOrUpdateCustomerReq {
    customerId?: string | undefined;
    gibAppServersId?: number;
}

export class OutgoingFieldsReq implements IOutgoingFieldsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IOutgoingFieldsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutgoingFieldsReq {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingFieldsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOutgoingFieldsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class AdditionalFieldsDTO implements IAdditionalFieldsDTO {
    id?: number;
    isActive?: number;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    serviceId?: number;
    serviceCode?: string | undefined;
    fieldName?: string | undefined;
    fieldAlias?: string | undefined;
    fieldCaption?: string | undefined;
    fieldDescription?: string | undefined;

    constructor(data?: IAdditionalFieldsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.customerId = _data["customerId"];
            this.customerTitle = _data["customerTitle"];
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.fieldName = _data["fieldName"];
            this.fieldAlias = _data["fieldAlias"];
            this.fieldCaption = _data["fieldCaption"];
            this.fieldDescription = _data["fieldDescription"];
        }
    }

    static fromJS(data: any): AdditionalFieldsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalFieldsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["customerId"] = this.customerId;
        data["customerTitle"] = this.customerTitle;
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["fieldName"] = this.fieldName;
        data["fieldAlias"] = this.fieldAlias;
        data["fieldCaption"] = this.fieldCaption;
        data["fieldDescription"] = this.fieldDescription;
        return data; 
    }
}

export interface IAdditionalFieldsDTO {
    id?: number;
    isActive?: number;
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    serviceId?: number;
    serviceCode?: string | undefined;
    fieldName?: string | undefined;
    fieldAlias?: string | undefined;
    fieldCaption?: string | undefined;
    fieldDescription?: string | undefined;
}

export class OutgoingFieldsRes implements IOutgoingFieldsRes {
    totalRecordCount?: number;
    listData?: AdditionalFieldsDTO[] | undefined;

    constructor(data?: IOutgoingFieldsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(AdditionalFieldsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OutgoingFieldsRes {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingFieldsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IOutgoingFieldsRes {
    totalRecordCount?: number;
    listData?: AdditionalFieldsDTO[] | undefined;
}

export class AddOutgoingFieldReq implements IAddOutgoingFieldReq {
    additionalFields?: AdditionalFieldsDTO;

    constructor(data?: IAddOutgoingFieldReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFields = _data["additionalFields"] ? AdditionalFieldsDTO.fromJS(_data["additionalFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddOutgoingFieldReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddOutgoingFieldReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFields"] = this.additionalFields ? this.additionalFields.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddOutgoingFieldReq {
    additionalFields?: AdditionalFieldsDTO;
}

export class AddOutgoingFieldRes implements IAddOutgoingFieldRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    additionalFields?: AdditionalFieldsDTO;

    constructor(data?: IAddOutgoingFieldRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.additionalFields = _data["additionalFields"] ? AdditionalFieldsDTO.fromJS(_data["additionalFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddOutgoingFieldRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddOutgoingFieldRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["additionalFields"] = this.additionalFields ? this.additionalFields.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddOutgoingFieldRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    additionalFields?: AdditionalFieldsDTO;
}

export class UpdateOutgoingFieldReq implements IUpdateOutgoingFieldReq {
    additionalFields?: AdditionalFieldsDTO;

    constructor(data?: IUpdateOutgoingFieldReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalFields = _data["additionalFields"] ? AdditionalFieldsDTO.fromJS(_data["additionalFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateOutgoingFieldReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOutgoingFieldReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalFields"] = this.additionalFields ? this.additionalFields.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateOutgoingFieldReq {
    additionalFields?: AdditionalFieldsDTO;
}

export class UpdateOutgoingFieldRes implements IUpdateOutgoingFieldRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    additionalFields?: AdditionalFieldsDTO;

    constructor(data?: IUpdateOutgoingFieldRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.additionalFields = _data["additionalFields"] ? AdditionalFieldsDTO.fromJS(_data["additionalFields"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateOutgoingFieldRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOutgoingFieldRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["additionalFields"] = this.additionalFields ? this.additionalFields.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateOutgoingFieldRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    additionalFields?: AdditionalFieldsDTO;
}

export class PartnersReq implements IPartnersReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IPartnersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnersReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnersReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class PartnerDTO implements IPartnerDTO {
    id?: string | undefined;
    shortCode?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    businessCode?: string | undefined;
    parentPartnerId?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IPartnerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortCode = _data["shortCode"];
            this.title = _data["title"];
            this.identificationId = _data["identificationId"];
            this.addressRoomNumber = _data["addressRoomNumber"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressBuildingName = _data["addressBuildingName"];
            this.addressBuildingNumber = _data["addressBuildingNumber"];
            this.addressCitySubdivisionId = _data["addressCitySubdivisionId"];
            this.addressCitySubdivisionName = _data["addressCitySubdivisionName"];
            this.addressCityId = _data["addressCityId"];
            this.addressCityName = _data["addressCityName"];
            this.addressPostalZone = _data["addressPostalZone"];
            this.addressRegion = _data["addressRegion"];
            this.addressCountryId = _data["addressCountryId"];
            this.addressCountryName = _data["addressCountryName"];
            this.taxAdministrationName = _data["taxAdministrationName"];
            this.telephone = _data["telephone"];
            this.eMail = _data["eMail"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.registrationNumber = _data["registrationNumber"];
            this.mersisNumber = _data["mersisNumber"];
            this.businessCode = _data["businessCode"];
            this.parentPartnerId = _data["parentPartnerId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PartnerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortCode"] = this.shortCode;
        data["title"] = this.title;
        data["identificationId"] = this.identificationId;
        data["addressRoomNumber"] = this.addressRoomNumber;
        data["addressStreetName"] = this.addressStreetName;
        data["addressBuildingName"] = this.addressBuildingName;
        data["addressBuildingNumber"] = this.addressBuildingNumber;
        data["addressCitySubdivisionId"] = this.addressCitySubdivisionId;
        data["addressCitySubdivisionName"] = this.addressCitySubdivisionName;
        data["addressCityId"] = this.addressCityId;
        data["addressCityName"] = this.addressCityName;
        data["addressPostalZone"] = this.addressPostalZone;
        data["addressRegion"] = this.addressRegion;
        data["addressCountryId"] = this.addressCountryId;
        data["addressCountryName"] = this.addressCountryName;
        data["taxAdministrationName"] = this.taxAdministrationName;
        data["telephone"] = this.telephone;
        data["eMail"] = this.eMail;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["registrationNumber"] = this.registrationNumber;
        data["mersisNumber"] = this.mersisNumber;
        data["businessCode"] = this.businessCode;
        data["parentPartnerId"] = this.parentPartnerId;
        data["notes"] = this.notes;
        return data; 
    }
}

export interface IPartnerDTO {
    id?: string | undefined;
    shortCode?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    businessCode?: string | undefined;
    parentPartnerId?: string | undefined;
    notes?: string | undefined;
}

export class PartnersRes implements IPartnersRes {
    totalRecordCount?: number;
    listData?: PartnerDTO[] | undefined;

    constructor(data?: IPartnersRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(PartnerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnersRes {
        data = typeof data === 'object' ? data : {};
        let result = new PartnersRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnersRes {
    totalRecordCount?: number;
    listData?: PartnerDTO[] | undefined;
}

export class PartnerContactsDTO implements IPartnerContactsDTO {
    id?: number | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobilPhone?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPartnerContactsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.title = _data["title"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobilPhone = _data["mobilPhone"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PartnerContactsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContactsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["title"] = this.title;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobilPhone"] = this.mobilPhone;
        data["description"] = this.description;
        return data; 
    }
}

export interface IPartnerContactsDTO {
    id?: number | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    title?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobilPhone?: string | undefined;
    description?: string | undefined;
}

export class PartnerDetailDTO implements IPartnerDetailDTO {
    id?: string | undefined;
    shortCode?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    businessCode?: string | undefined;
    parentPartnerId?: string | undefined;
    notes?: string | undefined;
    contacts?: PartnerContactsDTO[] | undefined;

    constructor(data?: IPartnerDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortCode = _data["shortCode"];
            this.title = _data["title"];
            this.identificationId = _data["identificationId"];
            this.addressRoomNumber = _data["addressRoomNumber"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressBuildingName = _data["addressBuildingName"];
            this.addressBuildingNumber = _data["addressBuildingNumber"];
            this.addressCitySubdivisionId = _data["addressCitySubdivisionId"];
            this.addressCitySubdivisionName = _data["addressCitySubdivisionName"];
            this.addressCityId = _data["addressCityId"];
            this.addressCityName = _data["addressCityName"];
            this.addressPostalZone = _data["addressPostalZone"];
            this.addressRegion = _data["addressRegion"];
            this.addressCountryId = _data["addressCountryId"];
            this.addressCountryName = _data["addressCountryName"];
            this.taxAdministrationName = _data["taxAdministrationName"];
            this.telephone = _data["telephone"];
            this.eMail = _data["eMail"];
            this.fax = _data["fax"];
            this.website = _data["website"];
            this.registrationNumber = _data["registrationNumber"];
            this.mersisNumber = _data["mersisNumber"];
            this.businessCode = _data["businessCode"];
            this.parentPartnerId = _data["parentPartnerId"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(PartnerContactsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortCode"] = this.shortCode;
        data["title"] = this.title;
        data["identificationId"] = this.identificationId;
        data["addressRoomNumber"] = this.addressRoomNumber;
        data["addressStreetName"] = this.addressStreetName;
        data["addressBuildingName"] = this.addressBuildingName;
        data["addressBuildingNumber"] = this.addressBuildingNumber;
        data["addressCitySubdivisionId"] = this.addressCitySubdivisionId;
        data["addressCitySubdivisionName"] = this.addressCitySubdivisionName;
        data["addressCityId"] = this.addressCityId;
        data["addressCityName"] = this.addressCityName;
        data["addressPostalZone"] = this.addressPostalZone;
        data["addressRegion"] = this.addressRegion;
        data["addressCountryId"] = this.addressCountryId;
        data["addressCountryName"] = this.addressCountryName;
        data["taxAdministrationName"] = this.taxAdministrationName;
        data["telephone"] = this.telephone;
        data["eMail"] = this.eMail;
        data["fax"] = this.fax;
        data["website"] = this.website;
        data["registrationNumber"] = this.registrationNumber;
        data["mersisNumber"] = this.mersisNumber;
        data["businessCode"] = this.businessCode;
        data["parentPartnerId"] = this.parentPartnerId;
        data["notes"] = this.notes;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnerDetailDTO {
    id?: string | undefined;
    shortCode?: string | undefined;
    title?: string | undefined;
    identificationId?: string | undefined;
    addressRoomNumber?: number | undefined;
    addressStreetName?: string | undefined;
    addressBuildingName?: string | undefined;
    addressBuildingNumber?: string | undefined;
    addressCitySubdivisionId?: number | undefined;
    addressCitySubdivisionName?: string | undefined;
    addressCityId?: number | undefined;
    addressCityName?: string | undefined;
    addressPostalZone?: string | undefined;
    addressRegion?: string | undefined;
    addressCountryId?: number | undefined;
    addressCountryName?: string | undefined;
    taxAdministrationName?: string | undefined;
    telephone?: string | undefined;
    eMail?: string | undefined;
    fax?: string | undefined;
    website?: string | undefined;
    registrationNumber?: string | undefined;
    mersisNumber?: string | undefined;
    businessCode?: string | undefined;
    parentPartnerId?: string | undefined;
    notes?: string | undefined;
    contacts?: PartnerContactsDTO[] | undefined;
}

export class AddPartnerReq implements IAddPartnerReq {
    parentPartnerId?: string | undefined;
    partner?: PartnerDetailDTO;

    constructor(data?: IAddPartnerReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentPartnerId = _data["parentPartnerId"];
            this.partner = _data["partner"] ? PartnerDetailDTO.fromJS(_data["partner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentPartnerId"] = this.parentPartnerId;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPartnerReq {
    parentPartnerId?: string | undefined;
    partner?: PartnerDetailDTO;
}

export class AddPartnerRes implements IAddPartnerRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    partner?: PartnerDetailDTO;

    constructor(data?: IAddPartnerRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.partner = _data["partner"] ? PartnerDetailDTO.fromJS(_data["partner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPartnerRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    partner?: PartnerDetailDTO;
}

export class UpdatePartnerReq implements IUpdatePartnerReq {
    partner?: PartnerDetailDTO;

    constructor(data?: IUpdatePartnerReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"] ? PartnerDetailDTO.fromJS(_data["partner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePartnerReq {
    partner?: PartnerDetailDTO;
}

export class UpdatePartnerRes implements IUpdatePartnerRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    partner?: PartnerDetailDTO;

    constructor(data?: IUpdatePartnerRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.partner = _data["partner"] ? PartnerDetailDTO.fromJS(_data["partner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePartnerRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    partner?: PartnerDetailDTO;
}

export class PartnerSummaryInfoDTO implements IPartnerSummaryInfoDTO {
    id?: number;
    partnerId?: string | undefined;
    isMapping?: number;
    isPrefixManagement?: number;
    isXsltManagement?: number;
    dataSendMethod?: number;
    description?: string | undefined;

    constructor(data?: IPartnerSummaryInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerId = _data["partnerId"];
            this.isMapping = _data["isMapping"];
            this.isPrefixManagement = _data["isPrefixManagement"];
            this.isXsltManagement = _data["isXsltManagement"];
            this.dataSendMethod = _data["dataSendMethod"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PartnerSummaryInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerSummaryInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerId"] = this.partnerId;
        data["isMapping"] = this.isMapping;
        data["isPrefixManagement"] = this.isPrefixManagement;
        data["isXsltManagement"] = this.isXsltManagement;
        data["dataSendMethod"] = this.dataSendMethod;
        data["description"] = this.description;
        return data; 
    }
}

export interface IPartnerSummaryInfoDTO {
    id?: number;
    partnerId?: string | undefined;
    isMapping?: number;
    isPrefixManagement?: number;
    isXsltManagement?: number;
    dataSendMethod?: number;
    description?: string | undefined;
}

export class AddPartnerSummaryInfoReq implements IAddPartnerSummaryInfoReq {
    partnerId?: string | undefined;
    partnerSummaryInfo?: PartnerSummaryInfoDTO;

    constructor(data?: IAddPartnerSummaryInfoReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.partnerSummaryInfo = _data["partnerSummaryInfo"] ? PartnerSummaryInfoDTO.fromJS(_data["partnerSummaryInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerSummaryInfoReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerSummaryInfoReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["partnerSummaryInfo"] = this.partnerSummaryInfo ? this.partnerSummaryInfo.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPartnerSummaryInfoReq {
    partnerId?: string | undefined;
    partnerSummaryInfo?: PartnerSummaryInfoDTO;
}

export class UpdatePartnerSummaryInfoReq implements IUpdatePartnerSummaryInfoReq {
    partnerSummaryInfoDTO?: PartnerSummaryInfoDTO;

    constructor(data?: IUpdatePartnerSummaryInfoReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerSummaryInfoDTO = _data["partnerSummaryInfoDTO"] ? PartnerSummaryInfoDTO.fromJS(_data["partnerSummaryInfoDTO"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerSummaryInfoReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerSummaryInfoReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerSummaryInfoDTO"] = this.partnerSummaryInfoDTO ? this.partnerSummaryInfoDTO.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePartnerSummaryInfoReq {
    partnerSummaryInfoDTO?: PartnerSummaryInfoDTO;
}

export enum ArchiveStatusFilter {
    All = "All",
    Archived = "Archived",
    NotArchived = "NotArchived",
}

export class GetArchiveReportRequest implements IGetArchiveReportRequest {
    partnerId?: string | undefined;
    smmUser?: string | undefined;
    period?: number;
    archiveStatusFilter?: ArchiveStatusFilter;

    constructor(data?: IGetArchiveReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.smmUser = _data["smmUser"];
            this.period = _data["period"];
            this.archiveStatusFilter = _data["archiveStatusFilter"];
        }
    }

    static fromJS(data: any): GetArchiveReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetArchiveReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["smmUser"] = this.smmUser;
        data["period"] = this.period;
        data["archiveStatusFilter"] = this.archiveStatusFilter;
        return data; 
    }
}

export interface IGetArchiveReportRequest {
    partnerId?: string | undefined;
    smmUser?: string | undefined;
    period?: number;
    archiveStatusFilter?: ArchiveStatusFilter;
}

export class ArchiveReportItem implements IArchiveReportItem {
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    branchCode?: string | undefined;
    lastPeriod?: number | undefined;
    archiveStatusDescription?: string | undefined;
    archiveUploadTime?: Date | undefined;
    archiveConfirmTime?: Date | undefined;
    gibArchiveTime?: Date | undefined;

    constructor(data?: IArchiveReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerTitle = _data["customerTitle"];
            this.branchCode = _data["branchCode"];
            this.lastPeriod = _data["lastPeriod"];
            this.archiveStatusDescription = _data["archiveStatusDescription"];
            this.archiveUploadTime = _data["archiveUploadTime"] ? new Date(_data["archiveUploadTime"].toString()) : <any>undefined;
            this.archiveConfirmTime = _data["archiveConfirmTime"] ? new Date(_data["archiveConfirmTime"].toString()) : <any>undefined;
            this.gibArchiveTime = _data["gibArchiveTime"] ? new Date(_data["gibArchiveTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArchiveReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerTitle"] = this.customerTitle;
        data["branchCode"] = this.branchCode;
        data["lastPeriod"] = this.lastPeriod;
        data["archiveStatusDescription"] = this.archiveStatusDescription;
        data["archiveUploadTime"] = this.archiveUploadTime ? this.archiveUploadTime.toISOString() : <any>undefined;
        data["archiveConfirmTime"] = this.archiveConfirmTime ? this.archiveConfirmTime.toISOString() : <any>undefined;
        data["gibArchiveTime"] = this.gibArchiveTime ? this.gibArchiveTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IArchiveReportItem {
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    branchCode?: string | undefined;
    lastPeriod?: number | undefined;
    archiveStatusDescription?: string | undefined;
    archiveUploadTime?: Date | undefined;
    archiveConfirmTime?: Date | undefined;
    gibArchiveTime?: Date | undefined;
}

export class GetArchiveReportResults implements IGetArchiveReportResults {
    totalRecordCount?: number;
    listData?: ArchiveReportItem[] | undefined;
    isSuccess?: boolean;
    traceId?: string | undefined;
    statusDescription?: string | undefined;

    constructor(data?: IGetArchiveReportResults) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(ArchiveReportItem.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.traceId = _data["traceId"];
            this.statusDescription = _data["statusDescription"];
        }
    }

    static fromJS(data: any): GetArchiveReportResults {
        data = typeof data === 'object' ? data : {};
        let result = new GetArchiveReportResults();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        data["isSuccess"] = this.isSuccess;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        return data; 
    }
}

export interface IGetArchiveReportResults {
    totalRecordCount?: number;
    listData?: ArchiveReportItem[] | undefined;
    isSuccess?: boolean;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
}

export class AvaiablePartnerContourAgreementsReq implements IAvaiablePartnerContourAgreementsReq {
    partnerId?: string | undefined;
    filter?: string | undefined;

    constructor(data?: IAvaiablePartnerContourAgreementsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): AvaiablePartnerContourAgreementsReq {
        data = typeof data === 'object' ? data : {};
        let result = new AvaiablePartnerContourAgreementsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IAvaiablePartnerContourAgreementsReq {
    partnerId?: string | undefined;
    filter?: string | undefined;
}

export class AgreementsInfoDTO implements IAgreementsInfoDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    contourPackSize?: number | undefined;
    agreementType?: AgreementType;

    constructor(data?: IAgreementsInfoDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.contourPackSize = _data["contourPackSize"];
            this.agreementType = _data["agreementType"];
        }
    }

    static fromJS(data: any): AgreementsInfoDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementsInfoDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["contourPackSize"] = this.contourPackSize;
        data["agreementType"] = this.agreementType;
        return data; 
    }
}

export interface IAgreementsInfoDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    contourPackSize?: number | undefined;
    agreementType?: AgreementType;
}

export class PartnersForContourReq implements IPartnersForContourReq {
    filter?: string | undefined;

    constructor(data?: IPartnersForContourReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): PartnersForContourReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnersForContourReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IPartnersForContourReq {
    filter?: string | undefined;
}

export class PartnerContoursDocumentsReq implements IPartnerContoursDocumentsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IPartnerContoursDocumentsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerContoursDocumentsReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContoursDocumentsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnerContoursDocumentsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class PartnerContourDocumentDTO implements IPartnerContourDocumentDTO {
    id?: number;
    partnerAgreementId?: number | undefined;
    partnerAgreementCode?: string | undefined;
    partnerAgreementType?: AgreementType;
    partnerId?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    invoiceNo?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceAmount?: number | undefined;
    invoiceCurrency?: string | undefined;
    currencyRate?: number | undefined;
    documentType?: ContourDocumentType;
    contourCount?: number;
    documentDate?: Date;
    documentTime?: Date;
    description?: string | undefined;

    constructor(data?: IPartnerContourDocumentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerAgreementId = _data["partnerAgreementId"];
            this.partnerAgreementCode = _data["partnerAgreementCode"];
            this.partnerAgreementType = _data["partnerAgreementType"];
            this.partnerId = _data["partnerId"];
            this.partnerShortCode = _data["partnerShortCode"];
            this.partnerTitle = _data["partnerTitle"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : <any>undefined;
            this.invoiceAmount = _data["invoiceAmount"];
            this.invoiceCurrency = _data["invoiceCurrency"];
            this.currencyRate = _data["currencyRate"];
            this.documentType = _data["documentType"];
            this.contourCount = _data["contourCount"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : <any>undefined;
            this.documentTime = _data["documentTime"] ? new Date(_data["documentTime"].toString()) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PartnerContourDocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContourDocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerAgreementId"] = this.partnerAgreementId;
        data["partnerAgreementCode"] = this.partnerAgreementCode;
        data["partnerAgreementType"] = this.partnerAgreementType;
        data["partnerId"] = this.partnerId;
        data["partnerShortCode"] = this.partnerShortCode;
        data["partnerTitle"] = this.partnerTitle;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["invoiceAmount"] = this.invoiceAmount;
        data["invoiceCurrency"] = this.invoiceCurrency;
        data["currencyRate"] = this.currencyRate;
        data["documentType"] = this.documentType;
        data["contourCount"] = this.contourCount;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : <any>undefined;
        data["documentTime"] = this.documentTime ? this.documentTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        return data; 
    }
}

export interface IPartnerContourDocumentDTO {
    id?: number;
    partnerAgreementId?: number | undefined;
    partnerAgreementCode?: string | undefined;
    partnerAgreementType?: AgreementType;
    partnerId?: string | undefined;
    partnerShortCode?: string | undefined;
    partnerTitle?: string | undefined;
    invoiceNo?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceAmount?: number | undefined;
    invoiceCurrency?: string | undefined;
    currencyRate?: number | undefined;
    documentType?: ContourDocumentType;
    contourCount?: number;
    documentDate?: Date;
    documentTime?: Date;
    description?: string | undefined;
}

export class PartnerContoursDocumentsRes implements IPartnerContoursDocumentsRes {
    totalRecordCount?: number;
    listData?: PartnerContourDocumentDTO[] | undefined;

    constructor(data?: IPartnerContoursDocumentsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(PartnerContourDocumentDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerContoursDocumentsRes {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContoursDocumentsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnerContoursDocumentsRes {
    totalRecordCount?: number;
    listData?: PartnerContourDocumentDTO[] | undefined;
}

export class AddPartnerContourDocumentReq implements IAddPartnerContourDocumentReq {
    document?: PartnerContourDocumentDTO;

    constructor(data?: IAddPartnerContourDocumentReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? PartnerContourDocumentDTO.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerContourDocumentReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerContourDocumentReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPartnerContourDocumentReq {
    document?: PartnerContourDocumentDTO;
}

export class AddPartnerContourDocumentRes implements IAddPartnerContourDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    document?: PartnerContourDocumentDTO;

    constructor(data?: IAddPartnerContourDocumentRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.document = _data["document"] ? PartnerContourDocumentDTO.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerContourDocumentRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerContourDocumentRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddPartnerContourDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    document?: PartnerContourDocumentDTO;
}

export class UpdatePartnerContourDocumentReq implements IUpdatePartnerContourDocumentReq {
    document?: PartnerContourDocumentDTO;

    constructor(data?: IUpdatePartnerContourDocumentReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.document = _data["document"] ? PartnerContourDocumentDTO.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerContourDocumentReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerContourDocumentReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePartnerContourDocumentReq {
    document?: PartnerContourDocumentDTO;
}

export class UpdatePartnerContourDocumentRes implements IUpdatePartnerContourDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    document?: PartnerContourDocumentDTO;

    constructor(data?: IUpdatePartnerContourDocumentRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.document = _data["document"] ? PartnerContourDocumentDTO.fromJS(_data["document"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerContourDocumentRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerContourDocumentRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdatePartnerContourDocumentRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    document?: PartnerContourDocumentDTO;
}

export class PartnerRouteTenantsPartnerInfo implements IPartnerRouteTenantsPartnerInfo {
    id?: string | undefined;
    identificationId?: string | undefined;
    title?: string | undefined;

    constructor(data?: IPartnerRouteTenantsPartnerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identificationId = _data["identificationId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PartnerRouteTenantsPartnerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRouteTenantsPartnerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identificationId"] = this.identificationId;
        data["title"] = this.title;
        return data; 
    }
}

export interface IPartnerRouteTenantsPartnerInfo {
    id?: string | undefined;
    identificationId?: string | undefined;
    title?: string | undefined;
}

export class PartnerRouteTenantsPartnersRes implements IPartnerRouteTenantsPartnersRes {
    partners?: PartnerRouteTenantsPartnerInfo[] | undefined;

    constructor(data?: IPartnerRouteTenantsPartnersRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerRouteTenantsPartnerInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerRouteTenantsPartnersRes {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRouteTenantsPartnersRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnerRouteTenantsPartnersRes {
    partners?: PartnerRouteTenantsPartnerInfo[] | undefined;
}

export class PartnerRouteTenantsDTO implements IPartnerRouteTenantsDTO {
    id?: number;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    serviceId?: number;
    serviceCode?: string | undefined;
    routeTenantId?: number;
    routeTenantCode?: string | undefined;

    constructor(data?: IPartnerRouteTenantsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerId = _data["partnerId"];
            this.partnerTitle = _data["partnerTitle"];
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.routeTenantId = _data["routeTenantId"];
            this.routeTenantCode = _data["routeTenantCode"];
        }
    }

    static fromJS(data: any): PartnerRouteTenantsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRouteTenantsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerId"] = this.partnerId;
        data["partnerTitle"] = this.partnerTitle;
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["routeTenantId"] = this.routeTenantId;
        data["routeTenantCode"] = this.routeTenantCode;
        return data; 
    }
}

export interface IPartnerRouteTenantsDTO {
    id?: number;
    partnerId?: string | undefined;
    partnerTitle?: string | undefined;
    serviceId?: number;
    serviceCode?: string | undefined;
    routeTenantId?: number;
    routeTenantCode?: string | undefined;
}

export class PartnerRouteTenantsRes implements IPartnerRouteTenantsRes {
    partnerRouteTenants?: PartnerRouteTenantsDTO[] | undefined;

    constructor(data?: IPartnerRouteTenantsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partnerRouteTenants"])) {
                this.partnerRouteTenants = [] as any;
                for (let item of _data["partnerRouteTenants"])
                    this.partnerRouteTenants!.push(PartnerRouteTenantsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartnerRouteTenantsRes {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRouteTenantsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partnerRouteTenants)) {
            data["partnerRouteTenants"] = [];
            for (let item of this.partnerRouteTenants)
                data["partnerRouteTenants"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPartnerRouteTenantsRes {
    partnerRouteTenants?: PartnerRouteTenantsDTO[] | undefined;
}

export class PartnerRouteTenantReq implements IPartnerRouteTenantReq {
    partnerRouteTenant?: PartnerRouteTenantsDTO;

    constructor(data?: IPartnerRouteTenantReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerRouteTenant = _data["partnerRouteTenant"] ? PartnerRouteTenantsDTO.fromJS(_data["partnerRouteTenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PartnerRouteTenantReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRouteTenantReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerRouteTenant"] = this.partnerRouteTenant ? this.partnerRouteTenant.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPartnerRouteTenantReq {
    partnerRouteTenant?: PartnerRouteTenantsDTO;
}

export class PartnerRouteTenantRes implements IPartnerRouteTenantRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    partnerRouteTenant?: PartnerRouteTenantsDTO;

    constructor(data?: IPartnerRouteTenantRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.partnerRouteTenant = _data["partnerRouteTenant"] ? PartnerRouteTenantsDTO.fromJS(_data["partnerRouteTenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PartnerRouteTenantRes {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerRouteTenantRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["partnerRouteTenant"] = this.partnerRouteTenant ? this.partnerRouteTenant.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPartnerRouteTenantRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    partnerRouteTenant?: PartnerRouteTenantsDTO;
}

export class UsersReq implements IUsersReq {
    identityId?: string | undefined;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IUsersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityId = _data["identityId"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsersReq {
        data = typeof data === 'object' ? data : {};
        let result = new UsersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUsersReq {
    identityId?: string | undefined;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export enum UserStatus {
    Active = "Active",
    Blocked = "Blocked",
    Deleted = "Deleted",
    Expired = "Expired",
    Disabled = "Disabled",
}

export enum UserType {
    ServiceUser = "ServiceUser",
    PortalUser = "PortalUser",
    BackgroundServiceUser = "BackgroundServiceUser",
}

export class UserDTO implements IUserDTO {
    id?: number;
    eMail?: string | undefined;
    userLevel?: number;
    name?: string | undefined;
    surname?: string | undefined;
    userStatus?: UserStatus;
    mobilePhone?: string | undefined;
    userType?: UserType;

    constructor(data?: IUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eMail = _data["eMail"];
            this.userLevel = _data["userLevel"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userStatus = _data["userStatus"];
            this.mobilePhone = _data["mobilePhone"];
            this.userType = _data["userType"];
        }
    }

    static fromJS(data: any): UserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eMail"] = this.eMail;
        data["userLevel"] = this.userLevel;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userStatus"] = this.userStatus;
        data["mobilePhone"] = this.mobilePhone;
        data["userType"] = this.userType;
        return data; 
    }
}

export interface IUserDTO {
    id?: number;
    eMail?: string | undefined;
    userLevel?: number;
    name?: string | undefined;
    surname?: string | undefined;
    userStatus?: UserStatus;
    mobilePhone?: string | undefined;
    userType?: UserType;
}

export class UsersRes implements IUsersRes {
    users?: UserDTO[] | undefined;

    constructor(data?: IUsersRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsersRes {
        data = typeof data === 'object' ? data : {};
        let result = new UsersRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUsersRes {
    users?: UserDTO[] | undefined;
}

export class CustomerUserListReq implements ICustomerUserListReq {
    customerId?: string | undefined;

    constructor(data?: ICustomerUserListReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): CustomerUserListReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserListReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface ICustomerUserListReq {
    customerId?: string | undefined;
}

export class CustomerUserListRes implements ICustomerUserListRes {
    users?: UserDTO[] | undefined;

    constructor(data?: ICustomerUserListRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerUserListRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerUserListRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerUserListRes {
    users?: UserDTO[] | undefined;
}

export class UserRoleInfo implements IUserRoleInfo {
    roleId?: number;
    code?: string | undefined;
    description?: string | undefined;
    customerId?: string | undefined;
    partnerId?: string | undefined;
    customerTitle?: string | undefined;
    partnerTitle?: string | undefined;

    constructor(data?: IUserRoleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.customerId = _data["customerId"];
            this.partnerId = _data["partnerId"];
            this.customerTitle = _data["customerTitle"];
            this.partnerTitle = _data["partnerTitle"];
        }
    }

    static fromJS(data: any): UserRoleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["customerId"] = this.customerId;
        data["partnerId"] = this.partnerId;
        data["customerTitle"] = this.customerTitle;
        data["partnerTitle"] = this.partnerTitle;
        return data; 
    }
}

export interface IUserRoleInfo {
    roleId?: number;
    code?: string | undefined;
    description?: string | undefined;
    customerId?: string | undefined;
    partnerId?: string | undefined;
    customerTitle?: string | undefined;
    partnerTitle?: string | undefined;
}

export class UserDetailDTO implements IUserDetailDTO {
    id?: number;
    eMail?: string | undefined;
    userLevel?: number;
    name?: string | undefined;
    surname?: string | undefined;
    userStatus?: UserStatus;
    mobilePhone?: string | undefined;
    userType?: UserType;
    password?: string | undefined;
    partners?: UserPartnerOrCustomerInfo[] | undefined;
    customers?: UserPartnerOrCustomerInfo[] | undefined;
    roles?: UserRoleInfo[] | undefined;

    constructor(data?: IUserDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eMail = _data["eMail"];
            this.userLevel = _data["userLevel"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userStatus = _data["userStatus"];
            this.mobilePhone = _data["mobilePhone"];
            this.userType = _data["userType"];
            this.password = _data["password"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(UserPartnerOrCustomerInfo.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eMail"] = this.eMail;
        data["userLevel"] = this.userLevel;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userStatus"] = this.userStatus;
        data["mobilePhone"] = this.mobilePhone;
        data["userType"] = this.userType;
        data["password"] = this.password;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IUserDetailDTO {
    id?: number;
    eMail?: string | undefined;
    userLevel?: number;
    name?: string | undefined;
    surname?: string | undefined;
    userStatus?: UserStatus;
    mobilePhone?: string | undefined;
    userType?: UserType;
    password?: string | undefined;
    partners?: UserPartnerOrCustomerInfo[] | undefined;
    customers?: UserPartnerOrCustomerInfo[] | undefined;
    roles?: UserRoleInfo[] | undefined;
}

export class AddUserReq implements IAddUserReq {
    creatorPartnerId?: string | undefined;
    user?: UserDetailDTO;

    constructor(data?: IAddUserReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creatorPartnerId = _data["creatorPartnerId"];
            this.user = _data["user"] ? UserDetailDTO.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddUserReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorPartnerId"] = this.creatorPartnerId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddUserReq {
    creatorPartnerId?: string | undefined;
    user?: UserDetailDTO;
}

export class AddUserRes implements IAddUserRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    user?: UserDetailDTO;

    constructor(data?: IAddUserRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.user = _data["user"] ? UserDetailDTO.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddUserRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddUserRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    user?: UserDetailDTO;
}

export class UpdateUserReq implements IUpdateUserReq {
    user?: UserDetailDTO;

    constructor(data?: IUpdateUserReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDetailDTO.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUserReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateUserReq {
    user?: UserDetailDTO;
}

export class UpdateUserRes implements IUpdateUserRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    user?: UserDetailDTO;

    constructor(data?: IUpdateUserRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.user = _data["user"] ? UserDetailDTO.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUserRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateUserRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    user?: UserDetailDTO;
}

export class PartnerUserRolesReq implements IPartnerUserRolesReq {
    filter?: string | undefined;

    constructor(data?: IPartnerUserRolesReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): PartnerUserRolesReq {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerUserRolesReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IPartnerUserRolesReq {
    filter?: string | undefined;
}

export class AddOperatorPermissionReq implements IAddOperatorPermissionReq {
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    userGivingPermissionId?: number;
    operatorPermissionId?: number;
    description?: string | undefined;
    leaveTime?: string | undefined;

    constructor(data?: IAddOperatorPermissionReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.customerTitle = _data["customerTitle"];
            this.userGivingPermissionId = _data["userGivingPermissionId"];
            this.operatorPermissionId = _data["operatorPermissionId"];
            this.description = _data["description"];
            this.leaveTime = _data["leaveTime"];
        }
    }

    static fromJS(data: any): AddOperatorPermissionReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddOperatorPermissionReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["customerTitle"] = this.customerTitle;
        data["userGivingPermissionId"] = this.userGivingPermissionId;
        data["operatorPermissionId"] = this.operatorPermissionId;
        data["description"] = this.description;
        data["leaveTime"] = this.leaveTime;
        return data; 
    }
}

export interface IAddOperatorPermissionReq {
    customerId?: string | undefined;
    customerTitle?: string | undefined;
    userGivingPermissionId?: number;
    operatorPermissionId?: number;
    description?: string | undefined;
    leaveTime?: string | undefined;
}

export class RolesReq implements IRolesReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IRolesReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolesReq {
        data = typeof data === 'object' ? data : {};
        let result = new RolesReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRolesReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class RoleDTO implements IRoleDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IRoleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IRoleDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
}

export class RolesRes implements IRolesRes {
    totalRecordCount?: number;
    listData?: RoleDTO[] | undefined;

    constructor(data?: IRolesRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(RoleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolesRes {
        data = typeof data === 'object' ? data : {};
        let result = new RolesRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRolesRes {
    totalRecordCount?: number;
    listData?: RoleDTO[] | undefined;
}

export class RoleRightDTO implements IRoleRightDTO {
    rightsId?: number;
    rightsCode?: string | undefined;
    checked?: boolean;
    rightsDescription?: string | undefined;
    serviceId?: number | undefined;
    serviceCode?: string | undefined;
    rightsGroupId?: number | undefined;
    rightsGroupName?: string | undefined;
    avaiableLicenses?: string | undefined;
    superAdminLevel?: number;
    useabilityLevel?: string | undefined;

    constructor(data?: IRoleRightDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rightsId = _data["rightsId"];
            this.rightsCode = _data["rightsCode"];
            this.checked = _data["checked"];
            this.rightsDescription = _data["rightsDescription"];
            this.serviceId = _data["serviceId"];
            this.serviceCode = _data["serviceCode"];
            this.rightsGroupId = _data["rightsGroupId"];
            this.rightsGroupName = _data["rightsGroupName"];
            this.avaiableLicenses = _data["avaiableLicenses"];
            this.superAdminLevel = _data["superAdminLevel"];
            this.useabilityLevel = _data["useabilityLevel"];
        }
    }

    static fromJS(data: any): RoleRightDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleRightDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rightsId"] = this.rightsId;
        data["rightsCode"] = this.rightsCode;
        data["checked"] = this.checked;
        data["rightsDescription"] = this.rightsDescription;
        data["serviceId"] = this.serviceId;
        data["serviceCode"] = this.serviceCode;
        data["rightsGroupId"] = this.rightsGroupId;
        data["rightsGroupName"] = this.rightsGroupName;
        data["avaiableLicenses"] = this.avaiableLicenses;
        data["superAdminLevel"] = this.superAdminLevel;
        data["useabilityLevel"] = this.useabilityLevel;
        return data; 
    }
}

export interface IRoleRightDTO {
    rightsId?: number;
    rightsCode?: string | undefined;
    checked?: boolean;
    rightsDescription?: string | undefined;
    serviceId?: number | undefined;
    serviceCode?: string | undefined;
    rightsGroupId?: number | undefined;
    rightsGroupName?: string | undefined;
    avaiableLicenses?: string | undefined;
    superAdminLevel?: number;
    useabilityLevel?: string | undefined;
}

export class RoleDetailDTO implements IRoleDetailDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    roleRights?: RoleRightDTO[] | undefined;

    constructor(data?: IRoleDetailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            if (Array.isArray(_data["roleRights"])) {
                this.roleRights = [] as any;
                for (let item of _data["roleRights"])
                    this.roleRights!.push(RoleRightDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDetailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDetailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        if (Array.isArray(this.roleRights)) {
            data["roleRights"] = [];
            for (let item of this.roleRights)
                data["roleRights"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRoleDetailDTO {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    roleRights?: RoleRightDTO[] | undefined;
}

export class AddRoleReq implements IAddRoleReq {
    role?: RoleDetailDTO;

    constructor(data?: IAddRoleReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleDetailDTO.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddRoleReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddRoleReq {
    role?: RoleDetailDTO;
}

export class AddRoleRes implements IAddRoleRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    role?: RoleDetailDTO;

    constructor(data?: IAddRoleRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.role = _data["role"] ? RoleDetailDTO.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddRoleRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddRoleRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    role?: RoleDetailDTO;
}

export class UpdateRoleReq implements IUpdateRoleReq {
    role?: RoleDetailDTO;

    constructor(data?: IUpdateRoleReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleDetailDTO.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateRoleReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateRoleReq {
    role?: RoleDetailDTO;
}

export class UpdateRoleRes implements IUpdateRoleRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    role?: RoleDetailDTO;

    constructor(data?: IUpdateRoleRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.role = _data["role"] ? RoleDetailDTO.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateRoleRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateRoleRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    role?: RoleDetailDTO;
}

export class RuleCustomersReq implements IRuleCustomersReq {
    filter?: string | undefined;

    constructor(data?: IRuleCustomersReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): RuleCustomersReq {
        data = typeof data === 'object' ? data : {};
        let result = new RuleCustomersReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        return data; 
    }
}

export interface IRuleCustomersReq {
    filter?: string | undefined;
}

export class RuleCustomerInfo implements IRuleCustomerInfo {
    identityId?: string | undefined;
    title?: string | undefined;

    constructor(data?: IRuleCustomerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityId = _data["identityId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): RuleCustomerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RuleCustomerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId;
        data["title"] = this.title;
        return data; 
    }
}

export interface IRuleCustomerInfo {
    identityId?: string | undefined;
    title?: string | undefined;
}

export enum RuleConditionType {
    RequestField = "RequestField",
    EntityField = "EntityField",
    XPath = "XPath",
}

export class RuleDefinitionConditionDTO implements IRuleDefinitionConditionDTO {
    id?: number;
    conditionType?: RuleConditionType;
    conditionExpression?: string | undefined;

    constructor(data?: IRuleDefinitionConditionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conditionType = _data["conditionType"];
            this.conditionExpression = _data["conditionExpression"];
        }
    }

    static fromJS(data: any): RuleDefinitionConditionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionConditionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conditionType"] = this.conditionType;
        data["conditionExpression"] = this.conditionExpression;
        return data; 
    }
}

export interface IRuleDefinitionConditionDTO {
    id?: number;
    conditionType?: RuleConditionType;
    conditionExpression?: string | undefined;
}

export class RuleDefinitionParameterDTO implements IRuleDefinitionParameterDTO {
    ruleDefinitionParametersId?: number;
    parameterName?: string | undefined;
    parameterDescription?: string | undefined;
    required?: boolean;
    valueList?: string | undefined;

    constructor(data?: IRuleDefinitionParameterDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleDefinitionParametersId = _data["ruleDefinitionParametersId"];
            this.parameterName = _data["parameterName"];
            this.parameterDescription = _data["parameterDescription"];
            this.required = _data["required"];
            this.valueList = _data["valueList"];
        }
    }

    static fromJS(data: any): RuleDefinitionParameterDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionParameterDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleDefinitionParametersId"] = this.ruleDefinitionParametersId;
        data["parameterName"] = this.parameterName;
        data["parameterDescription"] = this.parameterDescription;
        data["required"] = this.required;
        data["valueList"] = this.valueList;
        return data; 
    }
}

export interface IRuleDefinitionParameterDTO {
    ruleDefinitionParametersId?: number;
    parameterName?: string | undefined;
    parameterDescription?: string | undefined;
    required?: boolean;
    valueList?: string | undefined;
}

export class RuleDefinitionsReq implements IRuleDefinitionsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: IRuleDefinitionsReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RuleDefinitionsReq {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionsReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRuleDefinitionsReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class RuleDefinitionDTO implements IRuleDefinitionDTO {
    id?: number;
    isActive?: boolean;
    description?: string | undefined;
    ruleTypeName?: string | undefined;
    priority?: number;
    breakWhenErrors?: boolean;

    constructor(data?: IRuleDefinitionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.description = _data["description"];
            this.ruleTypeName = _data["ruleTypeName"];
            this.priority = _data["priority"];
            this.breakWhenErrors = _data["breakWhenErrors"];
        }
    }

    static fromJS(data: any): RuleDefinitionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["ruleTypeName"] = this.ruleTypeName;
        data["priority"] = this.priority;
        data["breakWhenErrors"] = this.breakWhenErrors;
        return data; 
    }
}

export interface IRuleDefinitionDTO {
    id?: number;
    isActive?: boolean;
    description?: string | undefined;
    ruleTypeName?: string | undefined;
    priority?: number;
    breakWhenErrors?: boolean;
}

export class RuleDefinitionsRes implements IRuleDefinitionsRes {
    totalRecordCount?: number;
    listData?: RuleDefinitionDTO[] | undefined;

    constructor(data?: IRuleDefinitionsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(RuleDefinitionDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RuleDefinitionsRes {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRuleDefinitionsRes {
    totalRecordCount?: number;
    listData?: RuleDefinitionDTO[] | undefined;
}

export class RuleDefinitionLicenseDTO implements IRuleDefinitionLicenseDTO {
    isActive?: boolean;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IRuleDefinitionLicenseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RuleDefinitionLicenseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionLicenseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }
}

export interface IRuleDefinitionLicenseDTO {
    isActive?: boolean;
    code?: string | undefined;
    description?: string | undefined;
}

export class RuleDefinitionDetailsDTO implements IRuleDefinitionDetailsDTO {
    id?: number;
    isActive?: boolean;
    description?: string | undefined;
    ruleTypeName?: string | undefined;
    priority?: number;
    breakWhenErrors?: boolean;
    ruleDefinitionConditions?: RuleDefinitionConditionDTO[] | undefined;
    ruleDefinitionLicenses?: RuleDefinitionLicenseDTO[] | undefined;

    constructor(data?: IRuleDefinitionDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.description = _data["description"];
            this.ruleTypeName = _data["ruleTypeName"];
            this.priority = _data["priority"];
            this.breakWhenErrors = _data["breakWhenErrors"];
            if (Array.isArray(_data["ruleDefinitionConditions"])) {
                this.ruleDefinitionConditions = [] as any;
                for (let item of _data["ruleDefinitionConditions"])
                    this.ruleDefinitionConditions!.push(RuleDefinitionConditionDTO.fromJS(item));
            }
            if (Array.isArray(_data["ruleDefinitionLicenses"])) {
                this.ruleDefinitionLicenses = [] as any;
                for (let item of _data["ruleDefinitionLicenses"])
                    this.ruleDefinitionLicenses!.push(RuleDefinitionLicenseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RuleDefinitionDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RuleDefinitionDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["ruleTypeName"] = this.ruleTypeName;
        data["priority"] = this.priority;
        data["breakWhenErrors"] = this.breakWhenErrors;
        if (Array.isArray(this.ruleDefinitionConditions)) {
            data["ruleDefinitionConditions"] = [];
            for (let item of this.ruleDefinitionConditions)
                data["ruleDefinitionConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.ruleDefinitionLicenses)) {
            data["ruleDefinitionLicenses"] = [];
            for (let item of this.ruleDefinitionLicenses)
                data["ruleDefinitionLicenses"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IRuleDefinitionDetailsDTO {
    id?: number;
    isActive?: boolean;
    description?: string | undefined;
    ruleTypeName?: string | undefined;
    priority?: number;
    breakWhenErrors?: boolean;
    ruleDefinitionConditions?: RuleDefinitionConditionDTO[] | undefined;
    ruleDefinitionLicenses?: RuleDefinitionLicenseDTO[] | undefined;
}

export class UpdateRuleDefinitionReq implements IUpdateRuleDefinitionReq {
    ruleDefinition?: RuleDefinitionDetailsDTO;

    constructor(data?: IUpdateRuleDefinitionReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ruleDefinition = _data["ruleDefinition"] ? RuleDefinitionDetailsDTO.fromJS(_data["ruleDefinition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateRuleDefinitionReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRuleDefinitionReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ruleDefinition"] = this.ruleDefinition ? this.ruleDefinition.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateRuleDefinitionReq {
    ruleDefinition?: RuleDefinitionDetailsDTO;
}

export class UpdateRuleDefinitionRes implements IUpdateRuleDefinitionRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    ruleDefinition?: RuleDefinitionDetailsDTO;

    constructor(data?: IUpdateRuleDefinitionRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.ruleDefinition = _data["ruleDefinition"] ? RuleDefinitionDetailsDTO.fromJS(_data["ruleDefinition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateRuleDefinitionRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRuleDefinitionRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["ruleDefinition"] = this.ruleDefinition ? this.ruleDefinition.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateRuleDefinitionRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    ruleDefinition?: RuleDefinitionDetailsDTO;
}

export class CustomerRulesReq implements ICustomerRulesReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;

    constructor(data?: ICustomerRulesReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.maxRecordCount = _data["maxRecordCount"];
            if (Array.isArray(_data["sortFields"])) {
                this.sortFields = [] as any;
                for (let item of _data["sortFields"])
                    this.sortFields!.push(item);
            }
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(RequestFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerRulesReq {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRulesReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["maxRecordCount"] = this.maxRecordCount;
        if (Array.isArray(this.sortFields)) {
            data["sortFields"] = [];
            for (let item of this.sortFields)
                data["sortFields"].push(item);
        }
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerRulesReq {
    page?: number;
    maxRecordCount?: number;
    sortFields?: string[] | undefined;
    filters?: RequestFilter[] | undefined;
}

export class CustomerRuleDTO implements ICustomerRuleDTO {
    id?: number;
    isActive?: boolean;
    customerId?: string | undefined;
    ruleDefinitionId?: number;
    customerTitle?: string | undefined;
    ruleDefinitionIsActive?: boolean;
    ruleTypeName?: string | undefined;
    ruleDefinitionDescription?: string | undefined;
    ruleDefinitionPriority?: number;

    constructor(data?: ICustomerRuleDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.customerId = _data["customerId"];
            this.ruleDefinitionId = _data["ruleDefinitionId"];
            this.customerTitle = _data["customerTitle"];
            this.ruleDefinitionIsActive = _data["ruleDefinitionIsActive"];
            this.ruleTypeName = _data["ruleTypeName"];
            this.ruleDefinitionDescription = _data["ruleDefinitionDescription"];
            this.ruleDefinitionPriority = _data["ruleDefinitionPriority"];
        }
    }

    static fromJS(data: any): CustomerRuleDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRuleDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["customerId"] = this.customerId;
        data["ruleDefinitionId"] = this.ruleDefinitionId;
        data["customerTitle"] = this.customerTitle;
        data["ruleDefinitionIsActive"] = this.ruleDefinitionIsActive;
        data["ruleTypeName"] = this.ruleTypeName;
        data["ruleDefinitionDescription"] = this.ruleDefinitionDescription;
        data["ruleDefinitionPriority"] = this.ruleDefinitionPriority;
        return data; 
    }
}

export interface ICustomerRuleDTO {
    id?: number;
    isActive?: boolean;
    customerId?: string | undefined;
    ruleDefinitionId?: number;
    customerTitle?: string | undefined;
    ruleDefinitionIsActive?: boolean;
    ruleTypeName?: string | undefined;
    ruleDefinitionDescription?: string | undefined;
    ruleDefinitionPriority?: number;
}

export class CustomerRulesRes implements ICustomerRulesRes {
    totalRecordCount?: number;
    listData?: CustomerRuleDTO[] | undefined;

    constructor(data?: ICustomerRulesRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecordCount = _data["totalRecordCount"];
            if (Array.isArray(_data["listData"])) {
                this.listData = [] as any;
                for (let item of _data["listData"])
                    this.listData!.push(CustomerRuleDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerRulesRes {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRulesRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecordCount"] = this.totalRecordCount;
        if (Array.isArray(this.listData)) {
            data["listData"] = [];
            for (let item of this.listData)
                data["listData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerRulesRes {
    totalRecordCount?: number;
    listData?: CustomerRuleDTO[] | undefined;
}

export enum RuleComparisonType {
    IsNullOrEmpty = "IsNullOrEmpty",
    IsNotNullOrEmpty = "IsNotNullOrEmpty",
    Equal = "Equal",
    NotEqual = "NotEqual",
    Contains = "Contains",
    StartsWith = "StartsWith",
    EndsWith = "EndsWith",
    In = "In",
}

export class CustomerRuleConditionsDTO implements ICustomerRuleConditionsDTO {
    id?: number;
    ruleDefinitionConditionsId?: number;
    conditionType?: RuleConditionType;
    conditionExpression?: string | undefined;
    andGroupIndex?: number;
    comparisonType?: RuleComparisonType;
    value?: string | undefined;

    constructor(data?: ICustomerRuleConditionsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ruleDefinitionConditionsId = _data["ruleDefinitionConditionsId"];
            this.conditionType = _data["conditionType"];
            this.conditionExpression = _data["conditionExpression"];
            this.andGroupIndex = _data["andGroupIndex"];
            this.comparisonType = _data["comparisonType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomerRuleConditionsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRuleConditionsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ruleDefinitionConditionsId"] = this.ruleDefinitionConditionsId;
        data["conditionType"] = this.conditionType;
        data["conditionExpression"] = this.conditionExpression;
        data["andGroupIndex"] = this.andGroupIndex;
        data["comparisonType"] = this.comparisonType;
        data["value"] = this.value;
        return data; 
    }
}

export interface ICustomerRuleConditionsDTO {
    id?: number;
    ruleDefinitionConditionsId?: number;
    conditionType?: RuleConditionType;
    conditionExpression?: string | undefined;
    andGroupIndex?: number;
    comparisonType?: RuleComparisonType;
    value?: string | undefined;
}

export enum RuleParameterType {
    Constant = "Constant",
    CustomerFields = "CustomerFields",
    EntityField = "EntityField",
    RequestField = "RequestField",
    XPath = "XPath",
}

export class CustomerRuleParametersDTO implements ICustomerRuleParametersDTO {
    id?: number;
    ruleDefinitionParametersId?: number;
    parameterName?: string | undefined;
    parameterDescription?: string | undefined;
    required?: boolean;
    valueList?: string | undefined;
    parameterType?: RuleParameterType;
    parameterValueSource?: string | undefined;

    constructor(data?: ICustomerRuleParametersDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ruleDefinitionParametersId = _data["ruleDefinitionParametersId"];
            this.parameterName = _data["parameterName"];
            this.parameterDescription = _data["parameterDescription"];
            this.required = _data["required"];
            this.valueList = _data["valueList"];
            this.parameterType = _data["parameterType"];
            this.parameterValueSource = _data["parameterValueSource"];
        }
    }

    static fromJS(data: any): CustomerRuleParametersDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRuleParametersDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ruleDefinitionParametersId"] = this.ruleDefinitionParametersId;
        data["parameterName"] = this.parameterName;
        data["parameterDescription"] = this.parameterDescription;
        data["required"] = this.required;
        data["valueList"] = this.valueList;
        data["parameterType"] = this.parameterType;
        data["parameterValueSource"] = this.parameterValueSource;
        return data; 
    }
}

export interface ICustomerRuleParametersDTO {
    id?: number;
    ruleDefinitionParametersId?: number;
    parameterName?: string | undefined;
    parameterDescription?: string | undefined;
    required?: boolean;
    valueList?: string | undefined;
    parameterType?: RuleParameterType;
    parameterValueSource?: string | undefined;
}

export class CustomerRuleDetailsDTO implements ICustomerRuleDetailsDTO {
    id?: number;
    isActive?: boolean;
    customerId?: string | undefined;
    ruleDefinitionId?: number;
    customerTitle?: string | undefined;
    ruleDefinitionIsActive?: boolean;
    ruleTypeName?: string | undefined;
    ruleDefinitionDescription?: string | undefined;
    ruleDefinitionPriority?: number;
    ruleConditions?: CustomerRuleConditionsDTO[] | undefined;
    ruleParameters?: CustomerRuleParametersDTO[] | undefined;

    constructor(data?: ICustomerRuleDetailsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.customerId = _data["customerId"];
            this.ruleDefinitionId = _data["ruleDefinitionId"];
            this.customerTitle = _data["customerTitle"];
            this.ruleDefinitionIsActive = _data["ruleDefinitionIsActive"];
            this.ruleTypeName = _data["ruleTypeName"];
            this.ruleDefinitionDescription = _data["ruleDefinitionDescription"];
            this.ruleDefinitionPriority = _data["ruleDefinitionPriority"];
            if (Array.isArray(_data["ruleConditions"])) {
                this.ruleConditions = [] as any;
                for (let item of _data["ruleConditions"])
                    this.ruleConditions!.push(CustomerRuleConditionsDTO.fromJS(item));
            }
            if (Array.isArray(_data["ruleParameters"])) {
                this.ruleParameters = [] as any;
                for (let item of _data["ruleParameters"])
                    this.ruleParameters!.push(CustomerRuleParametersDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerRuleDetailsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRuleDetailsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["customerId"] = this.customerId;
        data["ruleDefinitionId"] = this.ruleDefinitionId;
        data["customerTitle"] = this.customerTitle;
        data["ruleDefinitionIsActive"] = this.ruleDefinitionIsActive;
        data["ruleTypeName"] = this.ruleTypeName;
        data["ruleDefinitionDescription"] = this.ruleDefinitionDescription;
        data["ruleDefinitionPriority"] = this.ruleDefinitionPriority;
        if (Array.isArray(this.ruleConditions)) {
            data["ruleConditions"] = [];
            for (let item of this.ruleConditions)
                data["ruleConditions"].push(item.toJSON());
        }
        if (Array.isArray(this.ruleParameters)) {
            data["ruleParameters"] = [];
            for (let item of this.ruleParameters)
                data["ruleParameters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomerRuleDetailsDTO {
    id?: number;
    isActive?: boolean;
    customerId?: string | undefined;
    ruleDefinitionId?: number;
    customerTitle?: string | undefined;
    ruleDefinitionIsActive?: boolean;
    ruleTypeName?: string | undefined;
    ruleDefinitionDescription?: string | undefined;
    ruleDefinitionPriority?: number;
    ruleConditions?: CustomerRuleConditionsDTO[] | undefined;
    ruleParameters?: CustomerRuleParametersDTO[] | undefined;
}

export class AddCustomerRuleReq implements IAddCustomerRuleReq {
    customerRule?: CustomerRuleDetailsDTO;

    constructor(data?: IAddCustomerRuleReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerRule = _data["customerRule"] ? CustomerRuleDetailsDTO.fromJS(_data["customerRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerRuleReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerRuleReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerRule"] = this.customerRule ? this.customerRule.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerRuleReq {
    customerRule?: CustomerRuleDetailsDTO;
}

export class AddCustomerRuleRes implements IAddCustomerRuleRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerRule?: CustomerRuleDetailsDTO;

    constructor(data?: IAddCustomerRuleRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerRule = _data["customerRule"] ? CustomerRuleDetailsDTO.fromJS(_data["customerRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddCustomerRuleRes {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerRuleRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerRule"] = this.customerRule ? this.customerRule.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAddCustomerRuleRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerRule?: CustomerRuleDetailsDTO;
}

export class UpdateCustomerRuleReq implements IUpdateCustomerRuleReq {
    customerRule?: CustomerRuleDetailsDTO;

    constructor(data?: IUpdateCustomerRuleReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerRule = _data["customerRule"] ? CustomerRuleDetailsDTO.fromJS(_data["customerRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerRuleReq {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerRuleReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerRule"] = this.customerRule ? this.customerRule.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerRuleReq {
    customerRule?: CustomerRuleDetailsDTO;
}

export class UpdateCustomerRuleRes implements IUpdateCustomerRuleRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    readonly statusDescription?: string | undefined;
    readonly isAdded?: boolean;
    readonly isDeleted?: boolean;
    readonly isUpdated?: boolean;
    readonly isQueryed?: boolean;
    customerRule?: CustomerRuleDetailsDTO;

    constructor(data?: IUpdateCustomerRuleRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.resultMessage = _data["resultMessage"];
            this.traceId = _data["traceId"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).isAdded = _data["isAdded"];
            (<any>this).isDeleted = _data["isDeleted"];
            (<any>this).isUpdated = _data["isUpdated"];
            (<any>this).isQueryed = _data["isQueryed"];
            this.customerRule = _data["customerRule"] ? CustomerRuleDetailsDTO.fromJS(_data["customerRule"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateCustomerRuleRes {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerRuleRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["resultMessage"] = this.resultMessage;
        data["traceId"] = this.traceId;
        data["statusDescription"] = this.statusDescription;
        data["isAdded"] = this.isAdded;
        data["isDeleted"] = this.isDeleted;
        data["isUpdated"] = this.isUpdated;
        data["isQueryed"] = this.isQueryed;
        data["customerRule"] = this.customerRule ? this.customerRule.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUpdateCustomerRuleRes {
    isSuccess?: boolean;
    resultMessage?: string | undefined;
    traceId?: string | undefined;
    statusDescription?: string | undefined;
    isAdded?: boolean;
    isDeleted?: boolean;
    isUpdated?: boolean;
    isQueryed?: boolean;
    customerRule?: CustomerRuleDetailsDTO;
}

export enum EnvelopeStatus {
    Initial = "Initial",
    Extracting = "Extracting",
    ExtractErrorAndWillTryAgain = "ExtractErrorAndWillTryAgain",
    Extracted = "Extracted",
    ExtractError = "ExtractError",
    Processed = "Processed",
    ProcessError = "ProcessError",
    GibTest = "GibTest",
}

export class GetEnvelopesUUIDByProcessStatusReq implements IGetEnvelopesUUIDByProcessStatusReq {
    processStatus?: EnvelopeStatus;

    constructor(data?: IGetEnvelopesUUIDByProcessStatusReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processStatus = _data["processStatus"];
        }
    }

    static fromJS(data: any): GetEnvelopesUUIDByProcessStatusReq {
        data = typeof data === 'object' ? data : {};
        let result = new GetEnvelopesUUIDByProcessStatusReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processStatus"] = this.processStatus;
        return data; 
    }
}

export interface IGetEnvelopesUUIDByProcessStatusReq {
    processStatus?: EnvelopeStatus;
}

export class EnvelopeUUIDS implements IEnvelopeUUIDS {
    envelopeUUID?: string | undefined;

    constructor(data?: IEnvelopeUUIDS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.envelopeUUID = _data["envelopeUUID"];
        }
    }

    static fromJS(data: any): EnvelopeUUIDS {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopeUUIDS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["envelopeUUID"] = this.envelopeUUID;
        return data; 
    }
}

export interface IEnvelopeUUIDS {
    envelopeUUID?: string | undefined;
}

export class GetEnvelopesUUIDByProcessStatusRes implements IGetEnvelopesUUIDByProcessStatusRes {
    envelopesUUID?: EnvelopeUUIDS[] | undefined;

    constructor(data?: IGetEnvelopesUUIDByProcessStatusRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["envelopesUUID"])) {
                this.envelopesUUID = [] as any;
                for (let item of _data["envelopesUUID"])
                    this.envelopesUUID!.push(EnvelopeUUIDS.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEnvelopesUUIDByProcessStatusRes {
        data = typeof data === 'object' ? data : {};
        let result = new GetEnvelopesUUIDByProcessStatusRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.envelopesUUID)) {
            data["envelopesUUID"] = [];
            for (let item of this.envelopesUUID)
                data["envelopesUUID"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetEnvelopesUUIDByProcessStatusRes {
    envelopesUUID?: EnvelopeUUIDS[] | undefined;
}

export class TriggerEnvelopesStatusReq implements ITriggerEnvelopesStatusReq {
    envelopesUUID?: EnvelopeUUIDS[] | undefined;

    constructor(data?: ITriggerEnvelopesStatusReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["envelopesUUID"])) {
                this.envelopesUUID = [] as any;
                for (let item of _data["envelopesUUID"])
                    this.envelopesUUID!.push(EnvelopeUUIDS.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TriggerEnvelopesStatusReq {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerEnvelopesStatusReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.envelopesUUID)) {
            data["envelopesUUID"] = [];
            for (let item of this.envelopesUUID)
                data["envelopesUUID"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITriggerEnvelopesStatusReq {
    envelopesUUID?: EnvelopeUUIDS[] | undefined;
}

export class EnvelopesInfo implements IEnvelopesInfo {
    envelopeUUID?: string | undefined;
    systemResponseUUID?: string | undefined;
    envelopeGibStatus?: string | undefined;

    constructor(data?: IEnvelopesInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.envelopeUUID = _data["envelopeUUID"];
            this.systemResponseUUID = _data["systemResponseUUID"];
            this.envelopeGibStatus = _data["envelopeGibStatus"];
        }
    }

    static fromJS(data: any): EnvelopesInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopesInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["envelopeUUID"] = this.envelopeUUID;
        data["systemResponseUUID"] = this.systemResponseUUID;
        data["envelopeGibStatus"] = this.envelopeGibStatus;
        return data; 
    }
}

export interface IEnvelopesInfo {
    envelopeUUID?: string | undefined;
    systemResponseUUID?: string | undefined;
    envelopeGibStatus?: string | undefined;
}

export class GetDocumentDefaultEnvelopesUUIDRes implements IGetDocumentDefaultEnvelopesUUIDRes {
    envelopesUUID?: EnvelopesInfo[] | undefined;

    constructor(data?: IGetDocumentDefaultEnvelopesUUIDRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["envelopesUUID"])) {
                this.envelopesUUID = [] as any;
                for (let item of _data["envelopesUUID"])
                    this.envelopesUUID!.push(EnvelopesInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDocumentDefaultEnvelopesUUIDRes {
        data = typeof data === 'object' ? data : {};
        let result = new GetDocumentDefaultEnvelopesUUIDRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.envelopesUUID)) {
            data["envelopesUUID"] = [];
            for (let item of this.envelopesUUID)
                data["envelopesUUID"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetDocumentDefaultEnvelopesUUIDRes {
    envelopesUUID?: EnvelopesInfo[] | undefined;
}

export class InvoiceInfo implements IInvoiceInfo {
    invoiceUUID?: string | undefined;

    constructor(data?: IInvoiceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceUUID = _data["invoiceUUID"];
        }
    }

    static fromJS(data: any): InvoiceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceUUID"] = this.invoiceUUID;
        return data; 
    }
}

export interface IInvoiceInfo {
    invoiceUUID?: string | undefined;
}

export class GetErrorSignValidateInvoiceUUIDRes implements IGetErrorSignValidateInvoiceUUIDRes {
    invoicesUUID?: InvoiceInfo[] | undefined;

    constructor(data?: IGetErrorSignValidateInvoiceUUIDRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoicesUUID"])) {
                this.invoicesUUID = [] as any;
                for (let item of _data["invoicesUUID"])
                    this.invoicesUUID!.push(InvoiceInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetErrorSignValidateInvoiceUUIDRes {
        data = typeof data === 'object' ? data : {};
        let result = new GetErrorSignValidateInvoiceUUIDRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoicesUUID)) {
            data["invoicesUUID"] = [];
            for (let item of this.invoicesUUID)
                data["invoicesUUID"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGetErrorSignValidateInvoiceUUIDRes {
    invoicesUUID?: InvoiceInfo[] | undefined;
}

export class InvoiceUUIDS implements IInvoiceUUIDS {
    invoiceUUID?: string | undefined;

    constructor(data?: IInvoiceUUIDS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceUUID = _data["invoiceUUID"];
        }
    }

    static fromJS(data: any): InvoiceUUIDS {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceUUIDS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceUUID"] = this.invoiceUUID;
        return data; 
    }
}

export interface IInvoiceUUIDS {
    invoiceUUID?: string | undefined;
}

export class AddQueueSignEArchiveReq implements IAddQueueSignEArchiveReq {
    invoiceUUID?: InvoiceUUIDS[] | undefined;

    constructor(data?: IAddQueueSignEArchiveReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoiceUUID"])) {
                this.invoiceUUID = [] as any;
                for (let item of _data["invoiceUUID"])
                    this.invoiceUUID!.push(InvoiceUUIDS.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddQueueSignEArchiveReq {
        data = typeof data === 'object' ? data : {};
        let result = new AddQueueSignEArchiveReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoiceUUID)) {
            data["invoiceUUID"] = [];
            for (let item of this.invoiceUUID)
                data["invoiceUUID"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAddQueueSignEArchiveReq {
    invoiceUUID?: InvoiceUUIDS[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}